import * as Types from '../../../model/Sitecore.graphql.d';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type PressReleaseSearchQuery_search_ItemSearchResults_pageInfo_PageInfo = (
  { __typename?: 'PageInfo' }
  & Pick<Types.PageInfo, 'endCursor' | 'hasNext'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Accordion = (
  { __typename?: 'Accordion' }
  & Pick<Types.Accordion, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AccordionFolder = (
  { __typename?: 'AccordionFolder' }
  & Pick<Types.AccordionFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AccordionFolder_03f88fb497884025b46f2cb249f4fcd6 = (
  { __typename?: 'AccordionFolder_03f88fb497884025b46f2cb249f4fcd6' }
  & Pick<Types.AccordionFolder_03f88fb497884025b46f2cb249f4fcd6, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AccordionItem = (
  { __typename?: 'AccordionItem' }
  & Pick<Types.AccordionItem, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AccordionItem_8cf671721b2d489e809f4c23db5ab2da = (
  { __typename?: 'AccordionItem_8cf671721b2d489e809f4c23db5ab2da' }
  & Pick<Types.AccordionItem_8cf671721b2d489e809f4c23db5ab2da, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AccordionParametersTemplate = (
  { __typename?: 'AccordionParametersTemplate' }
  & Pick<Types.AccordionParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AccordionPresentation = (
  { __typename?: 'AccordionPresentation' }
  & Pick<Types.AccordionPresentation, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AccordionPresentationFolder = (
  { __typename?: 'AccordionPresentationFolder' }
  & Pick<Types.AccordionPresentationFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Accordion_02d060598cc14423a9ac9ff2365176b7 = (
  { __typename?: 'Accordion_02d060598cc14423a9ac9ff2365176b7' }
  & Pick<Types.Accordion_02d060598cc14423a9ac9ff2365176b7, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1 = (
  { __typename?: 'Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1' }
  & Pick<Types.Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AddItem = (
  { __typename?: 'AddItem' }
  & Pick<Types.AddItem, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AddItem_1e1b739ec3784909941d171aca7362e5 = (
  { __typename?: 'AddItem_1e1b739ec3784909941d171aca7362e5' }
  & Pick<Types.AddItem_1e1b739ec3784909941d171aca7362e5, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AddItem_3aea335cd06d45b1841acbc8d2d1ce40 = (
  { __typename?: 'AddItem_3aea335cd06d45b1841acbc8d2d1ce40' }
  & Pick<Types.AddItem_3aea335cd06d45b1841acbc8d2d1ce40, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AddItem_de8c75222f3241288f20342f479894eb = (
  { __typename?: 'AddItem_de8c75222f3241288f20342f479894eb' }
  & Pick<Types.AddItem_De8c75222f3241288f20342f479894eb, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AddItem_ea8a3f269ccd443a95f571b868a94bd0 = (
  { __typename?: 'AddItem_ea8a3f269ccd443a95f571b868a94bd0' }
  & Pick<Types.AddItem_Ea8a3f269ccd443a95f571b868a94bd0, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AddThisParameters = (
  { __typename?: 'AddThisParameters' }
  & Pick<Types.AddThisParameters, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AggregatedFacetFilter = (
  { __typename?: 'AggregatedFacetFilter' }
  & Pick<Types.AggregatedFacetFilter, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AlertMessage = (
  { __typename?: 'AlertMessage' }
  & Pick<Types.AlertMessage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AlertMessageFolder = (
  { __typename?: 'AlertMessageFolder' }
  & Pick<Types.AlertMessageFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AlertMessageParametersTemplate = (
  { __typename?: 'AlertMessageParametersTemplate' }
  & Pick<Types.AlertMessageParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AlertMessageType = (
  { __typename?: 'AlertMessageType' }
  & Pick<Types.AlertMessageType, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AllertMessageTypeFolder = (
  { __typename?: 'AllertMessageTypeFolder' }
  & Pick<Types.AllertMessageTypeFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Archive = (
  { __typename?: 'Archive' }
  & Pick<Types.Archive, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleAuthor = (
  { __typename?: 'ArticleAuthor' }
  & Pick<Types.ArticleAuthor, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleAuthorsFolder = (
  { __typename?: 'ArticleAuthorsFolder' }
  & Pick<Types.ArticleAuthorsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleCategoriesFolder = (
  { __typename?: 'ArticleCategoriesFolder' }
  & Pick<Types.ArticleCategoriesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleCategory = (
  { __typename?: 'ArticleCategory' }
  & Pick<Types.ArticleCategory, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleChapter = (
  { __typename?: 'ArticleChapter' }
  & Pick<Types.ArticleChapter, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleChapters = (
  { __typename?: 'ArticleChapters' }
  & Pick<Types.ArticleChapters, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleContentType = (
  { __typename?: 'ArticleContentType' }
  & Pick<Types.ArticleContentType, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleContentTypesFolder = (
  { __typename?: 'ArticleContentTypesFolder' }
  & Pick<Types.ArticleContentTypesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleFilter = (
  { __typename?: 'ArticleFilter' }
  & Pick<Types.ArticleFilter, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleFilterOption = (
  { __typename?: 'ArticleFilterOption' }
  & Pick<Types.ArticleFilterOption, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleFootnote = (
  { __typename?: 'ArticleFootnote' }
  & Pick<Types.ArticleFootnote, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleFootnoteLink = (
  { __typename?: 'ArticleFootnoteLink' }
  & Pick<Types.ArticleFootnoteLink, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleFootnoteText = (
  { __typename?: 'ArticleFootnoteText' }
  & Pick<Types.ArticleFootnoteText, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleInfogramTile = (
  { __typename?: 'ArticleInfogramTile' }
  & Pick<Types.ArticleInfogramTile, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleInfogramTileParametersTemplate = (
  { __typename?: 'ArticleInfogramTileParametersTemplate' }
  & Pick<Types.ArticleInfogramTileParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticlePage = (
  { __typename?: 'ArticlePage' }
  & Pick<Types.ArticlePage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleRegion = (
  { __typename?: 'ArticleRegion' }
  & Pick<Types.ArticleRegion, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleRegionsFolder = (
  { __typename?: 'ArticleRegionsFolder' }
  & Pick<Types.ArticleRegionsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleSearchPage = (
  { __typename?: 'ArticleSearchPage' }
  & Pick<Types.ArticleSearchPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c = (
  { __typename?: 'ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c' }
  & Pick<Types.ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2 = (
  { __typename?: 'ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2' }
  & Pick<Types.ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_be414ff574ac4203abb2694811443e25 = (
  { __typename?: 'ArticleSearchPage_be414ff574ac4203abb2694811443e25' }
  & Pick<Types.ArticleSearchPage_Be414ff574ac4203abb2694811443e25, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c = (
  { __typename?: 'ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c' }
  & Pick<Types.ArticleSearchPage_C7ad44ac3cab45158b619465a552a82c, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907 = (
  { __typename?: 'ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907' }
  & Pick<Types.ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleSeriesCollection = (
  { __typename?: 'ArticleSeriesCollection' }
  & Pick<Types.ArticleSeriesCollection, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleSeriesFolder = (
  { __typename?: 'ArticleSeriesFolder' }
  & Pick<Types.ArticleSeriesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleSettings = (
  { __typename?: 'ArticleSettings' }
  & Pick<Types.ArticleSettings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleSubscriptionBanner = (
  { __typename?: 'ArticleSubscriptionBanner' }
  & Pick<Types.ArticleSubscriptionBanner, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleSubscriptionBannerFolder = (
  { __typename?: 'ArticleSubscriptionBannerFolder' }
  & Pick<Types.ArticleSubscriptionBannerFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleTag = (
  { __typename?: 'ArticleTag' }
  & Pick<Types.ArticleTag, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleTagsFolder = (
  { __typename?: 'ArticleTagsFolder' }
  & Pick<Types.ArticleTagsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleTeamAuthor = (
  { __typename?: 'ArticleTeamAuthor' }
  & Pick<Types.ArticleTeamAuthor, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleTileParametersTemplate = (
  { __typename?: 'ArticleTileParametersTemplate' }
  & Pick<Types.ArticleTileParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleTilesParametersTemplate = (
  { __typename?: 'ArticleTilesParametersTemplate' }
  & Pick<Types.ArticleTilesParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f = (
  { __typename?: 'ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f' }
  & Pick<Types.ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8 = (
  { __typename?: 'ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8' }
  & Pick<Types.ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca = (
  { __typename?: 'ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca' }
  & Pick<Types.ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c = (
  { __typename?: 'ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c' }
  & Pick<Types.ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_405b20252077400383d3b47f09f88b47 = (
  { __typename?: 'ArticleWildcardPage_405b20252077400383d3b47f09f88b47' }
  & Pick<Types.ArticleWildcardPage_405b20252077400383d3b47f09f88b47, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b = (
  { __typename?: 'ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b' }
  & Pick<Types.ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985b, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ArticlesGroupFolder = (
  { __typename?: 'ArticlesGroupFolder' }
  & Pick<Types.ArticlesGroupFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AttachThemeExtension = (
  { __typename?: 'AttachThemeExtension' }
  & Pick<Types.AttachThemeExtension, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AutomaticDocumentListings = (
  { __typename?: 'AutomaticDocumentListings' }
  & Pick<Types.AutomaticDocumentListings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AutomaticDocumentListingsFolder = (
  { __typename?: 'AutomaticDocumentListingsFolder' }
  & Pick<Types.AutomaticDocumentListingsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AvailableJSONRenderings = (
  { __typename?: 'AvailableJSONRenderings' }
  & Pick<Types.AvailableJsonRenderings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AvailableMetaRenderings = (
  { __typename?: 'AvailableMetaRenderings' }
  & Pick<Types.AvailableMetaRenderings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AvailableRenderings = (
  { __typename?: 'AvailableRenderings' }
  & Pick<Types.AvailableRenderings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb = (
  { __typename?: 'AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb' }
  & Pick<Types.AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AwardsBanner = (
  { __typename?: 'AwardsBanner' }
  & Pick<Types.AwardsBanner, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AwardsBannerFolder = (
  { __typename?: 'AwardsBannerFolder' }
  & Pick<Types.AwardsBannerFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AwardsBannerImage = (
  { __typename?: 'AwardsBannerImage' }
  & Pick<Types.AwardsBannerImage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_AwardsBannerParametersTemplate = (
  { __typename?: 'AwardsBannerParametersTemplate' }
  & Pick<Types.AwardsBannerParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_BYOCWrapperRenderingParameters = (
  { __typename?: 'BYOCWrapperRenderingParameters' }
  & Pick<Types.ByocWrapperRenderingParameters, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_BackgroundColorOption = (
  { __typename?: 'BackgroundColorOption' }
  & Pick<Types.BackgroundColorOption, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_BackgroundColorOptionFolder = (
  { __typename?: 'BackgroundColorOptionFolder' }
  & Pick<Types.BackgroundColorOptionFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_BannerFolder = (
  { __typename?: 'BannerFolder' }
  & Pick<Types.BannerFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_BannerType = (
  { __typename?: 'BannerType' }
  & Pick<Types.BannerType, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_BannerTypeFolder = (
  { __typename?: 'BannerTypeFolder' }
  & Pick<Types.BannerTypeFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_BaseHeading = (
  { __typename?: 'BaseHeading' }
  & Pick<Types.BaseHeading, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_BaseHeadingFolder = (
  { __typename?: 'BaseHeadingFolder' }
  & Pick<Types.BaseHeadingFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_BoolFacet = (
  { __typename?: 'BoolFacet' }
  & Pick<Types.BoolFacet, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_BranchesFolder = (
  { __typename?: 'BranchesFolder' }
  & Pick<Types.BranchesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Breadcrumb = (
  { __typename?: 'Breadcrumb' }
  & Pick<Types.Breadcrumb, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_BrowserTitleDefinition = (
  { __typename?: 'BrowserTitleDefinition' }
  & Pick<Types.BrowserTitleDefinition, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CORSEntry = (
  { __typename?: 'CORSEntry' }
  & Pick<Types.CorsEntry, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CORSGrouping = (
  { __typename?: 'CORSGrouping' }
  & Pick<Types.CorsGrouping, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CTAPresentationType = (
  { __typename?: 'CTAPresentationType' }
  & Pick<Types.CtaPresentationType, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CTAPresentationTypeFolder = (
  { __typename?: 'CTAPresentationTypeFolder' }
  & Pick<Types.CtaPresentationTypeFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__AbrdnPage = (
  { __typename?: 'C__AbrdnPage' }
  & Pick<Types.C__AbrdnPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__ActionBase = (
  { __typename?: 'C__ActionBase' }
  & Pick<Types.C__ActionBase, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__AdvancedParameter = (
  { __typename?: 'C__AdvancedParameter' }
  & Pick<Types.C__AdvancedParameter, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__App = (
  { __typename?: 'C__App' }
  & Pick<Types.C__App, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c = (
  { __typename?: 'C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c' }
  & Pick<Types.C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__ArticleWildcardPage = (
  { __typename?: 'C__ArticleWildcardPage' }
  & Pick<Types.C__ArticleWildcardPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__AvailableRenderingsFolder = (
  { __typename?: 'C__AvailableRenderingsFolder' }
  & Pick<Types.C__AvailableRenderingsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__BYOCRenderingParameters = (
  { __typename?: 'C__BYOCRenderingParameters' }
  & Pick<Types.C__ByocRenderingParameters, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__BackgroundParametersTemplate = (
  { __typename?: 'C__BackgroundParametersTemplate' }
  & Pick<Types.C__BackgroundParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__BaseCTA = (
  { __typename?: 'C__BaseCTA' }
  & Pick<Types.C__BaseCta, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__BasePage = (
  { __typename?: 'C__BasePage' }
  & Pick<Types.C__BasePage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__BasePage_037da552a5524fe4aeee331f57ac1378 = (
  { __typename?: 'C__BasePage_037da552a5524fe4aeee331f57ac1378' }
  & Pick<Types.C__BasePage_037da552a5524fe4aeee331f57ac1378, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f = (
  { __typename?: 'C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f' }
  & Pick<Types.C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__BasePage_315fd21bebf04c9d9f00bae191442f1d = (
  { __typename?: 'C__BasePage_315fd21bebf04c9d9f00bae191442f1d' }
  & Pick<Types.C__BasePage_315fd21bebf04c9d9f00bae191442f1d, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd = (
  { __typename?: 'C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd' }
  & Pick<Types.C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__BasePage_728c97b5c56146d9807e21018a972bb5 = (
  { __typename?: 'C__BasePage_728c97b5c56146d9807e21018a972bb5' }
  & Pick<Types.C__BasePage_728c97b5c56146d9807e21018a972bb5, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__BasePage_6105875085f346729dfc8d133b481f26 = (
  { __typename?: 'C__BasePage_6105875085f346729dfc8d133b481f26' }
  & Pick<Types.C__BasePage_6105875085f346729dfc8d133b481f26, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b = (
  { __typename?: 'C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b' }
  & Pick<Types.C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387b, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__BaseRenderingParameters = (
  { __typename?: 'C__BaseRenderingParameters' }
  & Pick<Types.C__BaseRenderingParameters, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__BaseTheme = (
  { __typename?: 'C__BaseTheme' }
  & Pick<Types.C__BaseTheme, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__BaseVariantField = (
  { __typename?: 'C__BaseVariantField' }
  & Pick<Types.C__BaseVariantField, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__Class = (
  { __typename?: 'C__Class' }
  & Pick<Types.C__Class, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__CompositeGroup = (
  { __typename?: 'C__CompositeGroup' }
  & Pick<Types.C__CompositeGroup, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__CompositeSection = (
  { __typename?: 'C__CompositeSection' }
  & Pick<Types.C__CompositeSection, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__EloquaForm = (
  { __typename?: 'C__EloquaForm' }
  & Pick<Types.C__EloquaForm, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d = (
  { __typename?: 'C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d' }
  & Pick<Types.C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557d, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__ExtendedOptions = (
  { __typename?: 'C__ExtendedOptions' }
  & Pick<Types.C__ExtendedOptions, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__ExtendedOptions_2964fb4257a6440fb192218443904c90 = (
  { __typename?: 'C__ExtendedOptions_2964fb4257a6440fb192218443904c90' }
  & Pick<Types.C__ExtendedOptions_2964fb4257a6440fb192218443904c90, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160 = (
  { __typename?: 'C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160' }
  & Pick<Types.C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__FEaaSRenderingParameters = (
  { __typename?: 'C__FEaaSRenderingParameters' }
  & Pick<Types.C__FEaaSRenderingParameters, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__FacetSelectorConfigBase = (
  { __typename?: 'C__FacetSelectorConfigBase' }
  & Pick<Types.C__FacetSelectorConfigBase, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845 = (
  { __typename?: 'C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845' }
  & Pick<Types.C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b = (
  { __typename?: 'C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b' }
  & Pick<Types.C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303 = (
  { __typename?: 'C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303' }
  & Pick<Types.C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5 = (
  { __typename?: 'C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5' }
  & Pick<Types.C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc = (
  { __typename?: 'C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc' }
  & Pick<Types.C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fc, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__GlobalDatasourceBehavior = (
  { __typename?: 'C__GlobalDatasourceBehavior' }
  & Pick<Types.C__GlobalDatasourceBehavior, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__GridDefinition = (
  { __typename?: 'C__GridDefinition' }
  & Pick<Types.C__GridDefinition, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__GridItemBase = (
  { __typename?: 'C__GridItemBase' }
  & Pick<Types.C__GridItemBase, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__GridParameters = (
  { __typename?: 'C__GridParameters' }
  & Pick<Types.C__GridParameters, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__HeadlessSite = (
  { __typename?: 'C__HeadlessSite' }
  & Pick<Types.C__HeadlessSite, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__HeadlessTenant = (
  { __typename?: 'C__HeadlessTenant' }
  & Pick<Types.C__HeadlessTenant, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b = (
  { __typename?: 'C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b' }
  & Pick<Types.C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28b, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d = (
  { __typename?: 'C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d' }
  & Pick<Types.C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65d, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d = (
  { __typename?: 'C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d' }
  & Pick<Types.C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__IAllowEmpty = (
  { __typename?: 'C__IAllowEmpty' }
  & Pick<Types.C__IAllowEmpty, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__IBaseVariantDefinition = (
  { __typename?: 'C__IBaseVariantDefinition' }
  & Pick<Types.C__IBaseVariantDefinition, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__IBoosting = (
  { __typename?: 'C__IBoosting' }
  & Pick<Types.C__IBoosting, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__ICacheable = (
  { __typename?: 'C__ICacheable' }
  & Pick<Types.C__ICacheable, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__ICompatibleRenderings = (
  { __typename?: 'C__ICompatibleRenderings' }
  & Pick<Types.C__ICompatibleRenderings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__IComponentVariant = (
  { __typename?: 'C__IComponentVariant' }
  & Pick<Types.C__IComponentVariant, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__IControlType = (
  { __typename?: 'C__IControlType' }
  & Pick<Types.C__IControlType, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__IDynamicPlaceholder = (
  { __typename?: 'C__IDynamicPlaceholder' }
  & Pick<Types.C__IDynamicPlaceholder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__IFEaaSComponentsDataSourceTemplates = (
  { __typename?: 'C__IFEaaSComponentsDataSourceTemplates' }
  & Pick<Types.C__IfEaaSComponentsDataSourceTemplates, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__IFEaaSComponentsEditorScriptURL = (
  { __typename?: 'C__IFEaaSComponentsEditorScriptURL' }
  & Pick<Types.C__IfEaaSComponentsEditorScriptUrl, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__IIcon = (
  { __typename?: 'C__IIcon' }
  & Pick<Types.C__IIcon, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__ILocation = (
  { __typename?: 'C__ILocation' }
  & Pick<Types.C__ILocation, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__IPaginable = (
  { __typename?: 'C__IPaginable' }
  & Pick<Types.C__IPaginable, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__IPagination = (
  { __typename?: 'C__IPagination' }
  & Pick<Types.C__IPagination, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__IPoi = (
  { __typename?: 'C__IPoi' }
  & Pick<Types.C__IPoi, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__IRenderingId = (
  { __typename?: 'C__IRenderingId' }
  & Pick<Types.C__IRenderingId, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__ISplitter = (
  { __typename?: 'C__ISplitter' }
  & Pick<Types.C__ISplitter, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__IStyling = (
  { __typename?: 'C__IStyling' }
  & Pick<Types.C__IStyling, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__IVariantDefinition = (
  { __typename?: 'C__IVariantDefinition' }
  & Pick<Types.C__IVariantDefinition, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage = (
  { __typename?: 'C__InvestmentTrustPage' }
  & Pick<Types.C__InvestmentTrustPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__JSONField = (
  { __typename?: 'C__JSONField' }
  & Pick<Types.C__JsonField, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__JSONReference = (
  { __typename?: 'C__JSONReference' }
  & Pick<Types.C__JsonReference, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__JSSData = (
  { __typename?: 'C__JSSData' }
  & Pick<Types.C__JssData, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__JSSSettings = (
  { __typename?: 'C__JSSSettings' }
  & Pick<Types.C__JssSettings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__JSSSiteFolder = (
  { __typename?: 'C__JSSSiteFolder' }
  & Pick<Types.C__JssSiteFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__JssRootFolder = (
  { __typename?: 'C__JssRootFolder' }
  & Pick<Types.C__JssRootFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086 = (
  { __typename?: 'C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086' }
  & Pick<Types.C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__Navigation_e6d98f24d01c419e871a4617125a49ed = (
  { __typename?: 'C__Navigation_e6d98f24d01c419e871a4617125a49ed' }
  & Pick<Types.C__Navigation_E6d98f24d01c419e871a4617125a49ed, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__Page = (
  { __typename?: 'C__Page' }
  & Pick<Types.C__Page, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__PageData = (
  { __typename?: 'C__PageData' }
  & Pick<Types.C__PageData, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__PageDesignFolder = (
  { __typename?: 'C__PageDesignFolder' }
  & Pick<Types.C__PageDesignFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd = (
  { __typename?: 'C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd' }
  & Pick<Types.C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__PageDesigns_daaf41fd96db4892be99f62f16d036c4 = (
  { __typename?: 'C__PageDesigns_daaf41fd96db4892be99f62f16d036c4' }
  & Pick<Types.C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__PartialDesign = (
  { __typename?: 'C__PartialDesign' }
  & Pick<Types.C__PartialDesign, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__PartialDesignFolder = (
  { __typename?: 'C__PartialDesignFolder' }
  & Pick<Types.C__PartialDesignFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d = (
  { __typename?: 'C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d' }
  & Pick<Types.C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d = (
  { __typename?: 'C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d' }
  & Pick<Types.C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__PlaceholderWrapper = (
  { __typename?: 'C__PlaceholderWrapper' }
  & Pick<Types.C__PlaceholderWrapper, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac = (
  { __typename?: 'C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac' }
  & Pick<Types.C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b = (
  { __typename?: 'C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b' }
  & Pick<Types.C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__RedirectMapGrouping = (
  { __typename?: 'C__RedirectMapGrouping' }
  & Pick<Types.C__RedirectMapGrouping, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973 = (
  { __typename?: 'C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973' }
  & Pick<Types.C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__Route = (
  { __typename?: 'C__Route' }
  & Pick<Types.C__Route, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__SimpleVideo = (
  { __typename?: 'C__SimpleVideo' }
  & Pick<Types.C__SimpleVideo, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__SiteSettingsFolder = (
  { __typename?: 'C__SiteSettingsFolder' }
  & Pick<Types.C__SiteSettingsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__SitemapSettings = (
  { __typename?: 'C__SitemapSettings' }
  & Pick<Types.C__SitemapSettings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__StandardTemplate = (
  { __typename?: 'C__StandardTemplate' }
  & Pick<Types.C__StandardTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c = (
  { __typename?: 'C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c' }
  & Pick<Types.C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65 = (
  { __typename?: 'C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65' }
  & Pick<Types.C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__TrustFolder = (
  { __typename?: 'C__TrustFolder' }
  & Pick<Types.C__TrustFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__VariantDefinition = (
  { __typename?: 'C__VariantDefinition' }
  & Pick<Types.C__VariantDefinition, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__VariantField = (
  { __typename?: 'C__VariantField' }
  & Pick<Types.C__VariantField, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C__VariantsGrouping = (
  { __typename?: 'C__VariantsGrouping' }
  & Pick<Types.C__VariantsGrouping, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___AdvancedItem = (
  { __typename?: 'C___AdvancedItem' }
  & Pick<Types.C___AdvancedItem, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Arguments = (
  { __typename?: 'C___Arguments' }
  & Pick<Types.C___Arguments, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Arguments_33fab87cd52f44319a1f589ba7c1e287 = (
  { __typename?: 'C___Arguments_33fab87cd52f44319a1f589ba7c1e287' }
  & Pick<Types.C___Arguments_33fab87cd52f44319a1f589ba7c1e287, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Article = (
  { __typename?: 'C___Article' }
  & Pick<Types.C___Article, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___ArticlePageWorkflow = (
  { __typename?: 'C___ArticlePageWorkflow' }
  & Pick<Types.C___ArticlePageWorkflow, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___ArticleSearchPage = (
  { __typename?: 'C___ArticleSearchPage' }
  & Pick<Types.C___ArticleSearchPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___ArticleWildcard = (
  { __typename?: 'C___ArticleWildcard' }
  & Pick<Types.C___ArticleWildcard, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___AssetServiceThemeMode = (
  { __typename?: 'C___AssetServiceThemeMode' }
  & Pick<Types.C___AssetServiceThemeMode, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseArticle = (
  { __typename?: 'C___BaseArticle' }
  & Pick<Types.C___BaseArticle, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseDataFolder = (
  { __typename?: 'C___BaseDataFolder' }
  & Pick<Types.C___BaseDataFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseHelpArticle = (
  { __typename?: 'C___BaseHelpArticle' }
  & Pick<Types.C___BaseHelpArticle, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseInvestmentTrust = (
  { __typename?: 'C___BaseInvestmentTrust' }
  & Pick<Types.C___BaseInvestmentTrust, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseJSSTenant = (
  { __typename?: 'C___BaseJSSTenant' }
  & Pick<Types.C___BaseJssTenant, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BasePage = (
  { __typename?: 'C___BasePage' }
  & Pick<Types.C___BasePage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BasePageDesign = (
  { __typename?: 'C___BasePageDesign' }
  & Pick<Types.C___BasePageDesign, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BasePageDesignFolder = (
  { __typename?: 'C___BasePageDesignFolder' }
  & Pick<Types.C___BasePageDesignFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BasePartialDesign = (
  { __typename?: 'C___BasePartialDesign' }
  & Pick<Types.C___BasePartialDesign, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BasePartialDesignFolder = (
  { __typename?: 'C___BasePartialDesignFolder' }
  & Pick<Types.C___BasePartialDesignFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BasePlaceholder = (
  { __typename?: 'C___BasePlaceholder' }
  & Pick<Types.C___BasePlaceholder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BasePlaceholderSettingsFolder = (
  { __typename?: 'C___BasePlaceholderSettingsFolder' }
  & Pick<Types.C___BasePlaceholderSettingsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BasePresentation = (
  { __typename?: 'C___BasePresentation' }
  & Pick<Types.C___BasePresentation, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BasePressRelease = (
  { __typename?: 'C___BasePressRelease' }
  & Pick<Types.C___BasePressRelease, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseRenderingParameters = (
  { __typename?: 'C___BaseRenderingParameters' }
  & Pick<Types.C___BaseRenderingParameters, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseSXAStandardValuesFolder = (
  { __typename?: 'C___BaseSXAStandardValuesFolder' }
  & Pick<Types.C___BaseSxaStandardValuesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseSettings = (
  { __typename?: 'C___BaseSettings' }
  & Pick<Types.C___BaseSettings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseSharedSitesSettings = (
  { __typename?: 'C___BaseSharedSitesSettings' }
  & Pick<Types.C___BaseSharedSitesSettings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseSiteDefinition = (
  { __typename?: 'C___BaseSiteDefinition' }
  & Pick<Types.C___BaseSiteDefinition, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseSiteFolder = (
  { __typename?: 'C___BaseSiteFolder' }
  & Pick<Types.C___BaseSiteFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseSiteGrouping = (
  { __typename?: 'C___BaseSiteGrouping' }
  & Pick<Types.C___BaseSiteGrouping, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseSiteRoot = (
  { __typename?: 'C___BaseSiteRoot' }
  & Pick<Types.C___BaseSiteRoot, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseTenant = (
  { __typename?: 'C___BaseTenant' }
  & Pick<Types.C___BaseTenant, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseTenantFolder = (
  { __typename?: 'C___BaseTenantFolder' }
  & Pick<Types.C___BaseTenantFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___BucketRules = (
  { __typename?: 'C___BucketRules' }
  & Pick<Types.C___BucketRules, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___CORS = (
  { __typename?: 'C___CORS' }
  & Pick<Types.C___Cors, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Content = (
  { __typename?: 'C___Content' }
  & Pick<Types.C___Content, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___ContentType = (
  { __typename?: 'C___ContentType' }
  & Pick<Types.C___ContentType, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___DataAttributes = (
  { __typename?: 'C___DataAttributes' }
  & Pick<Types.C___DataAttributes, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___DatasourceWorkflow = (
  { __typename?: 'C___DatasourceWorkflow' }
  & Pick<Types.C___DatasourceWorkflow, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Dependencies = (
  { __typename?: 'C___Dependencies' }
  & Pick<Types.C___Dependencies, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Description = (
  { __typename?: 'C___Description' }
  & Pick<Types.C___Description, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___DesignTemplateMapping = (
  { __typename?: 'C___DesignTemplateMapping' }
  & Pick<Types.C___DesignTemplateMapping, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Designable = (
  { __typename?: 'C___Designable' }
  & Pick<Types.C___Designable, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___EditType = (
  { __typename?: 'C___EditType' }
  & Pick<Types.C___EditType, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___EditType_8a9f84baaa124c5d9096935714809da4 = (
  { __typename?: 'C___EditType_8a9f84baaa124c5d9096935714809da4' }
  & Pick<Types.C___EditType_8a9f84baaa124c5d9096935714809da4, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___EditingTheme = (
  { __typename?: 'C___EditingTheme' }
  & Pick<Types.C___EditingTheme, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Enabled = (
  { __typename?: 'C___Enabled' }
  & Pick<Types.C___Enabled, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___ErrorHandling = (
  { __typename?: 'C___ErrorHandling' }
  & Pick<Types.C___ErrorHandling, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___ExternalArticle = (
  { __typename?: 'C___ExternalArticle' }
  & Pick<Types.C___ExternalArticle, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Fields = (
  { __typename?: 'C___Fields' }
  & Pick<Types.C___Fields, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___FilteredArticlesParent = (
  { __typename?: 'C___FilteredArticlesParent' }
  & Pick<Types.C___FilteredArticlesParent, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___FilteredArticlesWildcard = (
  { __typename?: 'C___FilteredArticlesWildcard' }
  & Pick<Types.C___FilteredArticlesWildcard, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Footnotes = (
  { __typename?: 'C___Footnotes' }
  & Pick<Types.C___Footnotes, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___FundDetailsWildcard = (
  { __typename?: 'C___FundDetailsWildcard' }
  & Pick<Types.C___FundDetailsWildcard, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___FundFormAvailability = (
  { __typename?: 'C___FundFormAvailability' }
  & Pick<Types.C___FundFormAvailability, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___FundMetadataPage = (
  { __typename?: 'C___FundMetadataPage' }
  & Pick<Types.C___FundMetadataPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___FundSearchPage = (
  { __typename?: 'C___FundSearchPage' }
  & Pick<Types.C___FundSearchPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___FundsFolder = (
  { __typename?: 'C___FundsFolder' }
  & Pick<Types.C___FundsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___FundsFormsFolder = (
  { __typename?: 'C___FundsFormsFolder' }
  & Pick<Types.C___FundsFormsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___FundsLiteratureFolder = (
  { __typename?: 'C___FundsLiteratureFolder' }
  & Pick<Types.C___FundsLiteratureFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___FundsShareclassesDetailsWildcard = (
  { __typename?: 'C___FundsShareclassesDetailsWildcard' }
  & Pick<Types.C___FundsShareclassesDetailsWildcard, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___GridMapping = (
  { __typename?: 'C___GridMapping' }
  & Pick<Types.C___GridMapping, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___HelpArticle = (
  { __typename?: 'C___HelpArticle' }
  & Pick<Types.C___HelpArticle, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___HelpArticleSearchPage = (
  { __typename?: 'C___HelpArticleSearchPage' }
  & Pick<Types.C___HelpArticleSearchPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___HelpArticleWildcard = (
  { __typename?: 'C___HelpArticleWildcard' }
  & Pick<Types.C___HelpArticleWildcard, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___HorizonDatasourceGrouping = (
  { __typename?: 'C___HorizonDatasourceGrouping' }
  & Pick<Types.C___HorizonDatasourceGrouping, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Icon = (
  { __typename?: 'C___Icon' }
  & Pick<Types.C___Icon, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___IncludeByDefault = (
  { __typename?: 'C___IncludeByDefault' }
  & Pick<Types.C___IncludeByDefault, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___IncludeIfInstalled = (
  { __typename?: 'C___IncludeIfInstalled' }
  & Pick<Types.C___IncludeIfInstalled, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___InternalArticle = (
  { __typename?: 'C___InternalArticle' }
  & Pick<Types.C___InternalArticle, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___InternetExplorerCompatibilityMode = (
  { __typename?: 'C___InternetExplorerCompatibilityMode' }
  & Pick<Types.C___InternetExplorerCompatibilityMode, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___IsSystemModule = (
  { __typename?: 'C___IsSystemModule' }
  & Pick<Types.C___IsSystemModule, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___JSONVariantPaging = (
  { __typename?: 'C___JSONVariantPaging' }
  & Pick<Types.C___JsonVariantPaging, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___JSONVariantsBase = (
  { __typename?: 'C___JSONVariantsBase' }
  & Pick<Types.C___JsonVariantsBase, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___LimitedDisplay = (
  { __typename?: 'C___LimitedDisplay' }
  & Pick<Types.C___LimitedDisplay, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___LinkAttributes = (
  { __typename?: 'C___LinkAttributes' }
  & Pick<Types.C___LinkAttributes, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___LinkSettings = (
  { __typename?: 'C___LinkSettings' }
  & Pick<Types.C___LinkSettings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___LiteratureHubSearchPage = (
  { __typename?: 'C___LiteratureHubSearchPage' }
  & Pick<Types.C___LiteratureHubSearchPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___ManualKeyInformation = (
  { __typename?: 'C___ManualKeyInformation' }
  & Pick<Types.C___ManualKeyInformation, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___MemberOf = (
  { __typename?: 'C___MemberOf' }
  & Pick<Types.C___MemberOf, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___MetadataPage = (
  { __typename?: 'C___MetadataPage' }
  & Pick<Types.C___MetadataPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Modules = (
  { __typename?: 'C___Modules' }
  & Pick<Types.C___Modules, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Name = (
  { __typename?: 'C___Name' }
  & Pick<Types.C___Name, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d = (
  { __typename?: 'C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d' }
  & Pick<Types.C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Name_299cdb154745448a807868d401248eaa = (
  { __typename?: 'C___Name_299cdb154745448a807868d401248eaa' }
  & Pick<Types.C___Name_299cdb154745448a807868d401248eaa, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Name_b88cf88159a54a19991e71038751cb60 = (
  { __typename?: 'C___Name_b88cf88159a54a19991e71038751cb60' }
  & Pick<Types.C___Name_B88cf88159a54a19991e71038751cb60, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Navigable = (
  { __typename?: 'C___Navigable' }
  & Pick<Types.C___Navigable, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___NavigablePage = (
  { __typename?: 'C___NavigablePage' }
  & Pick<Types.C___NavigablePage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___PageContent = (
  { __typename?: 'C___PageContent' }
  & Pick<Types.C___PageContent, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___PageWorkflow = (
  { __typename?: 'C___PageWorkflow' }
  & Pick<Types.C___PageWorkflow, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___PerSiteStandardValues = (
  { __typename?: 'C___PerSiteStandardValues' }
  & Pick<Types.C___PerSiteStandardValues, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Podcast = (
  { __typename?: 'C___Podcast' }
  & Pick<Types.C___Podcast, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___PodcastPressRelease = (
  { __typename?: 'C___PodcastPressRelease' }
  & Pick<Types.C___PodcastPressRelease, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___PremiumContentPage = (
  { __typename?: 'C___PremiumContentPage' }
  & Pick<Types.C___PremiumContentPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___PressRelease = (
  { __typename?: 'C___PressRelease' }
  & Pick<Types.C___PressRelease, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___PressReleaseContentType = (
  { __typename?: 'C___PressReleaseContentType' }
  & Pick<Types.C___PressReleaseContentType, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___PressReleaseSearchPage = (
  { __typename?: 'C___PressReleaseSearchPage' }
  & Pick<Types.C___PressReleaseSearchPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___PressReleaseWildcard = (
  { __typename?: 'C___PressReleaseWildcard' }
  & Pick<Types.C___PressReleaseWildcard, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___ProtectedTheme = (
  { __typename?: 'C___ProtectedTheme' }
  & Pick<Types.C___ProtectedTheme, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___PublishingGroupingTemplate = (
  { __typename?: 'C___PublishingGroupingTemplate' }
  & Pick<Types.C___PublishingGroupingTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___RenderingRelatedParameters = (
  { __typename?: 'C___RenderingRelatedParameters' }
  & Pick<Types.C___RenderingRelatedParameters, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___RenderingVariantsBase = (
  { __typename?: 'C___RenderingVariantsBase' }
  & Pick<Types.C___RenderingVariantsBase, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___RenderingsList = (
  { __typename?: 'C___RenderingsList' }
  & Pick<Types.C___RenderingsList, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___RobotsContent = (
  { __typename?: 'C___RobotsContent' }
  & Pick<Types.C___RobotsContent, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___RoleDomain = (
  { __typename?: 'C___RoleDomain' }
  & Pick<Types.C___RoleDomain, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___RoleName = (
  { __typename?: 'C___RoleName' }
  & Pick<Types.C___RoleName, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___RoleType = (
  { __typename?: 'C___RoleType' }
  & Pick<Types.C___RoleType, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SalesforceCommonValidations = (
  { __typename?: 'C___SalesforceCommonValidations' }
  & Pick<Types.C___SalesforceCommonValidations, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SalesforceFieldId = (
  { __typename?: 'C___SalesforceFieldId' }
  & Pick<Types.C___SalesforceFieldId, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SalesforceFieldTitle = (
  { __typename?: 'C___SalesforceFieldTitle' }
  & Pick<Types.C___SalesforceFieldTitle, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SalesforceFieldValue = (
  { __typename?: 'C___SalesforceFieldValue' }
  & Pick<Types.C___SalesforceFieldValue, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Script = (
  { __typename?: 'C___Script' }
  & Pick<Types.C___Script, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SearchSignature = (
  { __typename?: 'C___SearchSignature' }
  & Pick<Types.C___SearchSignature, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Searchable = (
  { __typename?: 'C___Searchable' }
  & Pick<Types.C___Searchable, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SecurityItemPointer = (
  { __typename?: 'C___SecurityItemPointer' }
  & Pick<Types.C___SecurityItemPointer, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SharedArticles = (
  { __typename?: 'C___SharedArticles' }
  & Pick<Types.C___SharedArticles, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SharedContent = (
  { __typename?: 'C___SharedContent' }
  & Pick<Types.C___SharedContent, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SharedHelpArticles = (
  { __typename?: 'C___SharedHelpArticles' }
  & Pick<Types.C___SharedHelpArticles, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SharedPage = (
  { __typename?: 'C___SharedPage' }
  & Pick<Types.C___SharedPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SharedPressReleases = (
  { __typename?: 'C___SharedPressReleases' }
  & Pick<Types.C___SharedPressReleases, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SharedRoot = (
  { __typename?: 'C___SharedRoot' }
  & Pick<Types.C___SharedRoot, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SharedSettings = (
  { __typename?: 'C___SharedSettings' }
  & Pick<Types.C___SharedSettings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SiteContent = (
  { __typename?: 'C___SiteContent' }
  & Pick<Types.C___SiteContent, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SiteFolder = (
  { __typename?: 'C___SiteFolder' }
  & Pick<Types.C___SiteFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SiteMediaLibrary = (
  { __typename?: 'C___SiteMediaLibrary' }
  & Pick<Types.C___SiteMediaLibrary, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SiteSettings = (
  { __typename?: 'C___SiteSettings' }
  & Pick<Types.C___SiteSettings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SiteTemplate = (
  { __typename?: 'C___SiteTemplate' }
  & Pick<Types.C___SiteTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SitecoreClientSiteManaging = (
  { __typename?: 'C___SitecoreClientSiteManaging' }
  & Pick<Types.C___SitecoreClientSiteManaging, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Sitemap = (
  { __typename?: 'C___Sitemap' }
  & Pick<Types.C___Sitemap, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SitemapMediaItems = (
  { __typename?: 'C___SitemapMediaItems' }
  & Pick<Types.C___SitemapMediaItems, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SlidersRangeSettings = (
  { __typename?: 'C___SlidersRangeSettings' }
  & Pick<Types.C___SlidersRangeSettings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SolutionTemplateContent = (
  { __typename?: 'C___SolutionTemplateContent' }
  & Pick<Types.C___SolutionTemplateContent, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SolutionTemplateDescription = (
  { __typename?: 'C___SolutionTemplateDescription' }
  & Pick<Types.C___SolutionTemplateDescription, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SolutionTemplateName = (
  { __typename?: 'C___SolutionTemplateName' }
  & Pick<Types.C___SolutionTemplateName, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SortOrder = (
  { __typename?: 'C___SortOrder' }
  & Pick<Types.C___SortOrder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___StackBreakpoint = (
  { __typename?: 'C___StackBreakpoint' }
  & Pick<Types.C___StackBreakpoint, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Statistics = (
  { __typename?: 'C___Statistics' }
  & Pick<Types.C___Statistics, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___SupportedLanguages = (
  { __typename?: 'C___SupportedLanguages' }
  & Pick<Types.C___SupportedLanguages, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Taggable = (
  { __typename?: 'C___Taggable' }
  & Pick<Types.C___Taggable, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___TeamMembersParentPage = (
  { __typename?: 'C___TeamMembersParentPage' }
  & Pick<Types.C___TeamMembersParentPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___TeamMembersWildcard = (
  { __typename?: 'C___TeamMembersWildcard' }
  & Pick<Types.C___TeamMembersWildcard, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___TechzoneArticle = (
  { __typename?: 'C___TechzoneArticle' }
  & Pick<Types.C___TechzoneArticle, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Template = (
  { __typename?: 'C___Template' }
  & Pick<Types.C___Template, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Title = (
  { __typename?: 'C___Title' }
  & Pick<Types.C___Title, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Type = (
  { __typename?: 'C___Type' }
  & Pick<Types.C___Type, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Validation = (
  { __typename?: 'C___Validation' }
  & Pick<Types.C___Validation, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___VariantPaging = (
  { __typename?: 'C___VariantPaging' }
  & Pick<Types.C___VariantPaging, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___VectorTile = (
  { __typename?: 'C___VectorTile' }
  & Pick<Types.C___VectorTile, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___VectorTileLink = (
  { __typename?: 'C___VectorTileLink' }
  & Pick<Types.C___VectorTileLink, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Video = (
  { __typename?: 'C___Video' }
  & Pick<Types.C___Video, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___VideoPressRelease = (
  { __typename?: 'C___VideoPressRelease' }
  & Pick<Types.C___VideoPressRelease, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___Width = (
  { __typename?: 'C___Width' }
  & Pick<Types.C___Width, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_C___WildcardPage = (
  { __typename?: 'C___WildcardPage' }
  & Pick<Types.C___WildcardPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CacheSetting = (
  { __typename?: 'CacheSetting' }
  & Pick<Types.CacheSetting, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Caching_26fce9bf0256458d8281a713a5bf5520 = (
  { __typename?: 'Caching_26fce9bf0256458d8281a713a5bf5520' }
  & Pick<Types.Caching_26fce9bf0256458d8281a713a5bf5520, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CalendarEvent = (
  { __typename?: 'CalendarEvent' }
  & Pick<Types.CalendarEvent, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CallOutSection = (
  { __typename?: 'CallOutSection' }
  & Pick<Types.CallOutSection, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CallOutSectionDropdownOption = (
  { __typename?: 'CallOutSectionDropdownOption' }
  & Pick<Types.CallOutSectionDropdownOption, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CallOutSectionFolder = (
  { __typename?: 'CallOutSectionFolder' }
  & Pick<Types.CallOutSectionFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CallOutSectionParametersTemplate = (
  { __typename?: 'CallOutSectionParametersTemplate' }
  & Pick<Types.CallOutSectionParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CallToAction = (
  { __typename?: 'CallToAction' }
  & Pick<Types.CallToAction, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CallToActionFolder = (
  { __typename?: 'CallToActionFolder' }
  & Pick<Types.CallToActionFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CapabilitiesFolder = (
  { __typename?: 'CapabilitiesFolder' }
  & Pick<Types.CapabilitiesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Capability = (
  { __typename?: 'Capability' }
  & Pick<Types.Capability, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CapabilityMap = (
  { __typename?: 'CapabilityMap' }
  & Pick<Types.CapabilityMap, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CapabilityMappings = (
  { __typename?: 'CapabilityMappings' }
  & Pick<Types.CapabilityMappings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Carousel = (
  { __typename?: 'Carousel' }
  & Pick<Types.Carousel, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CarouselFolder = (
  { __typename?: 'CarouselFolder' }
  & Pick<Types.CarouselFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CarouselSlide = (
  { __typename?: 'CarouselSlide' }
  & Pick<Types.CarouselSlide, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Carousel_2b65f0d87ec54834b4aa1753c0f7036b = (
  { __typename?: 'Carousel_2b65f0d87ec54834b4aa1753c0f7036b' }
  & Pick<Types.Carousel_2b65f0d87ec54834b4aa1753c0f7036b, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Checkbox = (
  { __typename?: 'Checkbox' }
  & Pick<Types.Checkbox, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ChecklistFilter = (
  { __typename?: 'ChecklistFilter' }
  & Pick<Types.ChecklistFilter, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ChecklistFilterFolder = (
  { __typename?: 'ChecklistFilterFolder' }
  & Pick<Types.ChecklistFilterFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee = (
  { __typename?: 'ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee' }
  & Pick<Types.ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ColumnSplitter = (
  { __typename?: 'ColumnSplitter' }
  & Pick<Types.ColumnSplitter, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0 = (
  { __typename?: 'ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0' }
  & Pick<Types.ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CompatibilityMode = (
  { __typename?: 'CompatibilityMode' }
  & Pick<Types.CompatibilityMode, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ComponentConfiguration = (
  { __typename?: 'ComponentConfiguration' }
  & Pick<Types.ComponentConfiguration, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ComponentThemeConfiguration = (
  { __typename?: 'ComponentThemeConfiguration' }
  & Pick<Types.ComponentThemeConfiguration, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ComponentThemesConfiguration = (
  { __typename?: 'ComponentThemesConfiguration' }
  & Pick<Types.ComponentThemesConfiguration, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ComponentsConfigurations = (
  { __typename?: 'ComponentsConfigurations' }
  & Pick<Types.ComponentsConfigurations, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ConfigurationFolder = (
  { __typename?: 'ConfigurationFolder' }
  & Pick<Types.ConfigurationFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Container = (
  { __typename?: 'Container' }
  & Pick<Types.Container, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ContainerOption = (
  { __typename?: 'ContainerOption' }
  & Pick<Types.ContainerOption, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ContainerOptionsFolder = (
  { __typename?: 'ContainerOptionsFolder' }
  & Pick<Types.ContainerOptionsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ContainerParametersTemplate = (
  { __typename?: 'ContainerParametersTemplate' }
  & Pick<Types.ContainerParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Container_45130bdbbae34edcaea87b68b9d94c7f = (
  { __typename?: 'Container_45130bdbbae34edcaea87b68b9d94c7f' }
  & Pick<Types.Container_45130bdbbae34edcaea87b68b9d94c7f, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ContentBlock = (
  { __typename?: 'ContentBlock' }
  & Pick<Types.ContentBlock, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ContentBlockFolder = (
  { __typename?: 'ContentBlockFolder' }
  & Pick<Types.ContentBlockFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ContentToken = (
  { __typename?: 'ContentToken' }
  & Pick<Types.ContentToken, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ContentTokenFolder = (
  { __typename?: 'ContentTokenFolder' }
  & Pick<Types.ContentTokenFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ContentType = (
  { __typename?: 'ContentType' }
  & Pick<Types.ContentType, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CorporateTheme = (
  { __typename?: 'CorporateTheme' }
  & Pick<Types.CorporateTheme, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CorporateThemesFolder = (
  { __typename?: 'CorporateThemesFolder' }
  & Pick<Types.CorporateThemesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Country = (
  { __typename?: 'Country' }
  & Pick<Types.Country, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CountryISOCode = (
  { __typename?: 'CountryISOCode' }
  & Pick<Types.CountryIsoCode, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CountryISOCodesFolder = (
  { __typename?: 'CountryISOCodesFolder' }
  & Pick<Types.CountryIsoCodesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CustomerReviewFolder = (
  { __typename?: 'CustomerReviewFolder' }
  & Pick<Types.CustomerReviewFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CustomerReviewTile = (
  { __typename?: 'CustomerReviewTile' }
  & Pick<Types.CustomerReviewTile, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_CustomerReviewTileParametersTemplate = (
  { __typename?: 'CustomerReviewTileParametersTemplate' }
  & Pick<Types.CustomerReviewTileParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DataBridgeDocumentCategoryMap = (
  { __typename?: 'DataBridgeDocumentCategoryMap' }
  & Pick<Types.DataBridgeDocumentCategoryMap, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DataBridgeFund = (
  { __typename?: 'DataBridgeFund' }
  & Pick<Types.DataBridgeFund, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DataBridgeFundRangeName = (
  { __typename?: 'DataBridgeFundRangeName' }
  & Pick<Types.DataBridgeFundRangeName, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DataBridgeSettingsFolder = (
  { __typename?: 'DataBridgeSettingsFolder' }
  & Pick<Types.DataBridgeSettingsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DataBridgeShareClass = (
  { __typename?: 'DataBridgeShareClass' }
  & Pick<Types.DataBridgeShareClass, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DataFolder = (
  { __typename?: 'DataFolder' }
  & Pick<Types.DataFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DatasourceConfiguration = (
  { __typename?: 'DatasourceConfiguration' }
  & Pick<Types.DatasourceConfiguration, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DatasourceConfigurations = (
  { __typename?: 'DatasourceConfigurations' }
  & Pick<Types.DatasourceConfigurations, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DatasourceWorkflowAction = (
  { __typename?: 'DatasourceWorkflowAction' }
  & Pick<Types.DatasourceWorkflowAction, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DateFacet = (
  { __typename?: 'DateFacet' }
  & Pick<Types.DateFacet, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DateFilter = (
  { __typename?: 'DateFilter' }
  & Pick<Types.DateFilter, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DateFilterFolder = (
  { __typename?: 'DateFilterFolder' }
  & Pick<Types.DateFilterFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DateFilter_ad89c1f1e99148ef865938ab13aa28f1 = (
  { __typename?: 'DateFilter_ad89c1f1e99148ef865938ab13aa28f1' }
  & Pick<Types.DateFilter_Ad89c1f1e99148ef865938ab13aa28f1, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DefaultColumnLayout = (
  { __typename?: 'DefaultColumnLayout' }
  & Pick<Types.DefaultColumnLayout, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DefaultShareclassMapping = (
  { __typename?: 'DefaultShareclassMapping' }
  & Pick<Types.DefaultShareclassMapping, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DefaultShareclassMappings = (
  { __typename?: 'DefaultShareclassMappings' }
  & Pick<Types.DefaultShareclassMappings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DescriptiveHighlight = (
  { __typename?: 'DescriptiveHighlight' }
  & Pick<Types.DescriptiveHighlight, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DescriptiveHighlightFolder = (
  { __typename?: 'DescriptiveHighlightFolder' }
  & Pick<Types.DescriptiveHighlightFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DescriptiveHighlightItem = (
  { __typename?: 'DescriptiveHighlightItem' }
  & Pick<Types.DescriptiveHighlightItem, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DescriptiveHighlightParametersTemplate = (
  { __typename?: 'DescriptiveHighlightParametersTemplate' }
  & Pick<Types.DescriptiveHighlightParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Device = (
  { __typename?: 'Device' }
  & Pick<Types.Device, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Device_7c27ec70f42e40428a0fabaa2f8eda18 = (
  { __typename?: 'Device_7c27ec70f42e40428a0fabaa2f8eda18' }
  & Pick<Types.Device_7c27ec70f42e40428a0fabaa2f8eda18, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Devices = (
  { __typename?: 'Devices' }
  & Pick<Types.Devices, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DictionaryFolder = (
  { __typename?: 'DictionaryFolder' }
  & Pick<Types.DictionaryFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DisqusParameters = (
  { __typename?: 'DisqusParameters' }
  & Pick<Types.DisqusParameters, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DistanceFacet = (
  { __typename?: 'DistanceFacet' }
  & Pick<Types.DistanceFacet, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Divider = (
  { __typename?: 'Divider' }
  & Pick<Types.Divider, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DocumentItem = (
  { __typename?: 'DocumentItem' }
  & Pick<Types.DocumentItem, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DocumentListings = (
  { __typename?: 'DocumentListings' }
  & Pick<Types.DocumentListings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DocumentListingsFolder = (
  { __typename?: 'DocumentListingsFolder' }
  & Pick<Types.DocumentListingsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DocumentTypeFolder = (
  { __typename?: 'DocumentTypeFolder' }
  & Pick<Types.DocumentTypeFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DominantLanguageMapping = (
  { __typename?: 'DominantLanguageMapping' }
  & Pick<Types.DominantLanguageMapping, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Dropdown = (
  { __typename?: 'Dropdown' }
  & Pick<Types.Dropdown, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DropdownFilter = (
  { __typename?: 'DropdownFilter' }
  & Pick<Types.DropdownFilter, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DropdownFilterFolder = (
  { __typename?: 'DropdownFilterFolder' }
  & Pick<Types.DropdownFilterFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_DropdownFilter_790c0f2c16214604a6c672b9f8ae830d = (
  { __typename?: 'DropdownFilter_790c0f2c16214604a6c672b9f8ae830d' }
  & Pick<Types.DropdownFilter_790c0f2c16214604a6c672b9f8ae830d, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_EditEditingTheme = (
  { __typename?: 'EditEditingTheme' }
  & Pick<Types.EditEditingTheme, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_EditFrame = (
  { __typename?: 'EditFrame' }
  & Pick<Types.EditFrame, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_EditModePanel = (
  { __typename?: 'EditModePanel' }
  & Pick<Types.EditModePanel, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_EditSiteItem = (
  { __typename?: 'EditSiteItem' }
  & Pick<Types.EditSiteItem, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_EditSiteItem_f040db0387fe4e10ae4053c63175e31b = (
  { __typename?: 'EditSiteItem_f040db0387fe4e10ae4053c63175e31b' }
  & Pick<Types.EditSiteItem_F040db0387fe4e10ae4053c63175e31b, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_EditSiteTheme = (
  { __typename?: 'EditSiteTheme' }
  & Pick<Types.EditSiteTheme, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_EditTenantTemplate = (
  { __typename?: 'EditTenantTemplate' }
  & Pick<Types.EditTenantTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3 = (
  { __typename?: 'EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3' }
  & Pick<Types.EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_EditType = (
  { __typename?: 'EditType' }
  & Pick<Types.EditType, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_EloquaFormFolder = (
  { __typename?: 'EloquaFormFolder' }
  & Pick<Types.EloquaFormFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_EloquaFundForm = (
  { __typename?: 'EloquaFundForm' }
  & Pick<Types.EloquaFundForm, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Enum = (
  { __typename?: 'Enum' }
  & Pick<Types.Enum, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Enums = (
  { __typename?: 'Enums' }
  & Pick<Types.Enums, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ErrorPage = (
  { __typename?: 'ErrorPage' }
  & Pick<Types.ErrorPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171 = (
  { __typename?: 'ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171' }
  & Pick<Types.ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ErrorPage_4dbccce416d1491f94198496e3f77c6d = (
  { __typename?: 'ErrorPage_4dbccce416d1491f94198496e3f77c6d' }
  & Pick<Types.ErrorPage_4dbccce416d1491f94198496e3f77c6d, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ErrorPage_45d797cc048740ffb693214883ff35c2 = (
  { __typename?: 'ErrorPage_45d797cc048740ffb693214883ff35c2' }
  & Pick<Types.ErrorPage_45d797cc048740ffb693214883ff35c2, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9 = (
  { __typename?: 'ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9' }
  & Pick<Types.ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ErrorPage_a7dfa49761224679bf9949fffacd5fa1 = (
  { __typename?: 'ErrorPage_a7dfa49761224679bf9949fffacd5fa1' }
  & Pick<Types.ErrorPage_A7dfa49761224679bf9949fffacd5fa1, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_EventCalendarParameters = (
  { __typename?: 'EventCalendarParameters' }
  & Pick<Types.EventCalendarParameters, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_EventList = (
  { __typename?: 'EventList' }
  & Pick<Types.EventList, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_EventListParameters = (
  { __typename?: 'EventListParameters' }
  & Pick<Types.EventListParameters, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_EventTypes = (
  { __typename?: 'EventTypes' }
  & Pick<Types.EventTypes, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_EventsFolder = (
  { __typename?: 'EventsFolder' }
  & Pick<Types.EventsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ExecuteScript = (
  { __typename?: 'ExecuteScript' }
  & Pick<Types.ExecuteScript, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f = (
  { __typename?: 'ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f' }
  & Pick<Types.ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a = (
  { __typename?: 'ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a' }
  & Pick<Types.ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca = (
  { __typename?: 'ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca' }
  & Pick<Types.ExecuteScript_B06460c28b7b47a59e2cf966f689b6ca, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ExecuteScript_bc9bb68436df4285888bd8b4d87b10de = (
  { __typename?: 'ExecuteScript_bc9bb68436df4285888bd8b4d87b10de' }
  & Pick<Types.ExecuteScript_Bc9bb68436df4285888bd8b4d87b10de, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb = (
  { __typename?: 'ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb' }
  & Pick<Types.ExecuteScript_E14c08721a97459eafef0acaaaf1ffbb, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ExtendSiteTheme = (
  { __typename?: 'ExtendSiteTheme' }
  & Pick<Types.ExtendSiteTheme, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ExternalLiterature = (
  { __typename?: 'ExternalLiterature' }
  & Pick<Types.ExternalLiterature, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FEaaSWrapperRenderingParameters = (
  { __typename?: 'FEaaSWrapperRenderingParameters' }
  & Pick<Types.FEaaSWrapperRenderingParameters, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FacebookCommentsParametersTemplate = (
  { __typename?: 'FacebookCommentsParametersTemplate' }
  & Pick<Types.FacebookCommentsParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FacetSlider = (
  { __typename?: 'FacetSlider' }
  & Pick<Types.FacetSlider, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FacetSliderFolder = (
  { __typename?: 'FacetSliderFolder' }
  & Pick<Types.FacetSliderFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FacetSlider_995ce2c7319f478b84fe22053ac85bb7 = (
  { __typename?: 'FacetSlider_995ce2c7319f478b84fe22053ac85bb7' }
  & Pick<Types.FacetSlider_995ce2c7319f478b84fe22053ac85bb7, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FacetSummary = (
  { __typename?: 'FacetSummary' }
  & Pick<Types.FacetSummary, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FacetSummaryFolder = (
  { __typename?: 'FacetSummaryFolder' }
  & Pick<Types.FacetSummaryFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FacetSummary_cd5c935c1f604d899a6b88ce28305cf2 = (
  { __typename?: 'FacetSummary_cd5c935c1f604d899a6b88ce28305cf2' }
  & Pick<Types.FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FacetsGrouping = (
  { __typename?: 'FacetsGrouping' }
  & Pick<Types.FacetsGrouping, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FakeNavigationItem = (
  { __typename?: 'FakeNavigationItem' }
  & Pick<Types.FakeNavigationItem, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FeatureBanner = (
  { __typename?: 'FeatureBanner' }
  & Pick<Types.FeatureBanner, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FeatureBannerParametersTemplate = (
  { __typename?: 'FeatureBannerParametersTemplate' }
  & Pick<Types.FeatureBannerParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FeaturedArticles = (
  { __typename?: 'FeaturedArticles' }
  & Pick<Types.FeaturedArticles, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FeaturedArticlesFolder = (
  { __typename?: 'FeaturedArticlesFolder' }
  & Pick<Types.FeaturedArticlesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FeaturedTheme = (
  { __typename?: 'FeaturedTheme' }
  & Pick<Types.FeaturedTheme, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FeaturedThemesFolder = (
  { __typename?: 'FeaturedThemesFolder' }
  & Pick<Types.FeaturedThemesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Feed = (
  { __typename?: 'Feed' }
  & Pick<Types.Feed, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FeedFolder = (
  { __typename?: 'FeedFolder' }
  & Pick<Types.FeedFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FeedParameters = (
  { __typename?: 'FeedParameters' }
  & Pick<Types.FeedParameters, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FieldEditor = (
  { __typename?: 'FieldEditor' }
  & Pick<Types.FieldEditor, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FieldRenderer = (
  { __typename?: 'FieldRenderer' }
  & Pick<Types.FieldRenderer, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FileList = (
  { __typename?: 'FileList' }
  & Pick<Types.FileList, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FileListFolder = (
  { __typename?: 'FileListFolder' }
  & Pick<Types.FileListFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FileListParametersTemplate = (
  { __typename?: 'FileListParametersTemplate' }
  & Pick<Types.FileListParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_File_04129321770849c1801baee196e1c0a8 = (
  { __typename?: 'File_04129321770849c1801baee196e1c0a8' }
  & Pick<Types.File_04129321770849c1801baee196e1c0a8, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FilterCriteria = (
  { __typename?: 'FilterCriteria' }
  & Pick<Types.FilterCriteria, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FilterCriteriaFolder = (
  { __typename?: 'FilterCriteriaFolder' }
  & Pick<Types.FilterCriteriaFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FilterTaxonomyOption = (
  { __typename?: 'FilterTaxonomyOption' }
  & Pick<Types.FilterTaxonomyOption, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FilterTaxonomyOptions = (
  { __typename?: 'FilterTaxonomyOptions' }
  & Pick<Types.FilterTaxonomyOptions, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage = (
  { __typename?: 'FilteredArticlesParentPage' }
  & Pick<Types.FilteredArticlesParentPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d = (
  { __typename?: 'FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d' }
  & Pick<Types.FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941 = (
  { __typename?: 'FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941' }
  & Pick<Types.FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616 = (
  { __typename?: 'FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616' }
  & Pick<Types.FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9 = (
  { __typename?: 'FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9' }
  & Pick<Types.FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce = (
  { __typename?: 'FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce' }
  & Pick<Types.FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ce, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage = (
  { __typename?: 'FilteredArticlesWildcardPage' }
  & Pick<Types.FilteredArticlesWildcardPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e = (
  { __typename?: 'FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e' }
  & Pick<Types.FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835 = (
  { __typename?: 'FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835' }
  & Pick<Types.FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2 = (
  { __typename?: 'FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2' }
  & Pick<Types.FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96 = (
  { __typename?: 'FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96' }
  & Pick<Types.FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260 = (
  { __typename?: 'FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260' }
  & Pick<Types.FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Flip = (
  { __typename?: 'Flip' }
  & Pick<Types.Flip, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FlipFolder = (
  { __typename?: 'FlipFolder' }
  & Pick<Types.FlipFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Flip_5ef078504c044b839dafefd752cfaba8 = (
  { __typename?: 'Flip_5ef078504c044b839dafefd752cfaba8' }
  & Pick<Types.Flip_5ef078504c044b839dafefd752cfaba8, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Flipside = (
  { __typename?: 'Flipside' }
  & Pick<Types.Flipside, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FloatFacet = (
  { __typename?: 'FloatFacet' }
  & Pick<Types.FloatFacet, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Footer = (
  { __typename?: 'Footer' }
  & Pick<Types.Footer, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FooterFolder = (
  { __typename?: 'FooterFolder' }
  & Pick<Types.FooterFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FooterLink = (
  { __typename?: 'FooterLink' }
  & Pick<Types.FooterLink, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FormRenderingParameters = (
  { __typename?: 'FormRenderingParameters' }
  & Pick<Types.FormRenderingParameters, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundAssetClass = (
  { __typename?: 'FundAssetClass' }
  & Pick<Types.FundAssetClass, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundAssetClassesFolder = (
  { __typename?: 'FundAssetClassesFolder' }
  & Pick<Types.FundAssetClassesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage = (
  { __typename?: 'FundDetailsWildcardPage' }
  & Pick<Types.FundDetailsWildcardPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734 = (
  { __typename?: 'FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734' }
  & Pick<Types.FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f = (
  { __typename?: 'FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f' }
  & Pick<Types.FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b = (
  { __typename?: 'FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b' }
  & Pick<Types.FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundFormsFolder = (
  { __typename?: 'FundFormsFolder' }
  & Pick<Types.FundFormsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundInFocus = (
  { __typename?: 'FundInFocus' }
  & Pick<Types.FundInFocus, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundInFocusShareClass = (
  { __typename?: 'FundInFocusShareClass' }
  & Pick<Types.FundInFocusShareClass, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundSearchPage = (
  { __typename?: 'FundSearchPage' }
  & Pick<Types.FundSearchPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundSearchPage_5505b84dba1f47c7b8054749d802d926 = (
  { __typename?: 'FundSearchPage_5505b84dba1f47c7b8054749d802d926' }
  & Pick<Types.FundSearchPage_5505b84dba1f47c7b8054749d802d926, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundSearchPage_5806f83c03bc443380678ff955f4310f = (
  { __typename?: 'FundSearchPage_5806f83c03bc443380678ff955f4310f' }
  & Pick<Types.FundSearchPage_5806f83c03bc443380678ff955f4310f, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundSearchPage_7432205c04214a419ca064c4cb37501c = (
  { __typename?: 'FundSearchPage_7432205c04214a419ca064c4cb37501c' }
  & Pick<Types.FundSearchPage_7432205c04214a419ca064c4cb37501c, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a = (
  { __typename?: 'FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a' }
  & Pick<Types.FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0a, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundSettings = (
  { __typename?: 'FundSettings' }
  & Pick<Types.FundSettings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage = (
  { __typename?: 'FundShareclassDetailsWildcardPage' }
  & Pick<Types.FundShareclassDetailsWildcardPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c = (
  { __typename?: 'FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c' }
  & Pick<Types.FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3 = (
  { __typename?: 'FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3' }
  & Pick<Types.FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc = (
  { __typename?: 'FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc' }
  & Pick<Types.FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dcc, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee = (
  { __typename?: 'FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee' }
  & Pick<Types.FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eee, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundSubAssetClass = (
  { __typename?: 'FundSubAssetClass' }
  & Pick<Types.FundSubAssetClass, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundSubAssetClassesFolder = (
  { __typename?: 'FundSubAssetClassesFolder' }
  & Pick<Types.FundSubAssetClassesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundsExternalLiteratureFolder = (
  { __typename?: 'FundsExternalLiteratureFolder' }
  & Pick<Types.FundsExternalLiteratureFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundsFolder = (
  { __typename?: 'FundsFolder' }
  & Pick<Types.FundsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundsInFocusFolder = (
  { __typename?: 'FundsInFocusFolder' }
  & Pick<Types.FundsInFocusFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundsInFocusParametersTemplate = (
  { __typename?: 'FundsInFocusParametersTemplate' }
  & Pick<Types.FundsInFocusParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundsLiteratureFolder = (
  { __typename?: 'FundsLiteratureFolder' }
  & Pick<Types.FundsLiteratureFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_FundsLiteratureMappingsFolder = (
  { __typename?: 'FundsLiteratureMappingsFolder' }
  & Pick<Types.FundsLiteratureMappingsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Gallery = (
  { __typename?: 'Gallery' }
  & Pick<Types.Gallery, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_GalleryFolder = (
  { __typename?: 'GalleryFolder' }
  & Pick<Types.GalleryFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_GalleryImage = (
  { __typename?: 'GalleryImage' }
  & Pick<Types.GalleryImage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_GalleryParametersTemplate = (
  { __typename?: 'GalleryParametersTemplate' }
  & Pick<Types.GalleryParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_GalleryVideo = (
  { __typename?: 'GalleryVideo' }
  & Pick<Types.GalleryVideo, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_GatedAccordionContainer = (
  { __typename?: 'GatedAccordionContainer' }
  & Pick<Types.GatedAccordionContainer, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_GlobalLanguageSelector = (
  { __typename?: 'GlobalLanguageSelector' }
  & Pick<Types.GlobalLanguageSelector, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_GlobalNavigationBar = (
  { __typename?: 'GlobalNavigationBar' }
  & Pick<Types.GlobalNavigationBar, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_GoogleAnalytics = (
  { __typename?: 'GoogleAnalytics' }
  & Pick<Types.GoogleAnalytics, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_GoogleTagManager = (
  { __typename?: 'GoogleTagManager' }
  & Pick<Types.GoogleTagManager, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_GoogleTagManagerFolder = (
  { __typename?: 'GoogleTagManagerFolder' }
  & Pick<Types.GoogleTagManagerFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_GridSetup = (
  { __typename?: 'GridSetup' }
  & Pick<Types.GridSetup, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_GridTheme = (
  { __typename?: 'GridTheme' }
  & Pick<Types.GridTheme, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HTMLCode = (
  { __typename?: 'HTMLCode' }
  & Pick<Types.HtmlCode, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HTMLCodeFolder = (
  { __typename?: 'HTMLCodeFolder' }
  & Pick<Types.HtmlCodeFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HTMLInclude = (
  { __typename?: 'HTMLInclude' }
  & Pick<Types.HtmlInclude, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HTMLIncludesFolder = (
  { __typename?: 'HTMLIncludesFolder' }
  & Pick<Types.HtmlIncludesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HTMLSnippet = (
  { __typename?: 'HTMLSnippet' }
  & Pick<Types.HtmlSnippet, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HTMLSnippetFolder = (
  { __typename?: 'HTMLSnippetFolder' }
  & Pick<Types.HtmlSnippetFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HTMLTag = (
  { __typename?: 'HTMLTag' }
  & Pick<Types.HtmlTag, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Header = (
  { __typename?: 'Header' }
  & Pick<Types.Header, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeaderFolder = (
  { __typename?: 'HeaderFolder' }
  & Pick<Types.HeaderFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Heading = (
  { __typename?: 'Heading' }
  & Pick<Types.Heading, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessSiteSetupRoot = (
  { __typename?: 'HeadlessSiteSetupRoot' }
  & Pick<Types.HeadlessSiteSetupRoot, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessSite_00d050988bad49e5b65db1e08b03ca1b = (
  { __typename?: 'HeadlessSite_00d050988bad49e5b65db1e08b03ca1b' }
  & Pick<Types.HeadlessSite_00d050988bad49e5b65db1e08b03ca1b, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1 = (
  { __typename?: 'HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1' }
  & Pick<Types.HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessSite_8ca001453c4b4715959d8a05292ecbc5 = (
  { __typename?: 'HeadlessSite_8ca001453c4b4715959d8a05292ecbc5' }
  & Pick<Types.HeadlessSite_8ca001453c4b4715959d8a05292ecbc5, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessSite_68ffa40c5aab45548f774742b163f318 = (
  { __typename?: 'HeadlessSite_68ffa40c5aab45548f774742b163f318' }
  & Pick<Types.HeadlessSite_68ffa40c5aab45548f774742b163f318, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessSite_89d464c8c03e4b0287e9a878d95d7149 = (
  { __typename?: 'HeadlessSite_89d464c8c03e4b0287e9a878d95d7149' }
  & Pick<Types.HeadlessSite_89d464c8c03e4b0287e9a878d95d7149, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessSite_229484893ca144958b9937167dfb5064 = (
  { __typename?: 'HeadlessSite_229484893ca144958b9937167dfb5064' }
  & Pick<Types.HeadlessSite_229484893ca144958b9937167dfb5064, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessSite_b28055626acc45a2913a9617398c9730 = (
  { __typename?: 'HeadlessSite_b28055626acc45a2913a9617398c9730' }
  & Pick<Types.HeadlessSite_B28055626acc45a2913a9617398c9730, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessSite_f1cab1661abb450d84d55d938e7699cb = (
  { __typename?: 'HeadlessSite_f1cab1661abb450d84d55d938e7699cb' }
  & Pick<Types.HeadlessSite_F1cab1661abb450d84d55d938e7699cb, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessSite_f3884baa0e1548f59a6d7154a4559604 = (
  { __typename?: 'HeadlessSite_f3884baa0e1548f59a6d7154a4559604' }
  & Pick<Types.HeadlessSite_F3884baa0e1548f59a6d7154a4559604, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessSolutionTemplateFolder = (
  { __typename?: 'HeadlessSolutionTemplateFolder' }
  & Pick<Types.HeadlessSolutionTemplateFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessTenantSetupRoot = (
  { __typename?: 'HeadlessTenantSetupRoot' }
  & Pick<Types.HeadlessTenantSetupRoot, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessTenant_07248c4700af499eb2a9cb7789f72372 = (
  { __typename?: 'HeadlessTenant_07248c4700af499eb2a9cb7789f72372' }
  & Pick<Types.HeadlessTenant_07248c4700af499eb2a9cb7789f72372, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8 = (
  { __typename?: 'HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8' }
  & Pick<Types.HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessTenant_5d72df6049c74324969205b55767ad7b = (
  { __typename?: 'HeadlessTenant_5d72df6049c74324969205b55767ad7b' }
  & Pick<Types.HeadlessTenant_5d72df6049c74324969205b55767ad7b, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3 = (
  { __typename?: 'HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3' }
  & Pick<Types.HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessTenant_77a403a2094e48afafa60943d349d23d = (
  { __typename?: 'HeadlessTenant_77a403a2094e48afafa60943d349d23d' }
  & Pick<Types.HeadlessTenant_77a403a2094e48afafa60943d349d23d, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2 = (
  { __typename?: 'HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2' }
  & Pick<Types.HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessTenant_94824ac390d748499e5af0275d10811f = (
  { __typename?: 'HeadlessTenant_94824ac390d748499e5af0275d10811f' }
  & Pick<Types.HeadlessTenant_94824ac390d748499e5af0275d10811f, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessTenant_4797571864fd40929cf2412c39757ec3 = (
  { __typename?: 'HeadlessTenant_4797571864fd40929cf2412c39757ec3' }
  & Pick<Types.HeadlessTenant_4797571864fd40929cf2412c39757ec3, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107 = (
  { __typename?: 'HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107' }
  & Pick<Types.HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessTrustSite = (
  { __typename?: 'HeadlessTrustSite' }
  & Pick<Types.HeadlessTrustSite, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessVariants = (
  { __typename?: 'HeadlessVariants' }
  & Pick<Types.HeadlessVariants, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessVariantsGrouping = (
  { __typename?: 'HeadlessVariantsGrouping' }
  & Pick<Types.HeadlessVariantsGrouping, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HelpArticlePage = (
  { __typename?: 'HelpArticlePage' }
  & Pick<Types.HelpArticlePage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HelpArticlePlatform = (
  { __typename?: 'HelpArticlePlatform' }
  & Pick<Types.HelpArticlePlatform, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HelpArticlePlatformMap = (
  { __typename?: 'HelpArticlePlatformMap' }
  & Pick<Types.HelpArticlePlatformMap, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HelpArticlePlatformMappings = (
  { __typename?: 'HelpArticlePlatformMappings' }
  & Pick<Types.HelpArticlePlatformMappings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HelpArticlePlatformsFolder = (
  { __typename?: 'HelpArticlePlatformsFolder' }
  & Pick<Types.HelpArticlePlatformsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HelpArticleSearchPage = (
  { __typename?: 'HelpArticleSearchPage' }
  & Pick<Types.HelpArticleSearchPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77 = (
  { __typename?: 'HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77' }
  & Pick<Types.HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HelpArticleTag = (
  { __typename?: 'HelpArticleTag' }
  & Pick<Types.HelpArticleTag, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HelpArticleTagsFolder = (
  { __typename?: 'HelpArticleTagsFolder' }
  & Pick<Types.HelpArticleTagsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HelpArticleWildcardPage = (
  { __typename?: 'HelpArticleWildcardPage' }
  & Pick<Types.HelpArticleWildcardPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4 = (
  { __typename?: 'HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4' }
  & Pick<Types.HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HelpArticlesGroupFolder = (
  { __typename?: 'HelpArticlesGroupFolder' }
  & Pick<Types.HelpArticlesGroupFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HelpTagMap = (
  { __typename?: 'HelpTagMap' }
  & Pick<Types.HelpTagMap, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HelpTagMappings = (
  { __typename?: 'HelpTagMappings' }
  & Pick<Types.HelpTagMappings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HeroBanner = (
  { __typename?: 'HeroBanner' }
  & Pick<Types.HeroBanner, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Highlight = (
  { __typename?: 'Highlight' }
  & Pick<Types.Highlight, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HighlightBlock = (
  { __typename?: 'HighlightBlock' }
  & Pick<Types.HighlightBlock, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HighlightBlockFolder = (
  { __typename?: 'HighlightBlockFolder' }
  & Pick<Types.HighlightBlockFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HighlightBlockParametersTemplate = (
  { __typename?: 'HighlightBlockParametersTemplate' }
  & Pick<Types.HighlightBlockParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HighlightFolder = (
  { __typename?: 'HighlightFolder' }
  & Pick<Types.HighlightFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HighlightItem = (
  { __typename?: 'HighlightItem' }
  & Pick<Types.HighlightItem, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HighlightParametersTemplate = (
  { __typename?: 'HighlightParametersTemplate' }
  & Pick<Types.HighlightParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Home = (
  { __typename?: 'Home' }
  & Pick<Types.Home, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HomePage = (
  { __typename?: 'HomePage' }
  & Pick<Types.HomePage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HomePage_0d3963a8171d4080b5f808618578b631 = (
  { __typename?: 'HomePage_0d3963a8171d4080b5f808618578b631' }
  & Pick<Types.HomePage_0d3963a8171d4080b5f808618578b631, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HomePage_6d95c7d946c74a70be07304cc73a2010 = (
  { __typename?: 'HomePage_6d95c7d946c74a70be07304cc73a2010' }
  & Pick<Types.HomePage_6d95c7d946c74a70be07304cc73a2010, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HomePage_b407f259b4e34c7db9a06e8907a56b17 = (
  { __typename?: 'HomePage_b407f259b4e34c7db9a06e8907a56b17' }
  & Pick<Types.HomePage_B407f259b4e34c7db9a06e8907a56b17, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HomePage_cde13c51062d426b95569e8202edc963 = (
  { __typename?: 'HomePage_cde13c51062d426b95569e8202edc963' }
  & Pick<Types.HomePage_Cde13c51062d426b95569e8202edc963, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_HomePage_de9353283a3e41c495ba386aed0540c6 = (
  { __typename?: 'HomePage_de9353283a3e41c495ba386aed0540c6' }
  & Pick<Types.HomePage_De9353283a3e41c495ba386aed0540c6, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_IFrame = (
  { __typename?: 'IFrame' }
  & Pick<Types.IFrame, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_IFrameFolder = (
  { __typename?: 'IFrameFolder' }
  & Pick<Types.IFrameFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2 = (
  { __typename?: 'IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2' }
  & Pick<Types.IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_IFrameParametersTemplate = (
  { __typename?: 'IFrameParametersTemplate' }
  & Pick<Types.IFrameParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_IFrame_0da12d476de24dfeb4d0f513489bfea1 = (
  { __typename?: 'IFrame_0da12d476de24dfeb4d0f513489bfea1' }
  & Pick<Types.IFrame_0da12d476de24dfeb4d0f513489bfea1, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_IFrame_88a6f65f2b78491bb3770b06e48883e1 = (
  { __typename?: 'IFrame_88a6f65f2b78491bb3770b06e48883e1' }
  & Pick<Types.IFrame_88a6f65f2b78491bb3770b06e48883e1, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Icon = (
  { __typename?: 'Icon' }
  & Pick<Types.Icon, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_IconFolder = (
  { __typename?: 'IconFolder' }
  & Pick<Types.IconFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Image = (
  { __typename?: 'Image' }
  & Pick<Types.Image, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ImageFolder = (
  { __typename?: 'ImageFolder' }
  & Pick<Types.ImageFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ImageFolder_edc00e86cef24d0cbfa264460becc323 = (
  { __typename?: 'ImageFolder_edc00e86cef24d0cbfa264460becc323' }
  & Pick<Types.ImageFolder_Edc00e86cef24d0cbfa264460becc323, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993 = (
  { __typename?: 'ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993' }
  & Pick<Types.ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ImageParametersTemplate = (
  { __typename?: 'ImageParametersTemplate' }
  & Pick<Types.ImageParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Image_83bc563c6320490092f8204bff81586a = (
  { __typename?: 'Image_83bc563c6320490092f8204bff81586a' }
  & Pick<Types.Image_83bc563c6320490092f8204bff81586a, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Image_15185b0e641844499f934ff03b7ee032 = (
  { __typename?: 'Image_15185b0e641844499f934ff03b7ee032' }
  & Pick<Types.Image_15185b0e641844499f934ff03b7ee032, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Image_d885df8cb2d64007b34b2bbafb527304 = (
  { __typename?: 'Image_d885df8cb2d64007b34b2bbafb527304' }
  & Pick<Types.Image_D885df8cb2d64007b34b2bbafb527304, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Infographics = (
  { __typename?: 'Infographics' }
  & Pick<Types.Infographics, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_InfographicsFolder = (
  { __typename?: 'InfographicsFolder' }
  & Pick<Types.InfographicsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_InputValidationStep = (
  { __typename?: 'InputValidationStep' }
  & Pick<Types.InputValidationStep, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_InputValidationStep_088928cf558e40ec87f3342aa9e66757 = (
  { __typename?: 'InputValidationStep_088928cf558e40ec87f3342aa9e66757' }
  & Pick<Types.InputValidationStep_088928cf558e40ec87f3342aa9e66757, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593 = (
  { __typename?: 'InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593' }
  & Pick<Types.InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_InputValidationStep_d028fef2babf4ad1bbe74d62a977992f = (
  { __typename?: 'InputValidationStep_d028fef2babf4ad1bbe74d62a977992f' }
  & Pick<Types.InputValidationStep_D028fef2babf4ad1bbe74d62a977992f, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_IntegerFacet = (
  { __typename?: 'IntegerFacet' }
  & Pick<Types.IntegerFacet, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_IntroCopy = (
  { __typename?: 'IntroCopy' }
  & Pick<Types.IntroCopy, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_IntroCopyFolder = (
  { __typename?: 'IntroCopyFolder' }
  & Pick<Types.IntroCopyFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_InvestmentTrustAssetClass = (
  { __typename?: 'InvestmentTrustAssetClass' }
  & Pick<Types.InvestmentTrustAssetClass, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_InvestmentTrustAssetClassFolder = (
  { __typename?: 'InvestmentTrustAssetClassFolder' }
  & Pick<Types.InvestmentTrustAssetClassFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73 = (
  { __typename?: 'InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73' }
  & Pick<Types.InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb = (
  { __typename?: 'InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb' }
  & Pick<Types.InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_InvestmentTrustRegion = (
  { __typename?: 'InvestmentTrustRegion' }
  & Pick<Types.InvestmentTrustRegion, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_InvestmentTrustRegionFolder = (
  { __typename?: 'InvestmentTrustRegionFolder' }
  & Pick<Types.InvestmentTrustRegionFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_InvestmentTrustStyle = (
  { __typename?: 'InvestmentTrustStyle' }
  & Pick<Types.InvestmentTrustStyle, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_InvestmentTrustStyleFolder = (
  { __typename?: 'InvestmentTrustStyleFolder' }
  & Pick<Types.InvestmentTrustStyleFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_InvestorType = (
  { __typename?: 'InvestorType' }
  & Pick<Types.InvestorType, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_InvestorTypesFolder = (
  { __typename?: 'InvestorTypesFolder' }
  & Pick<Types.InvestorTypesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ItemQueriesFolder = (
  { __typename?: 'ItemQueriesFolder' }
  & Pick<Types.ItemQueriesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ItemRights = (
  { __typename?: 'ItemRights' }
  & Pick<Types.ItemRights, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSBeaconSettings = (
  { __typename?: 'JSBeaconSettings' }
  & Pick<Types.JsBeaconSettings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSONCheckbox = (
  { __typename?: 'JSONCheckbox' }
  & Pick<Types.JsonCheckbox, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSONContent = (
  { __typename?: 'JSONContent' }
  & Pick<Types.JsonContent, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSONDate = (
  { __typename?: 'JSONDate' }
  & Pick<Types.JsonDate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSONFile = (
  { __typename?: 'JSONFile' }
  & Pick<Types.JsonFile, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSONImage = (
  { __typename?: 'JSONImage' }
  & Pick<Types.JsonImage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSONLayout = (
  { __typename?: 'JSONLayout' }
  & Pick<Types.JsonLayout, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSONList = (
  { __typename?: 'JSONList' }
  & Pick<Types.JsonList, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSONMultilistReference = (
  { __typename?: 'JSONMultilistReference' }
  & Pick<Types.JsonMultilistReference, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSONPlaceholder = (
  { __typename?: 'JSONPlaceholder' }
  & Pick<Types.JsonPlaceholder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSONQuery = (
  { __typename?: 'JSONQuery' }
  & Pick<Types.JsonQuery, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSONResults = (
  { __typename?: 'JSONResults' }
  & Pick<Types.JsonResults, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSONRichText = (
  { __typename?: 'JSONRichText' }
  & Pick<Types.JsonRichText, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSONScriban = (
  { __typename?: 'JSONScriban' }
  & Pick<Types.JsonScriban, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSONSection = (
  { __typename?: 'JSONSection' }
  & Pick<Types.JsonSection, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSONTemplate = (
  { __typename?: 'JSONTemplate' }
  & Pick<Types.JsonTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSONText = (
  { __typename?: 'JSONText' }
  & Pick<Types.JsonText, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSONToken = (
  { __typename?: 'JSONToken' }
  & Pick<Types.JsonToken, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSONVariantDefinition = (
  { __typename?: 'JSONVariantDefinition' }
  & Pick<Types.JsonVariantDefinition, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSONVariants = (
  { __typename?: 'JSONVariants' }
  & Pick<Types.JsonVariants, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSSLayout = (
  { __typename?: 'JSSLayout' }
  & Pick<Types.JssLayout, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0 = (
  { __typename?: 'JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0' }
  & Pick<Types.JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSSSettings_6b328292f8314ab79885d89a054ca10a = (
  { __typename?: 'JSSSettings_6b328292f8314ab79885d89a054ca10a' }
  & Pick<Types.JssSettings_6b328292f8314ab79885d89a054ca10a, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSSSettings_457c9d0b61b84adfaf7f82561ed275ff = (
  { __typename?: 'JSSSettings_457c9d0b61b84adfaf7f82561ed275ff' }
  & Pick<Types.JssSettings_457c9d0b61b84adfaf7f82561ed275ff, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSSSettings_5045bf85d2ea430b9f41c2e348436e5d = (
  { __typename?: 'JSSSettings_5045bf85d2ea430b9f41c2e348436e5d' }
  & Pick<Types.JssSettings_5045bf85d2ea430b9f41c2e348436e5d, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5 = (
  { __typename?: 'JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5' }
  & Pick<Types.JssSettings_A767f80d5ad44bfbb8b750a8da144cb5, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSSSettings_b001fd725bb1476496825a8cb9e995cd = (
  { __typename?: 'JSSSettings_b001fd725bb1476496825a8cb9e995cd' }
  & Pick<Types.JssSettings_B001fd725bb1476496825a8cb9e995cd, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSSSettings_c643bc8630d14d61a173c7870f5dbbad = (
  { __typename?: 'JSSSettings_c643bc8630d14d61a173c7870f5dbbad' }
  & Pick<Types.JssSettings_C643bc8630d14d61a173c7870f5dbbad, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2 = (
  { __typename?: 'JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2' }
  & Pick<Types.JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSSSettings_ef855d0ba8b04a8e87851d1298266d90 = (
  { __typename?: 'JSSSettings_ef855d0ba8b04a8e87851d1298266d90' }
  & Pick<Types.JssSettings_Ef855d0ba8b04a8e87851d1298266d90, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSSSiteGrouping = (
  { __typename?: 'JSSSiteGrouping' }
  & Pick<Types.JssSiteGrouping, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JSSTenantFolder = (
  { __typename?: 'JSSTenantFolder' }
  & Pick<Types.JssTenantFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JavaScriptRendering = (
  { __typename?: 'JavaScriptRendering' }
  & Pick<Types.JavaScriptRendering, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JsonRendering = (
  { __typename?: 'JsonRendering' }
  & Pick<Types.JsonRendering, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JurisdictionStatus = (
  { __typename?: 'JurisdictionStatus' }
  & Pick<Types.JurisdictionStatus, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_JurisdictionsFolder = (
  { __typename?: 'JurisdictionsFolder' }
  & Pick<Types.JurisdictionsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_KeyHighlightItem = (
  { __typename?: 'KeyHighlightItem' }
  & Pick<Types.KeyHighlightItem, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_KeyHighlights = (
  { __typename?: 'KeyHighlights' }
  & Pick<Types.KeyHighlights, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_KeyHighlightsFolder = (
  { __typename?: 'KeyHighlightsFolder' }
  & Pick<Types.KeyHighlightsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_KeyHighlightsParametersTemplate = (
  { __typename?: 'KeyHighlightsParametersTemplate' }
  & Pick<Types.KeyHighlightsParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Language = (
  { __typename?: 'Language' }
  & Pick<Types.Language, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LanguageSelector = (
  { __typename?: 'LanguageSelector' }
  & Pick<Types.LanguageSelector, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LanguagesFolder = (
  { __typename?: 'LanguagesFolder' }
  & Pick<Types.LanguagesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LatestPressReleasesParametersTemplate = (
  { __typename?: 'LatestPressReleasesParametersTemplate' }
  & Pick<Types.LatestPressReleasesParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LayoutServiceVariants = (
  { __typename?: 'LayoutServiceVariants' }
  & Pick<Types.LayoutServiceVariants, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LimitedDisplayFolder = (
  { __typename?: 'LimitedDisplayFolder' }
  & Pick<Types.LimitedDisplayFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LimitedDisplayOption = (
  { __typename?: 'LimitedDisplayOption' }
  & Pick<Types.LimitedDisplayOption, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Link = (
  { __typename?: 'Link' }
  & Pick<Types.Link, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LinkList = (
  { __typename?: 'LinkList' }
  & Pick<Types.LinkList, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LinkListFolder = (
  { __typename?: 'LinkListFolder' }
  & Pick<Types.LinkListFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LinkListFolder_c237d144647a4afeaa7b1570f3e3f139 = (
  { __typename?: 'LinkListFolder_c237d144647a4afeaa7b1570f3e3f139' }
  & Pick<Types.LinkListFolder_C237d144647a4afeaa7b1570f3e3f139, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LinkList_33c9207e3b0446068ef54ca99a97c776 = (
  { __typename?: 'LinkList_33c9207e3b0446068ef54ca99a97c776' }
  & Pick<Types.LinkList_33c9207e3b0446068ef54ca99a97c776, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LinkList_97a593ad273141dc80bfceb5ef6a33b7 = (
  { __typename?: 'LinkList_97a593ad273141dc80bfceb5ef6a33b7' }
  & Pick<Types.LinkList_97a593ad273141dc80bfceb5ef6a33b7, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LinkList_f7561ffcc0d8477fb53d2703a4060be1 = (
  { __typename?: 'LinkList_f7561ffcc0d8477fb53d2703a4060be1' }
  & Pick<Types.LinkList_F7561ffcc0d8477fb53d2703a4060be1, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Link_68bd1cb5a7624a969ac6cb16ab5882a3 = (
  { __typename?: 'Link_68bd1cb5a7624a969ac6cb16ab5882a3' }
  & Pick<Types.Link_68bd1cb5a7624a969ac6cb16ab5882a3, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Link_930f134d56784b35bfd1b77f9d0115f1 = (
  { __typename?: 'Link_930f134d56784b35bfd1b77f9d0115f1' }
  & Pick<Types.Link_930f134d56784b35bfd1b77f9d0115f1, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Link_e24e0789a05848bfabb6c69c0e60b6b7 = (
  { __typename?: 'Link_e24e0789a05848bfabb6c69c0e60b6b7' }
  & Pick<Types.Link_E24e0789a05848bfabb6c69c0e60b6b7, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LinksFolder = (
  { __typename?: 'LinksFolder' }
  & Pick<Types.LinksFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_List = (
  { __typename?: 'List' }
  & Pick<Types.List, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ListFacet = (
  { __typename?: 'ListFacet' }
  & Pick<Types.ListFacet, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ListFolder = (
  { __typename?: 'ListFolder' }
  & Pick<Types.ListFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ListItem = (
  { __typename?: 'ListItem' }
  & Pick<Types.ListItem, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ListParametersTemplate = (
  { __typename?: 'ListParametersTemplate' }
  & Pick<Types.ListParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ListStyle = (
  { __typename?: 'ListStyle' }
  & Pick<Types.ListStyle, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ListStyleItem = (
  { __typename?: 'ListStyleItem' }
  & Pick<Types.ListStyleItem, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ListingHeroBanner = (
  { __typename?: 'ListingHeroBanner' }
  & Pick<Types.ListingHeroBanner, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ListingHeroParametersTemplate = (
  { __typename?: 'ListingHeroParametersTemplate' }
  & Pick<Types.ListingHeroParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LiteratureAuthorization = (
  { __typename?: 'LiteratureAuthorization' }
  & Pick<Types.LiteratureAuthorization, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LiteratureAuthorizationsFolder = (
  { __typename?: 'LiteratureAuthorizationsFolder' }
  & Pick<Types.LiteratureAuthorizationsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage = (
  { __typename?: 'LiteratureHubSearchPage' }
  & Pick<Types.LiteratureHubSearchPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d = (
  { __typename?: 'LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d' }
  & Pick<Types.LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e = (
  { __typename?: 'LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e' }
  & Pick<Types.LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea = (
  { __typename?: 'LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea' }
  & Pick<Types.LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0ea, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LoadMore = (
  { __typename?: 'LoadMore' }
  & Pick<Types.LoadMore, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LoadMoreFolder = (
  { __typename?: 'LoadMoreFolder' }
  & Pick<Types.LoadMoreFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LoadMore_7a3a53e06a0144ff8ba52be46e201fe6 = (
  { __typename?: 'LoadMore_7a3a53e06a0144ff8ba52be46e201fe6' }
  & Pick<Types.LoadMore_7a3a53e06a0144ff8ba52be46e201fe6, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LocationFilter = (
  { __typename?: 'LocationFilter' }
  & Pick<Types.LocationFilter, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LocationFilterFolder = (
  { __typename?: 'LocationFilterFolder' }
  & Pick<Types.LocationFilterFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LocationFilter_aaad4aad290744dc90b69e4e83a661ec = (
  { __typename?: 'LocationFilter_aaad4aad290744dc90b69e4e83a661ec' }
  & Pick<Types.LocationFilter_Aaad4aad290744dc90b69e4e83a661ec, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Log = (
  { __typename?: 'Log' }
  & Pick<Types.Log, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Login = (
  { __typename?: 'Login' }
  & Pick<Types.Login, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Login_abed54dc4f7840ddac562289c9c849d8 = (
  { __typename?: 'Login_abed54dc4f7840ddac562289c9c849d8' }
  & Pick<Types.Login_Abed54dc4f7840ddac562289c9c849d8, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LogoTextBlockItem = (
  { __typename?: 'LogoTextBlockItem' }
  & Pick<Types.LogoTextBlockItem, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LogoTextBlocks = (
  { __typename?: 'LogoTextBlocks' }
  & Pick<Types.LogoTextBlocks, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_LogoTextBlocksFolder = (
  { __typename?: 'LogoTextBlocksFolder' }
  & Pick<Types.LogoTextBlocksFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Logout = (
  { __typename?: 'Logout' }
  & Pick<Types.Logout, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Logout_c2294d8235a6452a94b15eb5e543b602 = (
  { __typename?: 'Logout_c2294d8235a6452a94b15eb5e543b602' }
  & Pick<Types.Logout_C2294d8235a6452a94b15eb5e543b602, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ManagedRangeFilter = (
  { __typename?: 'ManagedRangeFilter' }
  & Pick<Types.ManagedRangeFilter, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ManagedRangeFilterFolder = (
  { __typename?: 'ManagedRangeFilterFolder' }
  & Pick<Types.ManagedRangeFilterFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91 = (
  { __typename?: 'ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91' }
  & Pick<Types.ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ManagedRangeItem = (
  { __typename?: 'ManagedRangeItem' }
  & Pick<Types.ManagedRangeItem, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Map = (
  { __typename?: 'Map' }
  & Pick<Types.Map, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_MapParameters = (
  { __typename?: 'MapParameters' }
  & Pick<Types.MapParameters, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_MapsFolder = (
  { __typename?: 'MapsFolder' }
  & Pick<Types.MapsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_MapsProvider = (
  { __typename?: 'MapsProvider' }
  & Pick<Types.MapsProvider, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_MediaBlock = (
  { __typename?: 'MediaBlock' }
  & Pick<Types.MediaBlock, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_MediaBlockFolder = (
  { __typename?: 'MediaBlockFolder' }
  & Pick<Types.MediaBlockFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_MediaBlockParametersTemplate = (
  { __typename?: 'MediaBlockParametersTemplate' }
  & Pick<Types.MediaBlockParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_MediaFolder_81150e5837f5443fa3c075e14a9321e7 = (
  { __typename?: 'MediaFolder_81150e5837f5443fa3c075e14a9321e7' }
  & Pick<Types.MediaFolder_81150e5837f5443fa3c075e14a9321e7, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_MediaLinkParameters = (
  { __typename?: 'MediaLinkParameters' }
  & Pick<Types.MediaLinkParameters, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_MediaVirtualFolder = (
  { __typename?: 'MediaVirtualFolder' }
  & Pick<Types.MediaVirtualFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_MegaNavigation = (
  { __typename?: 'MegaNavigation' }
  & Pick<Types.MegaNavigation, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_MegaNavigationFolder = (
  { __typename?: 'MegaNavigationFolder' }
  & Pick<Types.MegaNavigationFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_MetaBranding = (
  { __typename?: 'MetaBranding' }
  & Pick<Types.MetaBranding, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_MetaRenderingParameters = (
  { __typename?: 'MetaRenderingParameters' }
  & Pick<Types.MetaRenderingParameters, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_MetadataPartialDesign = (
  { __typename?: 'MetadataPartialDesign' }
  & Pick<Types.MetadataPartialDesign, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Model = (
  { __typename?: 'Model' }
  & Pick<Types.Model, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ModelIterator = (
  { __typename?: 'ModelIterator' }
  & Pick<Types.ModelIterator, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_MyLocationPOI = (
  { __typename?: 'MyLocationPOI' }
  & Pick<Types.MyLocationPoi, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Navigation = (
  { __typename?: 'Navigation' }
  & Pick<Types.Navigation, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_NavigationCategory = (
  { __typename?: 'NavigationCategory' }
  & Pick<Types.NavigationCategory, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_NavigationFilter = (
  { __typename?: 'NavigationFilter' }
  & Pick<Types.NavigationFilter, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_NavigationFilterFolder = (
  { __typename?: 'NavigationFilterFolder' }
  & Pick<Types.NavigationFilterFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_NavigationLink = (
  { __typename?: 'NavigationLink' }
  & Pick<Types.NavigationLink, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_NavigationSubcategory = (
  { __typename?: 'NavigationSubcategory' }
  & Pick<Types.NavigationSubcategory, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Navigation_9ce34bf95c934dff841d8f649c2bd6c8 = (
  { __typename?: 'Navigation_9ce34bf95c934dff841d8f649c2bd6c8' }
  & Pick<Types.Navigation_9ce34bf95c934dff841d8f649c2bd6c8, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_OneTrustSettings = (
  { __typename?: 'OneTrustSettings' }
  & Pick<Types.OneTrustSettings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_OptimiserConfiguration = (
  { __typename?: 'OptimiserConfiguration' }
  & Pick<Types.OptimiserConfiguration, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_OptimiserConfigurationSection = (
  { __typename?: 'OptimiserConfigurationSection' }
  & Pick<Types.OptimiserConfigurationSection, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_OptimizedFile = (
  { __typename?: 'OptimizedFile' }
  & Pick<Types.OptimizedFile, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_OracleCDPSettings = (
  { __typename?: 'OracleCDPSettings' }
  & Pick<Types.OracleCdpSettings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_OverlayContent = (
  { __typename?: 'OverlayContent' }
  & Pick<Types.OverlayContent, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_OverlayFolderTemplate = (
  { __typename?: 'OverlayFolderTemplate' }
  & Pick<Types.OverlayFolderTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Ownership = (
  { __typename?: 'Ownership' }
  & Pick<Types.Ownership, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_OwnershipFolder = (
  { __typename?: 'OwnershipFolder' }
  & Pick<Types.OwnershipFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_POI = (
  { __typename?: 'POI' }
  & Pick<Types.Poi, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_POIFolder = (
  { __typename?: 'POIFolder' }
  & Pick<Types.PoiFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_POIType = (
  { __typename?: 'POIType' }
  & Pick<Types.PoiType, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_POIs = (
  { __typename?: 'POIs' }
  & Pick<Types.PoIs, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageBranchesFolder = (
  { __typename?: 'PageBranchesFolder' }
  & Pick<Types.PageBranchesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageContent = (
  { __typename?: 'PageContent' }
  & Pick<Types.PageContent, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageContentFolder = (
  { __typename?: 'PageContentFolder' }
  & Pick<Types.PageContentFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageContent_ef87e73bc7ff49a2ac599b0be83755c3 = (
  { __typename?: 'PageContent_ef87e73bc7ff49a2ac599b0be83755c3' }
  & Pick<Types.PageContent_Ef87e73bc7ff49a2ac599b0be83755c3, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesign = (
  { __typename?: 'PageDesign' }
  & Pick<Types.PageDesign, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0 = (
  { __typename?: 'PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0' }
  & Pick<Types.PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesignFolder_27d4f8be63b045769a4ef3163c935b47 = (
  { __typename?: 'PageDesignFolder_27d4f8be63b045769a4ef3163c935b47' }
  & Pick<Types.PageDesignFolder_27d4f8be63b045769a4ef3163c935b47, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8 = (
  { __typename?: 'PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8' }
  & Pick<Types.PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b = (
  { __typename?: 'PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b' }
  & Pick<Types.PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesignFolder_720d01f11e5046fa9c4a697f9321f662 = (
  { __typename?: 'PageDesignFolder_720d01f11e5046fa9c4a697f9321f662' }
  & Pick<Types.PageDesignFolder_720d01f11e5046fa9c4a697f9321f662, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesignFolder_771a0de7e83f44338c5d78727ead93bc = (
  { __typename?: 'PageDesignFolder_771a0de7e83f44338c5d78727ead93bc' }
  & Pick<Types.PageDesignFolder_771a0de7e83f44338c5d78727ead93bc, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesignFolder_14161ec204984aa7a2a46decadf669f5 = (
  { __typename?: 'PageDesignFolder_14161ec204984aa7a2a46decadf669f5' }
  & Pick<Types.PageDesignFolder_14161ec204984aa7a2a46decadf669f5, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb = (
  { __typename?: 'PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb' }
  & Pick<Types.PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cb, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesignFolder_d84605f786ea482da6ff683f6572821c = (
  { __typename?: 'PageDesignFolder_d84605f786ea482da6ff683f6572821c' }
  & Pick<Types.PageDesignFolder_D84605f786ea482da6ff683f6572821c, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesign_1105b8f81e00426bbf1fc840742d827b = (
  { __typename?: 'PageDesign_1105b8f81e00426bbf1fc840742d827b' }
  & Pick<Types.PageDesign_1105b8f81e00426bbf1fc840742d827b, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesigns = (
  { __typename?: 'PageDesigns' }
  & Pick<Types.PageDesigns, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesigns_3af52e70e982424b9c85e355542500c9 = (
  { __typename?: 'PageDesigns_3af52e70e982424b9c85e355542500c9' }
  & Pick<Types.PageDesigns_3af52e70e982424b9c85e355542500c9, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesigns_9b34083e890b467d8e76b8c3dbbb712d = (
  { __typename?: 'PageDesigns_9b34083e890b467d8e76b8c3dbbb712d' }
  & Pick<Types.PageDesigns_9b34083e890b467d8e76b8c3dbbb712d, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesigns_48d2d50a150c4f6283603a4fed5646e0 = (
  { __typename?: 'PageDesigns_48d2d50a150c4f6283603a4fed5646e0' }
  & Pick<Types.PageDesigns_48d2d50a150c4f6283603a4fed5646e0, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesigns_99a71bba507746729c3fb29b04abee23 = (
  { __typename?: 'PageDesigns_99a71bba507746729c3fb29b04abee23' }
  & Pick<Types.PageDesigns_99a71bba507746729c3fb29b04abee23, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesigns_a0f265b42d6241968b65d3ede7cb59c3 = (
  { __typename?: 'PageDesigns_a0f265b42d6241968b65d3ede7cb59c3' }
  & Pick<Types.PageDesigns_A0f265b42d6241968b65d3ede7cb59c3, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesigns_abe5ce6a82ff4433b4973bc50f192e11 = (
  { __typename?: 'PageDesigns_abe5ce6a82ff4433b4973bc50f192e11' }
  & Pick<Types.PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesigns_b8d9b352c1694b31bd506848b47ca884 = (
  { __typename?: 'PageDesigns_b8d9b352c1694b31bd506848b47ca884' }
  & Pick<Types.PageDesigns_B8d9b352c1694b31bd506848b47ca884, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesigns_d3b2e1466f744df0900bec314f699ef3 = (
  { __typename?: 'PageDesigns_d3b2e1466f744df0900bec314f699ef3' }
  & Pick<Types.PageDesigns_D3b2e1466f744df0900bec314f699ef3, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe = (
  { __typename?: 'PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe' }
  & Pick<Types.PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbe, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageLevelTabs = (
  { __typename?: 'PageLevelTabs' }
  & Pick<Types.PageLevelTabs, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageLevelTabsFolder = (
  { __typename?: 'PageLevelTabsFolder' }
  & Pick<Types.PageLevelTabsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageList = (
  { __typename?: 'PageList' }
  & Pick<Types.PageList, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageSelector = (
  { __typename?: 'PageSelector' }
  & Pick<Types.PageSelector, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageSelectorConfiguration = (
  { __typename?: 'PageSelectorConfiguration' }
  & Pick<Types.PageSelectorConfiguration, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageSelectorFolder = (
  { __typename?: 'PageSelectorFolder' }
  & Pick<Types.PageSelectorFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageSelector_59a7bb775f8c435ab810291abde80e63 = (
  { __typename?: 'PageSelector_59a7bb775f8c435ab810291abde80e63' }
  & Pick<Types.PageSelector_59a7bb775f8c435ab810291abde80e63, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageSize = (
  { __typename?: 'PageSize' }
  & Pick<Types.PageSize, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageSizeFolder = (
  { __typename?: 'PageSizeFolder' }
  & Pick<Types.PageSizeFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageSize_b682562e0af64b3e9e3b45273bbe152d = (
  { __typename?: 'PageSize_b682562e0af64b3e9e3b45273bbe152d' }
  & Pick<Types.PageSize_B682562e0af64b3e9e3b45273bbe152d, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageTheme = (
  { __typename?: 'PageTheme' }
  & Pick<Types.PageTheme, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PageThemesFolder = (
  { __typename?: 'PageThemesFolder' }
  & Pick<Types.PageThemesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Page_4f49a81db3664f198b89cab92f377d7a = (
  { __typename?: 'Page_4f49a81db3664f198b89cab92f377d7a' }
  & Pick<Types.Page_4f49a81db3664f198b89cab92f377d7a, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Page_5e66d86353544fe6a27d3b894984d50f = (
  { __typename?: 'Page_5e66d86353544fe6a27d3b894984d50f' }
  & Pick<Types.Page_5e66d86353544fe6a27d3b894984d50f, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Page_84f342ad2d0646b9aa9a818201145ca2 = (
  { __typename?: 'Page_84f342ad2d0646b9aa9a818201145ca2' }
  & Pick<Types.Page_84f342ad2d0646b9aa9a818201145ca2, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Page_718df200be51463d93edf4d77ab7a49e = (
  { __typename?: 'Page_718df200be51463d93edf4d77ab7a49e' }
  & Pick<Types.Page_718df200be51463d93edf4d77ab7a49e, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Page_b61d5babe46f4ef39f27b57c4ccefdf7 = (
  { __typename?: 'Page_b61d5babe46f4ef39f27b57c4ccefdf7' }
  & Pick<Types.Page_B61d5babe46f4ef39f27b57c4ccefdf7, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Page_cfd6e04697e24f3cb9eb41b79afc35dc = (
  { __typename?: 'Page_cfd6e04697e24f3cb9eb41b79afc35dc' }
  & Pick<Types.Page_Cfd6e04697e24f3cb9eb41b79afc35dc, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Page_dae7821153e14dbabb0ddf0b53a90aaf = (
  { __typename?: 'Page_dae7821153e14dbabb0ddf0b53a90aaf' }
  & Pick<Types.Page_Dae7821153e14dbabb0ddf0b53a90aaf, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Page_fa608b3e6aeb426388a059d89caabada = (
  { __typename?: 'Page_fa608b3e6aeb426388a059d89caabada' }
  & Pick<Types.Page_Fa608b3e6aeb426388a059d89caabada, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Pagging = (
  { __typename?: 'Pagging' }
  & Pick<Types.Pagging, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Pagination = (
  { __typename?: 'Pagination' }
  & Pick<Types.Pagination, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PaginationFolder = (
  { __typename?: 'PaginationFolder' }
  & Pick<Types.PaginationFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Paragraph = (
  { __typename?: 'Paragraph' }
  & Pick<Types.Paragraph, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_8cf20a4412b746ee801218122c955b2d = (
  { __typename?: 'PartialDesignFolder_8cf20a4412b746ee801218122c955b2d' }
  & Pick<Types.PartialDesignFolder_8cf20a4412b746ee801218122c955b2d, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b = (
  { __typename?: 'PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b' }
  & Pick<Types.PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8 = (
  { __typename?: 'PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8' }
  & Pick<Types.PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b = (
  { __typename?: 'PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b' }
  & Pick<Types.PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_828b5ff144cd4150bcdfe54084165112 = (
  { __typename?: 'PartialDesignFolder_828b5ff144cd4150bcdfe54084165112' }
  & Pick<Types.PartialDesignFolder_828b5ff144cd4150bcdfe54084165112, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_89098e3089aa4062a77346d608caac90 = (
  { __typename?: 'PartialDesignFolder_89098e3089aa4062a77346d608caac90' }
  & Pick<Types.PartialDesignFolder_89098e3089aa4062a77346d608caac90, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_1695576fb93647d7842ed17730278c32 = (
  { __typename?: 'PartialDesignFolder_1695576fb93647d7842ed17730278c32' }
  & Pick<Types.PartialDesignFolder_1695576fb93647d7842ed17730278c32, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc = (
  { __typename?: 'PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc' }
  & Pick<Types.PartialDesignFolder_F16ae56fb78845639407c88edaffcbcc, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a = (
  { __typename?: 'PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a' }
  & Pick<Types.PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21a, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesign_fd2059fd60434dfe8c04e2437ce87634 = (
  { __typename?: 'PartialDesign_fd2059fd60434dfe8c04e2437ce87634' }
  & Pick<Types.PartialDesign_Fd2059fd60434dfe8c04e2437ce87634, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesigns = (
  { __typename?: 'PartialDesigns' }
  & Pick<Types.PartialDesigns, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesigns_043d3ad0ac4445dba03afc3550d088ec = (
  { __typename?: 'PartialDesigns_043d3ad0ac4445dba03afc3550d088ec' }
  & Pick<Types.PartialDesigns_043d3ad0ac4445dba03afc3550d088ec, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesigns_0310a4bf20d1441c886a0418c53e30f4 = (
  { __typename?: 'PartialDesigns_0310a4bf20d1441c886a0418c53e30f4' }
  & Pick<Types.PartialDesigns_0310a4bf20d1441c886a0418c53e30f4, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesigns_36c869ded22040929ce829f6ed643c66 = (
  { __typename?: 'PartialDesigns_36c869ded22040929ce829f6ed643c66' }
  & Pick<Types.PartialDesigns_36c869ded22040929ce829f6ed643c66, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesigns_1943dc73710a430895515a342c84b037 = (
  { __typename?: 'PartialDesigns_1943dc73710a430895515a342c84b037' }
  & Pick<Types.PartialDesigns_1943dc73710a430895515a342c84b037, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesigns_b1e2a6790a1442d8bafa66317b8be117 = (
  { __typename?: 'PartialDesigns_b1e2a6790a1442d8bafa66317b8be117' }
  & Pick<Types.PartialDesigns_B1e2a6790a1442d8bafa66317b8be117, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e = (
  { __typename?: 'PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e' }
  & Pick<Types.PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9e, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesigns_d52704ed3b704a53abb4292105f687ad = (
  { __typename?: 'PartialDesigns_d52704ed3b704a53abb4292105f687ad' }
  & Pick<Types.PartialDesigns_D52704ed3b704a53abb4292105f687ad, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesigns_d216303f58d8425688da8cd30d00afab = (
  { __typename?: 'PartialDesigns_d216303f58d8425688da8cd30d00afab' }
  & Pick<Types.PartialDesigns_D216303f58d8425688da8cd30d00afab, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesigns_facda26791204fa9a0363344348f2c42 = (
  { __typename?: 'PartialDesigns_facda26791204fa9a0363344348f2c42' }
  & Pick<Types.PartialDesigns_Facda26791204fa9a0363344348f2c42, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PerformanceChartSettings = (
  { __typename?: 'PerformanceChartSettings' }
  & Pick<Types.PerformanceChartSettings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PerformanceChartTimePeriod = (
  { __typename?: 'PerformanceChartTimePeriod' }
  & Pick<Types.PerformanceChartTimePeriod, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PerformanceChartTimePeriodFolder = (
  { __typename?: 'PerformanceChartTimePeriodFolder' }
  & Pick<Types.PerformanceChartTimePeriodFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80 = (
  { __typename?: 'PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80' }
  & Pick<Types.PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d = (
  { __typename?: 'PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d' }
  & Pick<Types.PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba = (
  { __typename?: 'PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba' }
  & Pick<Types.PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Placeholder_1ca0304be5b64810821154426f1752c2 = (
  { __typename?: 'Placeholder_1ca0304be5b64810821154426f1752c2' }
  & Pick<Types.Placeholder_1ca0304be5b64810821154426f1752c2, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Placeholder_d2a6884c04d54089a64ed27ca9d68d4c = (
  { __typename?: 'Placeholder_d2a6884c04d54089a64ed27ca9d68d4c' }
  & Pick<Types.Placeholder_D2a6884c04d54089a64ed27ca9d68d4c, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PlainHtmlParametersTemplate = (
  { __typename?: 'PlainHtmlParametersTemplate' }
  & Pick<Types.PlainHtmlParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Playlist = (
  { __typename?: 'Playlist' }
  & Pick<Types.Playlist, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PlaylistFolder = (
  { __typename?: 'PlaylistFolder' }
  & Pick<Types.PlaylistFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PlaylistParametersTemplate = (
  { __typename?: 'PlaylistParametersTemplate' }
  & Pick<Types.PlaylistParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Podcast = (
  { __typename?: 'Podcast' }
  & Pick<Types.Podcast, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PodcastFolder = (
  { __typename?: 'PodcastFolder' }
  & Pick<Types.PodcastFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PodcastPage = (
  { __typename?: 'PodcastPage' }
  & Pick<Types.PodcastPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PodcastPressReleasePage = (
  { __typename?: 'PodcastPressReleasePage' }
  & Pick<Types.PodcastPressReleasePage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PoiTypes = (
  { __typename?: 'PoiTypes' }
  & Pick<Types.PoiTypes, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PostDeleteStep = (
  { __typename?: 'PostDeleteStep' }
  & Pick<Types.PostDeleteStep, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574 = (
  { __typename?: 'PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574' }
  & Pick<Types.PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PostDeleteStep_78d6ec9b66e34763987003cf314ee37a = (
  { __typename?: 'PostDeleteStep_78d6ec9b66e34763987003cf314ee37a' }
  & Pick<Types.PostDeleteStep_78d6ec9b66e34763987003cf314ee37a, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PostDeleteStep_b20857895385413883f096f3767cb156 = (
  { __typename?: 'PostDeleteStep_b20857895385413883f096f3767cb156' }
  & Pick<Types.PostDeleteStep_B20857895385413883f096f3767cb156, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PostSetupStep = (
  { __typename?: 'PostSetupStep' }
  & Pick<Types.PostSetupStep, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PostSetupStep_6fac654e22154a419a1d59197bebc0fe = (
  { __typename?: 'PostSetupStep_6fac654e22154a419a1d59197bebc0fe' }
  & Pick<Types.PostSetupStep_6fac654e22154a419a1d59197bebc0fe, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f = (
  { __typename?: 'PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f' }
  & Pick<Types.PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PostSetupStep_341738aa44fe490e90ff7010a3c2463b = (
  { __typename?: 'PostSetupStep_341738aa44fe490e90ff7010a3c2463b' }
  & Pick<Types.PostSetupStep_341738aa44fe490e90ff7010a3c2463b, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PreDeleteStep = (
  { __typename?: 'PreDeleteStep' }
  & Pick<Types.PreDeleteStep, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49 = (
  { __typename?: 'PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49' }
  & Pick<Types.PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b = (
  { __typename?: 'PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b' }
  & Pick<Types.PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PreDeleteStep_f0daf401190f45468bda8568d08e161d = (
  { __typename?: 'PreDeleteStep_f0daf401190f45468bda8568d08e161d' }
  & Pick<Types.PreDeleteStep_F0daf401190f45468bda8568d08e161d, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep = (
  { __typename?: 'PreDeleteValidationStep' }
  & Pick<Types.PreDeleteValidationStep, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f = (
  { __typename?: 'PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f' }
  & Pick<Types.PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f = (
  { __typename?: 'PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f' }
  & Pick<Types.PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8f, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e = (
  { __typename?: 'PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e' }
  & Pick<Types.PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1e, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Presentation = (
  { __typename?: 'Presentation' }
  & Pick<Types.Presentation, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Presentation_0a70fa7389234a6eabf34134f25f3221 = (
  { __typename?: 'Presentation_0a70fa7389234a6eabf34134f25f3221' }
  & Pick<Types.Presentation_0a70fa7389234a6eabf34134f25f3221, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseContentType = (
  { __typename?: 'PressReleaseContentType' }
  & Pick<Types.PressReleaseContentType, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseContentTypesFolder = (
  { __typename?: 'PressReleaseContentTypesFolder' }
  & Pick<Types.PressReleaseContentTypesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseFilter = (
  { __typename?: 'PressReleaseFilter' }
  & Pick<Types.PressReleaseFilter, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleasePage = (
  { __typename?: 'PressReleasePage' }
  & Pick<Types.PressReleasePage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleasePlatform = (
  { __typename?: 'PressReleasePlatform' }
  & Pick<Types.PressReleasePlatform, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleasePlatformsFolder = (
  { __typename?: 'PressReleasePlatformsFolder' }
  & Pick<Types.PressReleasePlatformsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage = (
  { __typename?: 'PressReleaseSearchPage' }
  & Pick<Types.PressReleaseSearchPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f = (
  { __typename?: 'PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f' }
  & Pick<Types.PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72 = (
  { __typename?: 'PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72' }
  & Pick<Types.PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d = (
  { __typename?: 'PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d' }
  & Pick<Types.PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64d, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58 = (
  { __typename?: 'PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58' }
  & Pick<Types.PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage = (
  { __typename?: 'PressReleaseWildcardPage' }
  & Pick<Types.PressReleaseWildcardPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e = (
  { __typename?: 'PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e' }
  & Pick<Types.PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79 = (
  { __typename?: 'PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79' }
  & Pick<Types.PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1 = (
  { __typename?: 'PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1' }
  & Pick<Types.PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258 = (
  { __typename?: 'PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258' }
  & Pick<Types.PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleasesGroupFolder = (
  { __typename?: 'PressReleasesGroupFolder' }
  & Pick<Types.PressReleasesGroupFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PrivacyWarning = (
  { __typename?: 'PrivacyWarning' }
  & Pick<Types.PrivacyWarning, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ProjectFolder = (
  { __typename?: 'ProjectFolder' }
  & Pick<Types.ProjectFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Promo = (
  { __typename?: 'Promo' }
  & Pick<Types.Promo, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PromoFolder = (
  { __typename?: 'PromoFolder' }
  & Pick<Types.PromoFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PromoFolder_f07cbe8973ae4de692172570260cac6e = (
  { __typename?: 'PromoFolder_f07cbe8973ae4de692172570260cac6e' }
  & Pick<Types.PromoFolder_F07cbe8973ae4de692172570260cac6e, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Promo_7f21f14d096b4f27bbccf115c6e6f6f1 = (
  { __typename?: 'Promo_7f21f14d096b4f27bbccf115c6e6f6f1' }
  & Pick<Types.Promo_7f21f14d096b4f27bbccf115c6e6f6f1, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Promo_881869ca7f5845ea8b34ad1bfd3551a8 = (
  { __typename?: 'Promo_881869ca7f5845ea8b34ad1bfd3551a8' }
  & Pick<Types.Promo_881869ca7f5845ea8b34ad1bfd3551a8, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Promo_dfed4457d760457abec1c0dccdc44381 = (
  { __typename?: 'Promo_dfed4457d760457abec1c0dccdc44381' }
  & Pick<Types.Promo_Dfed4457d760457abec1c0dccdc44381, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PromotedContent = (
  { __typename?: 'PromotedContent' }
  & Pick<Types.PromotedContent, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PromotedContentFolder = (
  { __typename?: 'PromotedContentFolder' }
  & Pick<Types.PromotedContentFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PropertyListingCard = (
  { __typename?: 'PropertyListingCard' }
  & Pick<Types.PropertyListingCard, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PropertyListingCards = (
  { __typename?: 'PropertyListingCards' }
  & Pick<Types.PropertyListingCards, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PropertyListingCategory = (
  { __typename?: 'PropertyListingCategory' }
  & Pick<Types.PropertyListingCategory, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_PropertyListingFolder = (
  { __typename?: 'PropertyListingFolder' }
  & Pick<Types.PropertyListingFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Query_98b413525a4b4067b92418a4b50f0a53 = (
  { __typename?: 'Query_98b413525a4b4067b92418a4b50f0a53' }
  & Pick<Types.Query_98b413525a4b4067b92418a4b50f0a53, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_QuickLinks = (
  { __typename?: 'QuickLinks' }
  & Pick<Types.QuickLinks, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_QuickLinksFolder = (
  { __typename?: 'QuickLinksFolder' }
  & Pick<Types.QuickLinksFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_QuickLinksParametersTemplate = (
  { __typename?: 'QuickLinksParametersTemplate' }
  & Pick<Types.QuickLinksParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_QuotationBlockItem = (
  { __typename?: 'QuotationBlockItem' }
  & Pick<Types.QuotationBlockItem, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_QuotationBlocks = (
  { __typename?: 'QuotationBlocks' }
  & Pick<Types.QuotationBlocks, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_QuotationBlocksFolder = (
  { __typename?: 'QuotationBlocksFolder' }
  & Pick<Types.QuotationBlocksFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_QuotationBlocksParametersTemplate = (
  { __typename?: 'QuotationBlocksParametersTemplate' }
  & Pick<Types.QuotationBlocksParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Quote = (
  { __typename?: 'Quote' }
  & Pick<Types.Quote, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_QuoteFolder = (
  { __typename?: 'QuoteFolder' }
  & Pick<Types.QuoteFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_QuoteParametersTemplate = (
  { __typename?: 'QuoteParametersTemplate' }
  & Pick<Types.QuoteParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RadiusFilter = (
  { __typename?: 'RadiusFilter' }
  & Pick<Types.RadiusFilter, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RadiusFilterFolder = (
  { __typename?: 'RadiusFilterFolder' }
  & Pick<Types.RadiusFilterFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64 = (
  { __typename?: 'RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64' }
  & Pick<Types.RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RadiusScheme = (
  { __typename?: 'RadiusScheme' }
  & Pick<Types.RadiusScheme, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RadiusSchemeValue = (
  { __typename?: 'RadiusSchemeValue' }
  & Pick<Types.RadiusSchemeValue, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RangeSliderFilter = (
  { __typename?: 'RangeSliderFilter' }
  & Pick<Types.RangeSliderFilter, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RangeSliderFilterFolder = (
  { __typename?: 'RangeSliderFilterFolder' }
  & Pick<Types.RangeSliderFilterFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RangeSliderFilter_0a1787c296b54d40828522564a5d8e03 = (
  { __typename?: 'RangeSliderFilter_0a1787c296b54d40828522564a5d8e03' }
  & Pick<Types.RangeSliderFilter_0a1787c296b54d40828522564a5d8e03, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RecentArticles = (
  { __typename?: 'RecentArticles' }
  & Pick<Types.RecentArticles, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Redirect = (
  { __typename?: 'Redirect' }
  & Pick<Types.Redirect, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RedirectMap = (
  { __typename?: 'RedirectMap' }
  & Pick<Types.RedirectMap, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RedirectMaps = (
  { __typename?: 'RedirectMaps' }
  & Pick<Types.RedirectMaps, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Region = (
  { __typename?: 'Region' }
  & Pick<Types.Region, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RegionLanguages = (
  { __typename?: 'RegionLanguages' }
  & Pick<Types.RegionLanguages, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RegionLanguagesFolder = (
  { __typename?: 'RegionLanguagesFolder' }
  & Pick<Types.RegionLanguagesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RelatedArticles = (
  { __typename?: 'RelatedArticles' }
  & Pick<Types.RelatedArticles, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RelatedArticlesParametersTemplate = (
  { __typename?: 'RelatedArticlesParametersTemplate' }
  & Pick<Types.RelatedArticlesParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RenderEngineType = (
  { __typename?: 'RenderEngineType' }
  & Pick<Types.RenderEngineType, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RenderingFolder_840d4a46550349ecbf9dbd090946c63d = (
  { __typename?: 'RenderingFolder_840d4a46550349ecbf9dbd090946c63d' }
  & Pick<Types.RenderingFolder_840d4a46550349ecbf9dbd090946c63d, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RenderingHost = (
  { __typename?: 'RenderingHost' }
  & Pick<Types.RenderingHost, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ResizableIFramePage = (
  { __typename?: 'ResizableIFramePage' }
  & Pick<Types.ResizableIFramePage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067 = (
  { __typename?: 'ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067' }
  & Pick<Types.ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68 = (
  { __typename?: 'ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68' }
  & Pick<Types.ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_b58eacfb27f5417bb536141f94b92521 = (
  { __typename?: 'ResizableIFramePage_b58eacfb27f5417bb536141f94b92521' }
  & Pick<Types.ResizableIFramePage_B58eacfb27f5417bb536141f94b92521, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401 = (
  { __typename?: 'ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401' }
  & Pick<Types.ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_f460ab055585441892023750e7cef6b7 = (
  { __typename?: 'ResizableIFramePage_f460ab055585441892023750e7cef6b7' }
  & Pick<Types.ResizableIFramePage_F460ab055585441892023750e7cef6b7, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ResponsiveImage = (
  { __typename?: 'ResponsiveImage' }
  & Pick<Types.ResponsiveImage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ResultsCount = (
  { __typename?: 'ResultsCount' }
  & Pick<Types.ResultsCount, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ResultsCountFolder = (
  { __typename?: 'ResultsCountFolder' }
  & Pick<Types.ResultsCountFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186 = (
  { __typename?: 'ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186' }
  & Pick<Types.ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ResultsVariantSelector = (
  { __typename?: 'ResultsVariantSelector' }
  & Pick<Types.ResultsVariantSelector, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RichText = (
  { __typename?: 'RichText' }
  & Pick<Types.RichText, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RichTextFolder = (
  { __typename?: 'RichTextFolder' }
  & Pick<Types.RichTextFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RichText_0f3b73366112418c8bbab0526f3887ce = (
  { __typename?: 'RichText_0f3b73366112418c8bbab0526f3887ce' }
  & Pick<Types.RichText_0f3b73366112418c8bbab0526f3887ce, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RichText_efcfd8f6596745f48f85b5421928205d = (
  { __typename?: 'RichText_efcfd8f6596745f48f85b5421928205d' }
  & Pick<Types.RichText_Efcfd8f6596745f48f85b5421928205d, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RiskImageMapping = (
  { __typename?: 'RiskImageMapping' }
  & Pick<Types.RiskImageMapping, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RiskImageMappings = (
  { __typename?: 'RiskImageMappings' }
  & Pick<Types.RiskImageMappings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RiskLevelOption = (
  { __typename?: 'RiskLevelOption' }
  & Pick<Types.RiskLevelOption, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RiskLevelOptionFolder = (
  { __typename?: 'RiskLevelOptionFolder' }
  & Pick<Types.RiskLevelOptionFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RiskWarning = (
  { __typename?: 'RiskWarning' }
  & Pick<Types.RiskWarning, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RiskWarningFolder = (
  { __typename?: 'RiskWarningFolder' }
  & Pick<Types.RiskWarningFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RiskWarningParametersTemplate = (
  { __typename?: 'RiskWarningParametersTemplate' }
  & Pick<Types.RiskWarningParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RolePlaceholder = (
  { __typename?: 'RolePlaceholder' }
  & Pick<Types.RolePlaceholder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RowSplitter = (
  { __typename?: 'RowSplitter' }
  & Pick<Types.RowSplitter, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_RowSplitter_340c887da1d1415b9678c763af74ea97 = (
  { __typename?: 'RowSplitter_340c887da1d1415b9678c763af74ea97' }
  & Pick<Types.RowSplitter_340c887da1d1415b9678c763af74ea97, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Rule = (
  { __typename?: 'Rule' }
  & Pick<Types.Rule, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SDRLogoMapping = (
  { __typename?: 'SDRLogoMapping' }
  & Pick<Types.SdrLogoMapping, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SDRLogoMappings = (
  { __typename?: 'SDRLogoMappings' }
  & Pick<Types.SdrLogoMappings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SDRTypeOption = (
  { __typename?: 'SDRTypeOption' }
  & Pick<Types.SdrTypeOption, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SDRTypeOptionFolder = (
  { __typename?: 'SDRTypeOptionFolder' }
  & Pick<Types.SdrTypeOptionFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SXAJSSLayout = (
  { __typename?: 'SXAJSSLayout' }
  & Pick<Types.SxajssLayout, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SXARole = (
  { __typename?: 'SXARole' }
  & Pick<Types.SxaRole, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SXAStandardValuesFolder = (
  { __typename?: 'SXAStandardValuesFolder' }
  & Pick<Types.SxaStandardValuesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceAlertMessage = (
  { __typename?: 'SalesforceAlertMessage' }
  & Pick<Types.SalesforceAlertMessage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceCheckBox = (
  { __typename?: 'SalesforceCheckBox' }
  & Pick<Types.SalesforceCheckBox, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceCheckBoxType = (
  { __typename?: 'SalesforceCheckBoxType' }
  & Pick<Types.SalesforceCheckBoxType, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButton = (
  { __typename?: 'SalesforceConditionalRadioButton' }
  & Pick<Types.SalesforceConditionalRadioButton, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButtons = (
  { __typename?: 'SalesforceConditionalRadioButtons' }
  & Pick<Types.SalesforceConditionalRadioButtons, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceDateInput = (
  { __typename?: 'SalesforceDateInput' }
  & Pick<Types.SalesforceDateInput, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceDropdown = (
  { __typename?: 'SalesforceDropdown' }
  & Pick<Types.SalesforceDropdown, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceDropdownOption = (
  { __typename?: 'SalesforceDropdownOption' }
  & Pick<Types.SalesforceDropdownOption, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceHiddenField = (
  { __typename?: 'SalesforceHiddenField' }
  & Pick<Types.SalesforceHiddenField, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceInput = (
  { __typename?: 'SalesforceInput' }
  & Pick<Types.SalesforceInput, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceInputType = (
  { __typename?: 'SalesforceInputType' }
  & Pick<Types.SalesforceInputType, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceIntegratedForm = (
  { __typename?: 'SalesforceIntegratedForm' }
  & Pick<Types.SalesforceIntegratedForm, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceIntegratedFormTypesFolder = (
  { __typename?: 'SalesforceIntegratedFormTypesFolder' }
  & Pick<Types.SalesforceIntegratedFormTypesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceRepeatableSubSection = (
  { __typename?: 'SalesforceRepeatableSubSection' }
  & Pick<Types.SalesforceRepeatableSubSection, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceRichTextArea = (
  { __typename?: 'SalesforceRichTextArea' }
  & Pick<Types.SalesforceRichTextArea, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceSection = (
  { __typename?: 'SalesforceSection' }
  & Pick<Types.SalesforceSection, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceSortCodeInput = (
  { __typename?: 'SalesforceSortCodeInput' }
  & Pick<Types.SalesforceSortCodeInput, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceSubmissionType = (
  { __typename?: 'SalesforceSubmissionType' }
  & Pick<Types.SalesforceSubmissionType, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Scope = (
  { __typename?: 'Scope' }
  & Pick<Types.Scope, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ScopesFolder = (
  { __typename?: 'ScopesFolder' }
  & Pick<Types.ScopesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Scriban = (
  { __typename?: 'Scriban' }
  & Pick<Types.Scriban, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Scripts = (
  { __typename?: 'Scripts' }
  & Pick<Types.Scripts, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SearchBox = (
  { __typename?: 'SearchBox' }
  & Pick<Types.SearchBox, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SearchBoxFolder = (
  { __typename?: 'SearchBoxFolder' }
  & Pick<Types.SearchBoxFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SearchBox_1c04fd611d874590acfe9cc186865ab3 = (
  { __typename?: 'SearchBox_1c04fd611d874590acfe9cc186865ab3' }
  & Pick<Types.SearchBox_1c04fd611d874590acfe9cc186865ab3, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SearchFolder = (
  { __typename?: 'SearchFolder' }
  & Pick<Types.SearchFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SearchResults = (
  { __typename?: 'SearchResults' }
  & Pick<Types.SearchResults, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SearchResultsFolder = (
  { __typename?: 'SearchResultsFolder' }
  & Pick<Types.SearchResultsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SearchResults_a06f7130041d46bb8c2995a2dc00c26a = (
  { __typename?: 'SearchResults_a06f7130041d46bb8c2995a2dc00c26a' }
  & Pick<Types.SearchResults_A06f7130041d46bb8c2995a2dc00c26a, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SecondaryHeroBannerParametersTemplate = (
  { __typename?: 'SecondaryHeroBannerParametersTemplate' }
  & Pick<Types.SecondaryHeroBannerParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SectionHeading = (
  { __typename?: 'SectionHeading' }
  & Pick<Types.SectionHeading, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SectionHeadingFolder = (
  { __typename?: 'SectionHeadingFolder' }
  & Pick<Types.SectionHeadingFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SectionHeadingParametersTemplate = (
  { __typename?: 'SectionHeadingParametersTemplate' }
  & Pick<Types.SectionHeadingParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SectionHeadingType = (
  { __typename?: 'SectionHeadingType' }
  & Pick<Types.SectionHeadingType, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SectionHeadingTypeFolder = (
  { __typename?: 'SectionHeadingTypeFolder' }
  & Pick<Types.SectionHeadingTypeFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SectionSelector = (
  { __typename?: 'SectionSelector' }
  & Pick<Types.SectionSelector, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SectionSelectorFolder = (
  { __typename?: 'SectionSelectorFolder' }
  & Pick<Types.SectionSelectorFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SectionSelectorTab = (
  { __typename?: 'SectionSelectorTab' }
  & Pick<Types.SectionSelectorTab, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Security_33077d51ebad4d1cb4a83b79f51dba13 = (
  { __typename?: 'Security_33077d51ebad4d1cb4a83b79f51dba13' }
  & Pick<Types.Security_33077d51ebad4d1cb4a83b79f51dba13, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Series = (
  { __typename?: 'Series' }
  & Pick<Types.Series, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SeriesFolder = (
  { __typename?: 'SeriesFolder' }
  & Pick<Types.SeriesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Settings = (
  { __typename?: 'Settings' }
  & Pick<Types.Settings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SettingsFolder = (
  { __typename?: 'SettingsFolder' }
  & Pick<Types.SettingsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Settings_6c82caca67dc464195698faad083230e = (
  { __typename?: 'Settings_6c82caca67dc464195698faad083230e' }
  & Pick<Types.Settings_6c82caca67dc464195698faad083230e, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SharePriceSettings = (
  { __typename?: 'SharePriceSettings' }
  & Pick<Types.SharePriceSettings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SharedArticlesFolder = (
  { __typename?: 'SharedArticlesFolder' }
  & Pick<Types.SharedArticlesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SharedContentFolder = (
  { __typename?: 'SharedContentFolder' }
  & Pick<Types.SharedContentFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SharedFolder = (
  { __typename?: 'SharedFolder' }
  & Pick<Types.SharedFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SharedHelpArticlesFolder = (
  { __typename?: 'SharedHelpArticlesFolder' }
  & Pick<Types.SharedHelpArticlesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SharedPressReleasesFolder = (
  { __typename?: 'SharedPressReleasesFolder' }
  & Pick<Types.SharedPressReleasesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SharedSettingsFolder = (
  { __typename?: 'SharedSettingsFolder' }
  & Pick<Types.SharedSettingsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SharedSitesSettings = (
  { __typename?: 'SharedSitesSettings' }
  & Pick<Types.SharedSitesSettings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SharedSitesSettings_c14bf746030f4e598594395f6d299e61 = (
  { __typename?: 'SharedSitesSettings_c14bf746030f4e598594395f6d299e61' }
  & Pick<Types.SharedSitesSettings_C14bf746030f4e598594395f6d299e61, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Showcase = (
  { __typename?: 'Showcase' }
  & Pick<Types.Showcase, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ShowcaseFolder = (
  { __typename?: 'ShowcaseFolder' }
  & Pick<Types.ShowcaseFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ShowcaseItem = (
  { __typename?: 'ShowcaseItem' }
  & Pick<Types.ShowcaseItem, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ShowcaseParametersTemplate = (
  { __typename?: 'ShowcaseParametersTemplate' }
  & Pick<Types.ShowcaseParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Site = (
  { __typename?: 'Site' }
  & Pick<Types.Site, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SiteContentFolder = (
  { __typename?: 'SiteContentFolder' }
  & Pick<Types.SiteContentFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SiteDefinition = (
  { __typename?: 'SiteDefinition' }
  & Pick<Types.SiteDefinition, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SiteEntryDisclaimer = (
  { __typename?: 'SiteEntryDisclaimer' }
  & Pick<Types.SiteEntryDisclaimer, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SiteFolder = (
  { __typename?: 'SiteFolder' }
  & Pick<Types.SiteFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SiteGrouping = (
  { __typename?: 'SiteGrouping' }
  & Pick<Types.SiteGrouping, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SiteManagement = (
  { __typename?: 'SiteManagement' }
  & Pick<Types.SiteManagement, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SiteSecurityItemPointer = (
  { __typename?: 'SiteSecurityItemPointer' }
  & Pick<Types.SiteSecurityItemPointer, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SiteSelector = (
  { __typename?: 'SiteSelector' }
  & Pick<Types.SiteSelector, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SiteSelector_a44632f56dcd4d10b4892f4e35e193c3 = (
  { __typename?: 'SiteSelector_a44632f56dcd4d10b4892f4e35e193c3' }
  & Pick<Types.SiteSelector_A44632f56dcd4d10b4892f4e35e193c3, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SiteSetupRoot = (
  { __typename?: 'SiteSetupRoot' }
  & Pick<Types.SiteSetupRoot, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SiteTheme = (
  { __typename?: 'SiteTheme' }
  & Pick<Types.SiteTheme, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Site_e46f3af239fa4866a1577017c4b2a40c = (
  { __typename?: 'Site_e46f3af239fa4866a1577017c4b2a40c' }
  & Pick<Types.Site_E46f3af239fa4866a1577017c4b2a40c, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SitecoreFormWrapperParametersTemplate = (
  { __typename?: 'SitecoreFormWrapperParametersTemplate' }
  & Pick<Types.SitecoreFormWrapperParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SitecoreRole = (
  { __typename?: 'SitecoreRole' }
  & Pick<Types.SitecoreRole, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SitemapSettings_c71d856635c849b7a84d9d176e9cbd05 = (
  { __typename?: 'SitemapSettings_c71d856635c849b7a84d9d176e9cbd05' }
  & Pick<Types.SitemapSettings_C71d856635c849b7a84d9d176e9cbd05, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SkipLink = (
  { __typename?: 'SkipLink' }
  & Pick<Types.SkipLink, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SkipLinkParameters = (
  { __typename?: 'SkipLinkParameters' }
  & Pick<Types.SkipLinkParameters, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SkipLinksFolder = (
  { __typename?: 'SkipLinksFolder' }
  & Pick<Types.SkipLinksFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Snippet = (
  { __typename?: 'Snippet' }
  & Pick<Types.Snippet, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SnippetItem = (
  { __typename?: 'SnippetItem' }
  & Pick<Types.SnippetItem, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SnippetsFolder = (
  { __typename?: 'SnippetsFolder' }
  & Pick<Types.SnippetsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SocialLoginWrapper = (
  { __typename?: 'SocialLoginWrapper' }
  & Pick<Types.SocialLoginWrapper, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SocialMediaButtons = (
  { __typename?: 'SocialMediaButtons' }
  & Pick<Types.SocialMediaButtons, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SocialMediaFolder = (
  { __typename?: 'SocialMediaFolder' }
  & Pick<Types.SocialMediaFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SocialMediaShare = (
  { __typename?: 'SocialMediaShare' }
  & Pick<Types.SocialMediaShare, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SocialMediaTemplate = (
  { __typename?: 'SocialMediaTemplate' }
  & Pick<Types.SocialMediaTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SocialNetwork = (
  { __typename?: 'SocialNetwork' }
  & Pick<Types.SocialNetwork, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SocialNetworkFolder = (
  { __typename?: 'SocialNetworkFolder' }
  & Pick<Types.SocialNetworkFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SocialNetworkLink = (
  { __typename?: 'SocialNetworkLink' }
  & Pick<Types.SocialNetworkLink, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SolutionTemplate = (
  { __typename?: 'SolutionTemplate' }
  & Pick<Types.SolutionTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SortResults = (
  { __typename?: 'SortResults' }
  & Pick<Types.SortResults, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SortResultsFolder = (
  { __typename?: 'SortResultsFolder' }
  & Pick<Types.SortResultsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Sorting = (
  { __typename?: 'Sorting' }
  & Pick<Types.Sorting, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SortingGroups = (
  { __typename?: 'SortingGroups' }
  & Pick<Types.SortingGroups, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SpotifyPodcast = (
  { __typename?: 'SpotifyPodcast' }
  & Pick<Types.SpotifyPodcast, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SpotifyPodcastFolder = (
  { __typename?: 'SpotifyPodcastFolder' }
  & Pick<Types.SpotifyPodcastFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_StickyCTA = (
  { __typename?: 'StickyCTA' }
  & Pick<Types.StickyCta, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_StickyCTAFolder = (
  { __typename?: 'StickyCTAFolder' }
  & Pick<Types.StickyCtaFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_StickyCTAParametersTemplate = (
  { __typename?: 'StickyCTAParametersTemplate' }
  & Pick<Types.StickyCtaParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_StrategiesInFocusFolder = (
  { __typename?: 'StrategiesInFocusFolder' }
  & Pick<Types.StrategiesInFocusFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_StrategyInFocus = (
  { __typename?: 'StrategyInFocus' }
  & Pick<Types.StrategyInFocus, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Style = (
  { __typename?: 'Style' }
  & Pick<Types.Style, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Styles = (
  { __typename?: 'Styles' }
  & Pick<Types.Styles, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Styles_9c0dac2808aa4b44bc2153363206f6a5 = (
  { __typename?: 'Styles_9c0dac2808aa4b44bc2153363206f6a5' }
  & Pick<Types.Styles_9c0dac2808aa4b44bc2153363206f6a5, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_SubscriptionBannerParametersTemplate = (
  { __typename?: 'SubscriptionBannerParametersTemplate' }
  & Pick<Types.SubscriptionBannerParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Tab = (
  { __typename?: 'Tab' }
  & Pick<Types.Tab, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TabItem = (
  { __typename?: 'TabItem' }
  & Pick<Types.TabItem, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TableOfContents = (
  { __typename?: 'TableOfContents' }
  & Pick<Types.TableOfContents, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TableOfContentsFolder = (
  { __typename?: 'TableOfContentsFolder' }
  & Pick<Types.TableOfContentsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TableOfContentsSection = (
  { __typename?: 'TableOfContentsSection' }
  & Pick<Types.TableOfContentsSection, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TableOfContentsSubsection = (
  { __typename?: 'TableOfContentsSubsection' }
  & Pick<Types.TableOfContentsSubsection, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Tabs = (
  { __typename?: 'Tabs' }
  & Pick<Types.Tabs, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TabsFolder = (
  { __typename?: 'TabsFolder' }
  & Pick<Types.TabsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Tabs_f26a9560ccf148c59542800e837caf7a = (
  { __typename?: 'Tabs_f26a9560ccf148c59542800e837caf7a' }
  & Pick<Types.Tabs_F26a9560ccf148c59542800e837caf7a, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Tag = (
  { __typename?: 'Tag' }
  & Pick<Types.Tag, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TagCloud = (
  { __typename?: 'TagCloud' }
  & Pick<Types.TagCloud, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TagFolder = (
  { __typename?: 'TagFolder' }
  & Pick<Types.TagFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TagList = (
  { __typename?: 'TagList' }
  & Pick<Types.TagList, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TeamBiographySettings = (
  { __typename?: 'TeamBiographySettings' }
  & Pick<Types.TeamBiographySettings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TeamListingCards = (
  { __typename?: 'TeamListingCards' }
  & Pick<Types.TeamListingCards, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TeamListingCardsFolder = (
  { __typename?: 'TeamListingCardsFolder' }
  & Pick<Types.TeamListingCardsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMember = (
  { __typename?: 'TeamMember' }
  & Pick<Types.TeamMember, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMemberCard = (
  { __typename?: 'TeamMemberCard' }
  & Pick<Types.TeamMemberCard, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembers = (
  { __typename?: 'TeamMembers' }
  & Pick<Types.TeamMembers, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage = (
  { __typename?: 'TeamMembersParentPage' }
  & Pick<Types.TeamMembersParentPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e = (
  { __typename?: 'TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e' }
  & Pick<Types.TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e = (
  { __typename?: 'TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e' }
  & Pick<Types.TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_47f304d629a84648a0e2b942513133ff = (
  { __typename?: 'TeamMembersParentPage_47f304d629a84648a0e2b942513133ff' }
  & Pick<Types.TeamMembersParentPage_47f304d629a84648a0e2b942513133ff, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089 = (
  { __typename?: 'TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089' }
  & Pick<Types.TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0 = (
  { __typename?: 'TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0' }
  & Pick<Types.TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage = (
  { __typename?: 'TeamMembersWildcardPage' }
  & Pick<Types.TeamMembersWildcardPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e = (
  { __typename?: 'TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e' }
  & Pick<Types.TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450 = (
  { __typename?: 'TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450' }
  & Pick<Types.TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a = (
  { __typename?: 'TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a' }
  & Pick<Types.TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29 = (
  { __typename?: 'TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29' }
  & Pick<Types.TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745 = (
  { __typename?: 'TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745' }
  & Pick<Types.TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TeamProfileCards = (
  { __typename?: 'TeamProfileCards' }
  & Pick<Types.TeamProfileCards, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TeamProfileCardsFolder = (
  { __typename?: 'TeamProfileCardsFolder' }
  & Pick<Types.TeamProfileCardsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TechzoneArticlePage = (
  { __typename?: 'TechzoneArticlePage' }
  & Pick<Types.TechzoneArticlePage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Tenant = (
  { __typename?: 'Tenant' }
  & Pick<Types.Tenant, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TenantFolder = (
  { __typename?: 'TenantFolder' }
  & Pick<Types.TenantFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TenantSecurityItemPointer = (
  { __typename?: 'TenantSecurityItemPointer' }
  & Pick<Types.TenantSecurityItemPointer, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TenantSetupRoot = (
  { __typename?: 'TenantSetupRoot' }
  & Pick<Types.TenantSetupRoot, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TertieryHeroBanner = (
  { __typename?: 'TertieryHeroBanner' }
  & Pick<Types.TertieryHeroBanner, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TertieryHeroBannerParametersTemplate = (
  { __typename?: 'TertieryHeroBannerParametersTemplate' }
  & Pick<Types.TertieryHeroBannerParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Text = (
  { __typename?: 'Text' }
  & Pick<Types.Text, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TextBlock = (
  { __typename?: 'TextBlock' }
  & Pick<Types.TextBlock, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TextBlockHeadingParametersTemplate = (
  { __typename?: 'TextBlockHeadingParametersTemplate' }
  & Pick<Types.TextBlockHeadingParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TextBlockHeadingType = (
  { __typename?: 'TextBlockHeadingType' }
  & Pick<Types.TextBlockHeadingType, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TextBlockHeadingTypeFolder = (
  { __typename?: 'TextBlockHeadingTypeFolder' }
  & Pick<Types.TextBlockHeadingTypeFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TextBlockLinkType = (
  { __typename?: 'TextBlockLinkType' }
  & Pick<Types.TextBlockLinkType, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TextBlockLinkTypeFolder = (
  { __typename?: 'TextBlockLinkTypeFolder' }
  & Pick<Types.TextBlockLinkTypeFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TextBlocks = (
  { __typename?: 'TextBlocks' }
  & Pick<Types.TextBlocks, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TextBlocksFolder = (
  { __typename?: 'TextBlocksFolder' }
  & Pick<Types.TextBlocksFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TextBlocksParametersTemplate = (
  { __typename?: 'TextBlocksParametersTemplate' }
  & Pick<Types.TextBlocksParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TextFolder = (
  { __typename?: 'TextFolder' }
  & Pick<Types.TextFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TextFolder_b762d56787f5493cbb480c455d834457 = (
  { __typename?: 'TextFolder_b762d56787f5493cbb480c455d834457' }
  & Pick<Types.TextFolder_B762d56787f5493cbb480c455d834457, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Text_b8f5894cb4934016bf784090b0a2fd16 = (
  { __typename?: 'Text_b8f5894cb4934016bf784090b0a2fd16' }
  & Pick<Types.Text_B8f5894cb4934016bf784090b0a2fd16, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Theme = (
  { __typename?: 'Theme' }
  & Pick<Types.Theme, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ThemeTag = (
  { __typename?: 'ThemeTag' }
  & Pick<Types.ThemeTag, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ThemeTagsFolder = (
  { __typename?: 'ThemeTagsFolder' }
  & Pick<Types.ThemeTagsFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ThemingMode = (
  { __typename?: 'ThemingMode' }
  & Pick<Types.ThemingMode, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ThemingModes = (
  { __typename?: 'ThemingModes' }
  & Pick<Types.ThemingModes, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Tile = (
  { __typename?: 'Tile' }
  & Pick<Types.Tile, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TileLink = (
  { __typename?: 'TileLink' }
  & Pick<Types.TileLink, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TileParametersTemplate = (
  { __typename?: 'TileParametersTemplate' }
  & Pick<Types.TileParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TileSizeOption = (
  { __typename?: 'TileSizeOption' }
  & Pick<Types.TileSizeOption, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TileSizeOptionFolder = (
  { __typename?: 'TileSizeOptionFolder' }
  & Pick<Types.TileSizeOptionFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TilesFolder = (
  { __typename?: 'TilesFolder' }
  & Pick<Types.TilesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TilesParametersTemplate = (
  { __typename?: 'TilesParametersTemplate' }
  & Pick<Types.TilesParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Title = (
  { __typename?: 'Title' }
  & Pick<Types.Title, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Title_a82e893105754175917de904ef7e6dbe = (
  { __typename?: 'Title_a82e893105754175917de904ef7e6dbe' }
  & Pick<Types.Title_A82e893105754175917de904ef7e6dbe, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Toggle = (
  { __typename?: 'Toggle' }
  & Pick<Types.Toggle, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_ToggleFolder = (
  { __typename?: 'ToggleFolder' }
  & Pick<Types.ToggleFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Toggle_8e4c968e9fa543a89ac4c0baf273ccde = (
  { __typename?: 'Toggle_8e4c968e9fa543a89ac4c0baf273ccde' }
  & Pick<Types.Toggle_8e4c968e9fa543a89ac4c0baf273ccde, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Transformation = (
  { __typename?: 'Transformation' }
  & Pick<Types.Transformation, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TrustArticleHeroParametersTemplate = (
  { __typename?: 'TrustArticleHeroParametersTemplate' }
  & Pick<Types.TrustArticleHeroParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TrustFinder = (
  { __typename?: 'TrustFinder' }
  & Pick<Types.TrustFinder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TrustFinderFilterOption = (
  { __typename?: 'TrustFinderFilterOption' }
  & Pick<Types.TrustFinderFilterOption, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TrustRegion = (
  { __typename?: 'TrustRegion' }
  & Pick<Types.TrustRegion, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TrustType = (
  { __typename?: 'TrustType' }
  & Pick<Types.TrustType, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TrustTypesFolder = (
  { __typename?: 'TrustTypesFolder' }
  & Pick<Types.TrustTypesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Twitter = (
  { __typename?: 'Twitter' }
  & Pick<Types.Twitter, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TwitterApp = (
  { __typename?: 'TwitterApp' }
  & Pick<Types.TwitterApp, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TwitterApps = (
  { __typename?: 'TwitterApps' }
  & Pick<Types.TwitterApps, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TwitterFolder = (
  { __typename?: 'TwitterFolder' }
  & Pick<Types.TwitterFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TwitterParametersTemplate = (
  { __typename?: 'TwitterParametersTemplate' }
  & Pick<Types.TwitterParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_TwitterSettings = (
  { __typename?: 'TwitterSettings' }
  & Pick<Types.TwitterSettings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_UnknownItem = (
  { __typename?: 'UnknownItem' }
  & Pick<Types.UnknownItem, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_UnminifiedFile = (
  { __typename?: 'UnminifiedFile' }
  & Pick<Types.UnminifiedFile, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_UpgradeScript = (
  { __typename?: 'UpgradeScript' }
  & Pick<Types.UpgradeScript, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_UpgradeScriptLibrary = (
  { __typename?: 'UpgradeScriptLibrary' }
  & Pick<Types.UpgradeScriptLibrary, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_VariantComponentField = (
  { __typename?: 'VariantComponentField' }
  & Pick<Types.VariantComponentField, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_VariantDateField = (
  { __typename?: 'VariantDateField' }
  & Pick<Types.VariantDateField, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55 = (
  { __typename?: 'VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55' }
  & Pick<Types.VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_VariantPlaceholder = (
  { __typename?: 'VariantPlaceholder' }
  & Pick<Types.VariantPlaceholder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_VariantReference = (
  { __typename?: 'VariantReference' }
  & Pick<Types.VariantReference, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_VariantSection = (
  { __typename?: 'VariantSection' }
  & Pick<Types.VariantSection, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_VariantTemplate = (
  { __typename?: 'VariantTemplate' }
  & Pick<Types.VariantTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_VariantText = (
  { __typename?: 'VariantText' }
  & Pick<Types.VariantText, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_VariantToken = (
  { __typename?: 'VariantToken' }
  & Pick<Types.VariantToken, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Variants = (
  { __typename?: 'Variants' }
  & Pick<Types.Variants, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_VectorFolder = (
  { __typename?: 'VectorFolder' }
  & Pick<Types.VectorFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_VectorTile = (
  { __typename?: 'VectorTile' }
  & Pick<Types.VectorTile, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_VectorTileLink = (
  { __typename?: 'VectorTileLink' }
  & Pick<Types.VectorTileLink, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_VectorTilesFolder = (
  { __typename?: 'VectorTilesFolder' }
  & Pick<Types.VectorTilesFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_VectorTilesParametersTemplate = (
  { __typename?: 'VectorTilesParametersTemplate' }
  & Pick<Types.VectorTilesParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Version_95ebc23204774dc38ad3465d5fe8da2f = (
  { __typename?: 'Version_95ebc23204774dc38ad3465d5fe8da2f' }
  & Pick<Types.Version_95ebc23204774dc38ad3465d5fe8da2f, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Video = (
  { __typename?: 'Video' }
  & Pick<Types.Video, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_VideoCountOption = (
  { __typename?: 'VideoCountOption' }
  & Pick<Types.VideoCountOption, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_VideoCountOptions = (
  { __typename?: 'VideoCountOptions' }
  & Pick<Types.VideoCountOptions, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_VideoFolder = (
  { __typename?: 'VideoFolder' }
  & Pick<Types.VideoFolder, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_VideoFolder_bba49474673e468186ba8b1a20e067a9 = (
  { __typename?: 'VideoFolder_bba49474673e468186ba8b1a20e067a9' }
  & Pick<Types.VideoFolder_Bba49474673e468186ba8b1a20e067a9, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_VideoPage = (
  { __typename?: 'VideoPage' }
  & Pick<Types.VideoPage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_VideoParameters = (
  { __typename?: 'VideoParameters' }
  & Pick<Types.VideoParameters, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_VideoParametersTemplate = (
  { __typename?: 'VideoParametersTemplate' }
  & Pick<Types.VideoParametersTemplate, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_VideoPressReleasePage = (
  { __typename?: 'VideoPressReleasePage' }
  & Pick<Types.VideoPressReleasePage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results_Video_4bc649610a894242be2dc5026090cf49 = (
  { __typename?: 'Video_4bc649610a894242be2dc5026090cf49' }
  & Pick<Types.Video_4bc649610a894242be2dc5026090cf49, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__AssetsOptimization = (
  { __typename?: '_AssetsOptimization' }
  & Pick<Types._AssetsOptimization, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__BackgroundImage = (
  { __typename?: '_BackgroundImage' }
  & Pick<Types._BackgroundImage, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__CompatibleThemes = (
  { __typename?: '_CompatibleThemes' }
  & Pick<Types._CompatibleThemes, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__CompositeTheme = (
  { __typename?: '_CompositeTheme' }
  & Pick<Types._CompositeTheme, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__CustomMetadata = (
  { __typename?: '_CustomMetadata' }
  & Pick<Types._CustomMetadata, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__CustomRenderingViewPath = (
  { __typename?: '_CustomRenderingViewPath' }
  & Pick<Types._CustomRenderingViewPath, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__DatasourceBehaviour = (
  { __typename?: '_DatasourceBehaviour' }
  & Pick<Types._DatasourceBehaviour, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__Favicon = (
  { __typename?: '_Favicon' }
  & Pick<Types._Favicon, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__FormsFolderLocation = (
  { __typename?: '_FormsFolderLocation' }
  & Pick<Types._FormsFolderLocation, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__FundSettings = (
  { __typename?: '_FundSettings' }
  & Pick<Types._FundSettings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__HasValidUrlName = (
  { __typename?: '_HasValidUrlName' }
  & Pick<Types._HasValidUrlName, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__LocalDataLink = (
  { __typename?: '_LocalDataLink' }
  & Pick<Types._LocalDataLink, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__Login = (
  { __typename?: '_Login' }
  & Pick<Types._Login, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__OpenGraphMetadata = (
  { __typename?: '_OpenGraphMetadata' }
  & Pick<Types._OpenGraphMetadata, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__PageDesignTheme = (
  { __typename?: '_PageDesignTheme' }
  & Pick<Types._PageDesignTheme, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__PageSearchScope = (
  { __typename?: '_PageSearchScope' }
  & Pick<Types._PageSearchScope, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__SearchCriteria = (
  { __typename?: '_SearchCriteria' }
  & Pick<Types._SearchCriteria, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__SearchableWithoutRelatedItems = (
  { __typename?: '_SearchableWithoutRelatedItems' }
  & Pick<Types._SearchableWithoutRelatedItems, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__SeoMetadata = (
  { __typename?: '_SeoMetadata' }
  & Pick<Types._SeoMetadata, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__SiteTheme = (
  { __typename?: '_SiteTheme' }
  & Pick<Types._SiteTheme, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__SitemapSettings = (
  { __typename?: '_SitemapSettings' }
  & Pick<Types._SitemapSettings, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__StickyNote = (
  { __typename?: '_StickyNote' }
  & Pick<Types._StickyNote, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__Styleable = (
  { __typename?: '_Styleable' }
  & Pick<Types._Styleable, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__TwitterMetadata = (
  { __typename?: '_TwitterMetadata' }
  & Pick<Types._TwitterMetadata, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__Webinar = (
  { __typename?: '_Webinar' }
  & Pick<Types._Webinar, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results__WildcardSource = (
  { __typename?: '_WildcardSource' }
  & Pick<Types._WildcardSource, 'id' | 'rendered'>
);

export type PressReleaseSearchQuery_search_ItemSearchResults_results = PressReleaseSearchQuery_search_ItemSearchResults_results_Accordion | PressReleaseSearchQuery_search_ItemSearchResults_results_AccordionFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_AccordionFolder_03f88fb497884025b46f2cb249f4fcd6 | PressReleaseSearchQuery_search_ItemSearchResults_results_AccordionItem | PressReleaseSearchQuery_search_ItemSearchResults_results_AccordionItem_8cf671721b2d489e809f4c23db5ab2da | PressReleaseSearchQuery_search_ItemSearchResults_results_AccordionParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_AccordionPresentation | PressReleaseSearchQuery_search_ItemSearchResults_results_AccordionPresentationFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_Accordion_02d060598cc14423a9ac9ff2365176b7 | PressReleaseSearchQuery_search_ItemSearchResults_results_Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1 | PressReleaseSearchQuery_search_ItemSearchResults_results_AddItem | PressReleaseSearchQuery_search_ItemSearchResults_results_AddItem_1e1b739ec3784909941d171aca7362e5 | PressReleaseSearchQuery_search_ItemSearchResults_results_AddItem_3aea335cd06d45b1841acbc8d2d1ce40 | PressReleaseSearchQuery_search_ItemSearchResults_results_AddItem_de8c75222f3241288f20342f479894eb | PressReleaseSearchQuery_search_ItemSearchResults_results_AddItem_ea8a3f269ccd443a95f571b868a94bd0 | PressReleaseSearchQuery_search_ItemSearchResults_results_AddThisParameters | PressReleaseSearchQuery_search_ItemSearchResults_results_AggregatedFacetFilter | PressReleaseSearchQuery_search_ItemSearchResults_results_AlertMessage | PressReleaseSearchQuery_search_ItemSearchResults_results_AlertMessageFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_AlertMessageParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_AlertMessageType | PressReleaseSearchQuery_search_ItemSearchResults_results_AllertMessageTypeFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_Archive | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleAuthor | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleAuthorsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleCategoriesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleCategory | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleChapter | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleChapters | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleContentType | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleContentTypesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleFilter | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleFilterOption | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleFootnote | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleFootnoteLink | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleFootnoteText | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleInfogramTile | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleInfogramTileParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticlePage | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleRegion | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleRegionsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleSearchPage | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2 | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_be414ff574ac4203abb2694811443e25 | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907 | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleSeriesCollection | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleSeriesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleSettings | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleSubscriptionBanner | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleSubscriptionBannerFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleTag | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleTagsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleTeamAuthor | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleTileParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleTilesParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8 | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_405b20252077400383d3b47f09f88b47 | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b | PressReleaseSearchQuery_search_ItemSearchResults_results_ArticlesGroupFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_AttachThemeExtension | PressReleaseSearchQuery_search_ItemSearchResults_results_AutomaticDocumentListings | PressReleaseSearchQuery_search_ItemSearchResults_results_AutomaticDocumentListingsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_AvailableJSONRenderings | PressReleaseSearchQuery_search_ItemSearchResults_results_AvailableMetaRenderings | PressReleaseSearchQuery_search_ItemSearchResults_results_AvailableRenderings | PressReleaseSearchQuery_search_ItemSearchResults_results_AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb | PressReleaseSearchQuery_search_ItemSearchResults_results_AwardsBanner | PressReleaseSearchQuery_search_ItemSearchResults_results_AwardsBannerFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_AwardsBannerImage | PressReleaseSearchQuery_search_ItemSearchResults_results_AwardsBannerParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_BYOCWrapperRenderingParameters | PressReleaseSearchQuery_search_ItemSearchResults_results_BackgroundColorOption | PressReleaseSearchQuery_search_ItemSearchResults_results_BackgroundColorOptionFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_BannerFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_BannerType | PressReleaseSearchQuery_search_ItemSearchResults_results_BannerTypeFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_BaseHeading | PressReleaseSearchQuery_search_ItemSearchResults_results_BaseHeadingFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_BoolFacet | PressReleaseSearchQuery_search_ItemSearchResults_results_BranchesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_Breadcrumb | PressReleaseSearchQuery_search_ItemSearchResults_results_BrowserTitleDefinition | PressReleaseSearchQuery_search_ItemSearchResults_results_CORSEntry | PressReleaseSearchQuery_search_ItemSearchResults_results_CORSGrouping | PressReleaseSearchQuery_search_ItemSearchResults_results_CTAPresentationType | PressReleaseSearchQuery_search_ItemSearchResults_results_CTAPresentationTypeFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_C__AbrdnPage | PressReleaseSearchQuery_search_ItemSearchResults_results_C__ActionBase | PressReleaseSearchQuery_search_ItemSearchResults_results_C__AdvancedParameter | PressReleaseSearchQuery_search_ItemSearchResults_results_C__App | PressReleaseSearchQuery_search_ItemSearchResults_results_C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c | PressReleaseSearchQuery_search_ItemSearchResults_results_C__ArticleWildcardPage | PressReleaseSearchQuery_search_ItemSearchResults_results_C__AvailableRenderingsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_C__BYOCRenderingParameters | PressReleaseSearchQuery_search_ItemSearchResults_results_C__BackgroundParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_C__BaseCTA | PressReleaseSearchQuery_search_ItemSearchResults_results_C__BasePage | PressReleaseSearchQuery_search_ItemSearchResults_results_C__BasePage_037da552a5524fe4aeee331f57ac1378 | PressReleaseSearchQuery_search_ItemSearchResults_results_C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f | PressReleaseSearchQuery_search_ItemSearchResults_results_C__BasePage_315fd21bebf04c9d9f00bae191442f1d | PressReleaseSearchQuery_search_ItemSearchResults_results_C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd | PressReleaseSearchQuery_search_ItemSearchResults_results_C__BasePage_728c97b5c56146d9807e21018a972bb5 | PressReleaseSearchQuery_search_ItemSearchResults_results_C__BasePage_6105875085f346729dfc8d133b481f26 | PressReleaseSearchQuery_search_ItemSearchResults_results_C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b | PressReleaseSearchQuery_search_ItemSearchResults_results_C__BaseRenderingParameters | PressReleaseSearchQuery_search_ItemSearchResults_results_C__BaseTheme | PressReleaseSearchQuery_search_ItemSearchResults_results_C__BaseVariantField | PressReleaseSearchQuery_search_ItemSearchResults_results_C__Class | PressReleaseSearchQuery_search_ItemSearchResults_results_C__CompositeGroup | PressReleaseSearchQuery_search_ItemSearchResults_results_C__CompositeSection | PressReleaseSearchQuery_search_ItemSearchResults_results_C__EloquaForm | PressReleaseSearchQuery_search_ItemSearchResults_results_C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d | PressReleaseSearchQuery_search_ItemSearchResults_results_C__ExtendedOptions | PressReleaseSearchQuery_search_ItemSearchResults_results_C__ExtendedOptions_2964fb4257a6440fb192218443904c90 | PressReleaseSearchQuery_search_ItemSearchResults_results_C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160 | PressReleaseSearchQuery_search_ItemSearchResults_results_C__FEaaSRenderingParameters | PressReleaseSearchQuery_search_ItemSearchResults_results_C__FacetSelectorConfigBase | PressReleaseSearchQuery_search_ItemSearchResults_results_C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845 | PressReleaseSearchQuery_search_ItemSearchResults_results_C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b | PressReleaseSearchQuery_search_ItemSearchResults_results_C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303 | PressReleaseSearchQuery_search_ItemSearchResults_results_C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5 | PressReleaseSearchQuery_search_ItemSearchResults_results_C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc | PressReleaseSearchQuery_search_ItemSearchResults_results_C__GlobalDatasourceBehavior | PressReleaseSearchQuery_search_ItemSearchResults_results_C__GridDefinition | PressReleaseSearchQuery_search_ItemSearchResults_results_C__GridItemBase | PressReleaseSearchQuery_search_ItemSearchResults_results_C__GridParameters | PressReleaseSearchQuery_search_ItemSearchResults_results_C__HeadlessSite | PressReleaseSearchQuery_search_ItemSearchResults_results_C__HeadlessTenant | PressReleaseSearchQuery_search_ItemSearchResults_results_C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b | PressReleaseSearchQuery_search_ItemSearchResults_results_C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d | PressReleaseSearchQuery_search_ItemSearchResults_results_C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d | PressReleaseSearchQuery_search_ItemSearchResults_results_C__IAllowEmpty | PressReleaseSearchQuery_search_ItemSearchResults_results_C__IBaseVariantDefinition | PressReleaseSearchQuery_search_ItemSearchResults_results_C__IBoosting | PressReleaseSearchQuery_search_ItemSearchResults_results_C__ICacheable | PressReleaseSearchQuery_search_ItemSearchResults_results_C__ICompatibleRenderings | PressReleaseSearchQuery_search_ItemSearchResults_results_C__IComponentVariant | PressReleaseSearchQuery_search_ItemSearchResults_results_C__IControlType | PressReleaseSearchQuery_search_ItemSearchResults_results_C__IDynamicPlaceholder | PressReleaseSearchQuery_search_ItemSearchResults_results_C__IFEaaSComponentsDataSourceTemplates | PressReleaseSearchQuery_search_ItemSearchResults_results_C__IFEaaSComponentsEditorScriptURL | PressReleaseSearchQuery_search_ItemSearchResults_results_C__IIcon | PressReleaseSearchQuery_search_ItemSearchResults_results_C__ILocation | PressReleaseSearchQuery_search_ItemSearchResults_results_C__IPaginable | PressReleaseSearchQuery_search_ItemSearchResults_results_C__IPagination | PressReleaseSearchQuery_search_ItemSearchResults_results_C__IPoi | PressReleaseSearchQuery_search_ItemSearchResults_results_C__IRenderingId | PressReleaseSearchQuery_search_ItemSearchResults_results_C__ISplitter | PressReleaseSearchQuery_search_ItemSearchResults_results_C__IStyling | PressReleaseSearchQuery_search_ItemSearchResults_results_C__IVariantDefinition | PressReleaseSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage | PressReleaseSearchQuery_search_ItemSearchResults_results_C__JSONField | PressReleaseSearchQuery_search_ItemSearchResults_results_C__JSONReference | PressReleaseSearchQuery_search_ItemSearchResults_results_C__JSSData | PressReleaseSearchQuery_search_ItemSearchResults_results_C__JSSSettings | PressReleaseSearchQuery_search_ItemSearchResults_results_C__JSSSiteFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_C__JssRootFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086 | PressReleaseSearchQuery_search_ItemSearchResults_results_C__Navigation_e6d98f24d01c419e871a4617125a49ed | PressReleaseSearchQuery_search_ItemSearchResults_results_C__Page | PressReleaseSearchQuery_search_ItemSearchResults_results_C__PageData | PressReleaseSearchQuery_search_ItemSearchResults_results_C__PageDesignFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd | PressReleaseSearchQuery_search_ItemSearchResults_results_C__PageDesigns_daaf41fd96db4892be99f62f16d036c4 | PressReleaseSearchQuery_search_ItemSearchResults_results_C__PartialDesign | PressReleaseSearchQuery_search_ItemSearchResults_results_C__PartialDesignFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d | PressReleaseSearchQuery_search_ItemSearchResults_results_C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d | PressReleaseSearchQuery_search_ItemSearchResults_results_C__PlaceholderWrapper | PressReleaseSearchQuery_search_ItemSearchResults_results_C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac | PressReleaseSearchQuery_search_ItemSearchResults_results_C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b | PressReleaseSearchQuery_search_ItemSearchResults_results_C__RedirectMapGrouping | PressReleaseSearchQuery_search_ItemSearchResults_results_C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973 | PressReleaseSearchQuery_search_ItemSearchResults_results_C__Route | PressReleaseSearchQuery_search_ItemSearchResults_results_C__SimpleVideo | PressReleaseSearchQuery_search_ItemSearchResults_results_C__SiteSettingsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_C__SitemapSettings | PressReleaseSearchQuery_search_ItemSearchResults_results_C__StandardTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c | PressReleaseSearchQuery_search_ItemSearchResults_results_C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65 | PressReleaseSearchQuery_search_ItemSearchResults_results_C__TrustFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_C__VariantDefinition | PressReleaseSearchQuery_search_ItemSearchResults_results_C__VariantField | PressReleaseSearchQuery_search_ItemSearchResults_results_C__VariantsGrouping | PressReleaseSearchQuery_search_ItemSearchResults_results_C___AdvancedItem | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Arguments | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Arguments_33fab87cd52f44319a1f589ba7c1e287 | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Article | PressReleaseSearchQuery_search_ItemSearchResults_results_C___ArticlePageWorkflow | PressReleaseSearchQuery_search_ItemSearchResults_results_C___ArticleSearchPage | PressReleaseSearchQuery_search_ItemSearchResults_results_C___ArticleWildcard | PressReleaseSearchQuery_search_ItemSearchResults_results_C___AssetServiceThemeMode | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseArticle | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseDataFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseHelpArticle | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseInvestmentTrust | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseJSSTenant | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BasePage | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BasePageDesign | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BasePageDesignFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BasePartialDesign | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BasePartialDesignFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BasePlaceholder | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BasePlaceholderSettingsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BasePresentation | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BasePressRelease | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseRenderingParameters | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseSXAStandardValuesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseSettings | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseSharedSitesSettings | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseSiteDefinition | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseSiteFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseSiteGrouping | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseSiteRoot | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseTenant | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BaseTenantFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_C___BucketRules | PressReleaseSearchQuery_search_ItemSearchResults_results_C___CORS | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Content | PressReleaseSearchQuery_search_ItemSearchResults_results_C___ContentType | PressReleaseSearchQuery_search_ItemSearchResults_results_C___DataAttributes | PressReleaseSearchQuery_search_ItemSearchResults_results_C___DatasourceWorkflow | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Dependencies | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Description | PressReleaseSearchQuery_search_ItemSearchResults_results_C___DesignTemplateMapping | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Designable | PressReleaseSearchQuery_search_ItemSearchResults_results_C___EditType | PressReleaseSearchQuery_search_ItemSearchResults_results_C___EditType_8a9f84baaa124c5d9096935714809da4 | PressReleaseSearchQuery_search_ItemSearchResults_results_C___EditingTheme | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Enabled | PressReleaseSearchQuery_search_ItemSearchResults_results_C___ErrorHandling | PressReleaseSearchQuery_search_ItemSearchResults_results_C___ExternalArticle | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Fields | PressReleaseSearchQuery_search_ItemSearchResults_results_C___FilteredArticlesParent | PressReleaseSearchQuery_search_ItemSearchResults_results_C___FilteredArticlesWildcard | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Footnotes | PressReleaseSearchQuery_search_ItemSearchResults_results_C___FundDetailsWildcard | PressReleaseSearchQuery_search_ItemSearchResults_results_C___FundFormAvailability | PressReleaseSearchQuery_search_ItemSearchResults_results_C___FundMetadataPage | PressReleaseSearchQuery_search_ItemSearchResults_results_C___FundSearchPage | PressReleaseSearchQuery_search_ItemSearchResults_results_C___FundsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_C___FundsFormsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_C___FundsLiteratureFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_C___FundsShareclassesDetailsWildcard | PressReleaseSearchQuery_search_ItemSearchResults_results_C___GridMapping | PressReleaseSearchQuery_search_ItemSearchResults_results_C___HelpArticle | PressReleaseSearchQuery_search_ItemSearchResults_results_C___HelpArticleSearchPage | PressReleaseSearchQuery_search_ItemSearchResults_results_C___HelpArticleWildcard | PressReleaseSearchQuery_search_ItemSearchResults_results_C___HorizonDatasourceGrouping | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Icon | PressReleaseSearchQuery_search_ItemSearchResults_results_C___IncludeByDefault | PressReleaseSearchQuery_search_ItemSearchResults_results_C___IncludeIfInstalled | PressReleaseSearchQuery_search_ItemSearchResults_results_C___InternalArticle | PressReleaseSearchQuery_search_ItemSearchResults_results_C___InternetExplorerCompatibilityMode | PressReleaseSearchQuery_search_ItemSearchResults_results_C___IsSystemModule | PressReleaseSearchQuery_search_ItemSearchResults_results_C___JSONVariantPaging | PressReleaseSearchQuery_search_ItemSearchResults_results_C___JSONVariantsBase | PressReleaseSearchQuery_search_ItemSearchResults_results_C___LimitedDisplay | PressReleaseSearchQuery_search_ItemSearchResults_results_C___LinkAttributes | PressReleaseSearchQuery_search_ItemSearchResults_results_C___LinkSettings | PressReleaseSearchQuery_search_ItemSearchResults_results_C___LiteratureHubSearchPage | PressReleaseSearchQuery_search_ItemSearchResults_results_C___ManualKeyInformation | PressReleaseSearchQuery_search_ItemSearchResults_results_C___MemberOf | PressReleaseSearchQuery_search_ItemSearchResults_results_C___MetadataPage | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Modules | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Name | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Name_299cdb154745448a807868d401248eaa | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Name_b88cf88159a54a19991e71038751cb60 | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Navigable | PressReleaseSearchQuery_search_ItemSearchResults_results_C___NavigablePage | PressReleaseSearchQuery_search_ItemSearchResults_results_C___PageContent | PressReleaseSearchQuery_search_ItemSearchResults_results_C___PageWorkflow | PressReleaseSearchQuery_search_ItemSearchResults_results_C___PerSiteStandardValues | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Podcast | PressReleaseSearchQuery_search_ItemSearchResults_results_C___PodcastPressRelease | PressReleaseSearchQuery_search_ItemSearchResults_results_C___PremiumContentPage | PressReleaseSearchQuery_search_ItemSearchResults_results_C___PressRelease | PressReleaseSearchQuery_search_ItemSearchResults_results_C___PressReleaseContentType | PressReleaseSearchQuery_search_ItemSearchResults_results_C___PressReleaseSearchPage | PressReleaseSearchQuery_search_ItemSearchResults_results_C___PressReleaseWildcard | PressReleaseSearchQuery_search_ItemSearchResults_results_C___ProtectedTheme | PressReleaseSearchQuery_search_ItemSearchResults_results_C___PublishingGroupingTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_C___RenderingRelatedParameters | PressReleaseSearchQuery_search_ItemSearchResults_results_C___RenderingVariantsBase | PressReleaseSearchQuery_search_ItemSearchResults_results_C___RenderingsList | PressReleaseSearchQuery_search_ItemSearchResults_results_C___RobotsContent | PressReleaseSearchQuery_search_ItemSearchResults_results_C___RoleDomain | PressReleaseSearchQuery_search_ItemSearchResults_results_C___RoleName | PressReleaseSearchQuery_search_ItemSearchResults_results_C___RoleType | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SalesforceCommonValidations | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SalesforceFieldId | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SalesforceFieldTitle | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SalesforceFieldValue | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Script | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SearchSignature | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Searchable | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SecurityItemPointer | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SharedArticles | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SharedContent | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SharedHelpArticles | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SharedPage | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SharedPressReleases | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SharedRoot | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SharedSettings | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SiteContent | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SiteFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SiteMediaLibrary | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SiteSettings | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SiteTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SitecoreClientSiteManaging | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Sitemap | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SitemapMediaItems | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SlidersRangeSettings | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SolutionTemplateContent | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SolutionTemplateDescription | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SolutionTemplateName | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SortOrder | PressReleaseSearchQuery_search_ItemSearchResults_results_C___StackBreakpoint | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Statistics | PressReleaseSearchQuery_search_ItemSearchResults_results_C___SupportedLanguages | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Taggable | PressReleaseSearchQuery_search_ItemSearchResults_results_C___TeamMembersParentPage | PressReleaseSearchQuery_search_ItemSearchResults_results_C___TeamMembersWildcard | PressReleaseSearchQuery_search_ItemSearchResults_results_C___TechzoneArticle | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Template | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Title | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Type | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Validation | PressReleaseSearchQuery_search_ItemSearchResults_results_C___VariantPaging | PressReleaseSearchQuery_search_ItemSearchResults_results_C___VectorTile | PressReleaseSearchQuery_search_ItemSearchResults_results_C___VectorTileLink | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Video | PressReleaseSearchQuery_search_ItemSearchResults_results_C___VideoPressRelease | PressReleaseSearchQuery_search_ItemSearchResults_results_C___Width | PressReleaseSearchQuery_search_ItemSearchResults_results_C___WildcardPage | PressReleaseSearchQuery_search_ItemSearchResults_results_CacheSetting | PressReleaseSearchQuery_search_ItemSearchResults_results_Caching_26fce9bf0256458d8281a713a5bf5520 | PressReleaseSearchQuery_search_ItemSearchResults_results_CalendarEvent | PressReleaseSearchQuery_search_ItemSearchResults_results_CallOutSection | PressReleaseSearchQuery_search_ItemSearchResults_results_CallOutSectionDropdownOption | PressReleaseSearchQuery_search_ItemSearchResults_results_CallOutSectionFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_CallOutSectionParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_CallToAction | PressReleaseSearchQuery_search_ItemSearchResults_results_CallToActionFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_CapabilitiesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_Capability | PressReleaseSearchQuery_search_ItemSearchResults_results_CapabilityMap | PressReleaseSearchQuery_search_ItemSearchResults_results_CapabilityMappings | PressReleaseSearchQuery_search_ItemSearchResults_results_Carousel | PressReleaseSearchQuery_search_ItemSearchResults_results_CarouselFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_CarouselSlide | PressReleaseSearchQuery_search_ItemSearchResults_results_Carousel_2b65f0d87ec54834b4aa1753c0f7036b | PressReleaseSearchQuery_search_ItemSearchResults_results_Checkbox | PressReleaseSearchQuery_search_ItemSearchResults_results_ChecklistFilter | PressReleaseSearchQuery_search_ItemSearchResults_results_ChecklistFilterFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee | PressReleaseSearchQuery_search_ItemSearchResults_results_ColumnSplitter | PressReleaseSearchQuery_search_ItemSearchResults_results_ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0 | PressReleaseSearchQuery_search_ItemSearchResults_results_CompatibilityMode | PressReleaseSearchQuery_search_ItemSearchResults_results_ComponentConfiguration | PressReleaseSearchQuery_search_ItemSearchResults_results_ComponentThemeConfiguration | PressReleaseSearchQuery_search_ItemSearchResults_results_ComponentThemesConfiguration | PressReleaseSearchQuery_search_ItemSearchResults_results_ComponentsConfigurations | PressReleaseSearchQuery_search_ItemSearchResults_results_ConfigurationFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_Container | PressReleaseSearchQuery_search_ItemSearchResults_results_ContainerOption | PressReleaseSearchQuery_search_ItemSearchResults_results_ContainerOptionsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_ContainerParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_Container_45130bdbbae34edcaea87b68b9d94c7f | PressReleaseSearchQuery_search_ItemSearchResults_results_ContentBlock | PressReleaseSearchQuery_search_ItemSearchResults_results_ContentBlockFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_ContentToken | PressReleaseSearchQuery_search_ItemSearchResults_results_ContentTokenFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_ContentType | PressReleaseSearchQuery_search_ItemSearchResults_results_CorporateTheme | PressReleaseSearchQuery_search_ItemSearchResults_results_CorporateThemesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_Country | PressReleaseSearchQuery_search_ItemSearchResults_results_CountryISOCode | PressReleaseSearchQuery_search_ItemSearchResults_results_CountryISOCodesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_CustomerReviewFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_CustomerReviewTile | PressReleaseSearchQuery_search_ItemSearchResults_results_CustomerReviewTileParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_DataBridgeDocumentCategoryMap | PressReleaseSearchQuery_search_ItemSearchResults_results_DataBridgeFund | PressReleaseSearchQuery_search_ItemSearchResults_results_DataBridgeFundRangeName | PressReleaseSearchQuery_search_ItemSearchResults_results_DataBridgeSettingsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_DataBridgeShareClass | PressReleaseSearchQuery_search_ItemSearchResults_results_DataFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_DatasourceConfiguration | PressReleaseSearchQuery_search_ItemSearchResults_results_DatasourceConfigurations | PressReleaseSearchQuery_search_ItemSearchResults_results_DatasourceWorkflowAction | PressReleaseSearchQuery_search_ItemSearchResults_results_DateFacet | PressReleaseSearchQuery_search_ItemSearchResults_results_DateFilter | PressReleaseSearchQuery_search_ItemSearchResults_results_DateFilterFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_DateFilter_ad89c1f1e99148ef865938ab13aa28f1 | PressReleaseSearchQuery_search_ItemSearchResults_results_DefaultColumnLayout | PressReleaseSearchQuery_search_ItemSearchResults_results_DefaultShareclassMapping | PressReleaseSearchQuery_search_ItemSearchResults_results_DefaultShareclassMappings | PressReleaseSearchQuery_search_ItemSearchResults_results_DescriptiveHighlight | PressReleaseSearchQuery_search_ItemSearchResults_results_DescriptiveHighlightFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_DescriptiveHighlightItem | PressReleaseSearchQuery_search_ItemSearchResults_results_DescriptiveHighlightParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_Device | PressReleaseSearchQuery_search_ItemSearchResults_results_Device_7c27ec70f42e40428a0fabaa2f8eda18 | PressReleaseSearchQuery_search_ItemSearchResults_results_Devices | PressReleaseSearchQuery_search_ItemSearchResults_results_DictionaryFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_DisqusParameters | PressReleaseSearchQuery_search_ItemSearchResults_results_DistanceFacet | PressReleaseSearchQuery_search_ItemSearchResults_results_Divider | PressReleaseSearchQuery_search_ItemSearchResults_results_DocumentItem | PressReleaseSearchQuery_search_ItemSearchResults_results_DocumentListings | PressReleaseSearchQuery_search_ItemSearchResults_results_DocumentListingsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_DocumentTypeFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_DominantLanguageMapping | PressReleaseSearchQuery_search_ItemSearchResults_results_Dropdown | PressReleaseSearchQuery_search_ItemSearchResults_results_DropdownFilter | PressReleaseSearchQuery_search_ItemSearchResults_results_DropdownFilterFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_DropdownFilter_790c0f2c16214604a6c672b9f8ae830d | PressReleaseSearchQuery_search_ItemSearchResults_results_EditEditingTheme | PressReleaseSearchQuery_search_ItemSearchResults_results_EditFrame | PressReleaseSearchQuery_search_ItemSearchResults_results_EditModePanel | PressReleaseSearchQuery_search_ItemSearchResults_results_EditSiteItem | PressReleaseSearchQuery_search_ItemSearchResults_results_EditSiteItem_f040db0387fe4e10ae4053c63175e31b | PressReleaseSearchQuery_search_ItemSearchResults_results_EditSiteTheme | PressReleaseSearchQuery_search_ItemSearchResults_results_EditTenantTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3 | PressReleaseSearchQuery_search_ItemSearchResults_results_EditType | PressReleaseSearchQuery_search_ItemSearchResults_results_EloquaFormFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_EloquaFundForm | PressReleaseSearchQuery_search_ItemSearchResults_results_Enum | PressReleaseSearchQuery_search_ItemSearchResults_results_Enums | PressReleaseSearchQuery_search_ItemSearchResults_results_ErrorPage | PressReleaseSearchQuery_search_ItemSearchResults_results_ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171 | PressReleaseSearchQuery_search_ItemSearchResults_results_ErrorPage_4dbccce416d1491f94198496e3f77c6d | PressReleaseSearchQuery_search_ItemSearchResults_results_ErrorPage_45d797cc048740ffb693214883ff35c2 | PressReleaseSearchQuery_search_ItemSearchResults_results_ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9 | PressReleaseSearchQuery_search_ItemSearchResults_results_ErrorPage_a7dfa49761224679bf9949fffacd5fa1 | PressReleaseSearchQuery_search_ItemSearchResults_results_EventCalendarParameters | PressReleaseSearchQuery_search_ItemSearchResults_results_EventList | PressReleaseSearchQuery_search_ItemSearchResults_results_EventListParameters | PressReleaseSearchQuery_search_ItemSearchResults_results_EventTypes | PressReleaseSearchQuery_search_ItemSearchResults_results_EventsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_ExecuteScript | PressReleaseSearchQuery_search_ItemSearchResults_results_ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f | PressReleaseSearchQuery_search_ItemSearchResults_results_ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a | PressReleaseSearchQuery_search_ItemSearchResults_results_ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca | PressReleaseSearchQuery_search_ItemSearchResults_results_ExecuteScript_bc9bb68436df4285888bd8b4d87b10de | PressReleaseSearchQuery_search_ItemSearchResults_results_ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb | PressReleaseSearchQuery_search_ItemSearchResults_results_ExtendSiteTheme | PressReleaseSearchQuery_search_ItemSearchResults_results_ExternalLiterature | PressReleaseSearchQuery_search_ItemSearchResults_results_FEaaSWrapperRenderingParameters | PressReleaseSearchQuery_search_ItemSearchResults_results_FacebookCommentsParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_FacetSlider | PressReleaseSearchQuery_search_ItemSearchResults_results_FacetSliderFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_FacetSlider_995ce2c7319f478b84fe22053ac85bb7 | PressReleaseSearchQuery_search_ItemSearchResults_results_FacetSummary | PressReleaseSearchQuery_search_ItemSearchResults_results_FacetSummaryFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_FacetSummary_cd5c935c1f604d899a6b88ce28305cf2 | PressReleaseSearchQuery_search_ItemSearchResults_results_FacetsGrouping | PressReleaseSearchQuery_search_ItemSearchResults_results_FakeNavigationItem | PressReleaseSearchQuery_search_ItemSearchResults_results_FeatureBanner | PressReleaseSearchQuery_search_ItemSearchResults_results_FeatureBannerParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_FeaturedArticles | PressReleaseSearchQuery_search_ItemSearchResults_results_FeaturedArticlesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_FeaturedTheme | PressReleaseSearchQuery_search_ItemSearchResults_results_FeaturedThemesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_Feed | PressReleaseSearchQuery_search_ItemSearchResults_results_FeedFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_FeedParameters | PressReleaseSearchQuery_search_ItemSearchResults_results_FieldEditor | PressReleaseSearchQuery_search_ItemSearchResults_results_FieldRenderer | PressReleaseSearchQuery_search_ItemSearchResults_results_FileList | PressReleaseSearchQuery_search_ItemSearchResults_results_FileListFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_FileListParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_File_04129321770849c1801baee196e1c0a8 | PressReleaseSearchQuery_search_ItemSearchResults_results_FilterCriteria | PressReleaseSearchQuery_search_ItemSearchResults_results_FilterCriteriaFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_FilterTaxonomyOption | PressReleaseSearchQuery_search_ItemSearchResults_results_FilterTaxonomyOptions | PressReleaseSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage | PressReleaseSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d | PressReleaseSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941 | PressReleaseSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616 | PressReleaseSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9 | PressReleaseSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce | PressReleaseSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage | PressReleaseSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e | PressReleaseSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835 | PressReleaseSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2 | PressReleaseSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96 | PressReleaseSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260 | PressReleaseSearchQuery_search_ItemSearchResults_results_Flip | PressReleaseSearchQuery_search_ItemSearchResults_results_FlipFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_Flip_5ef078504c044b839dafefd752cfaba8 | PressReleaseSearchQuery_search_ItemSearchResults_results_Flipside | PressReleaseSearchQuery_search_ItemSearchResults_results_FloatFacet | PressReleaseSearchQuery_search_ItemSearchResults_results_Footer | PressReleaseSearchQuery_search_ItemSearchResults_results_FooterFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_FooterLink | PressReleaseSearchQuery_search_ItemSearchResults_results_FormRenderingParameters | PressReleaseSearchQuery_search_ItemSearchResults_results_FundAssetClass | PressReleaseSearchQuery_search_ItemSearchResults_results_FundAssetClassesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage | PressReleaseSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734 | PressReleaseSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f | PressReleaseSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b | PressReleaseSearchQuery_search_ItemSearchResults_results_FundFormsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_FundInFocus | PressReleaseSearchQuery_search_ItemSearchResults_results_FundInFocusShareClass | PressReleaseSearchQuery_search_ItemSearchResults_results_FundSearchPage | PressReleaseSearchQuery_search_ItemSearchResults_results_FundSearchPage_5505b84dba1f47c7b8054749d802d926 | PressReleaseSearchQuery_search_ItemSearchResults_results_FundSearchPage_5806f83c03bc443380678ff955f4310f | PressReleaseSearchQuery_search_ItemSearchResults_results_FundSearchPage_7432205c04214a419ca064c4cb37501c | PressReleaseSearchQuery_search_ItemSearchResults_results_FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a | PressReleaseSearchQuery_search_ItemSearchResults_results_FundSettings | PressReleaseSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage | PressReleaseSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c | PressReleaseSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3 | PressReleaseSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc | PressReleaseSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee | PressReleaseSearchQuery_search_ItemSearchResults_results_FundSubAssetClass | PressReleaseSearchQuery_search_ItemSearchResults_results_FundSubAssetClassesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_FundsExternalLiteratureFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_FundsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_FundsInFocusFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_FundsInFocusParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_FundsLiteratureFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_FundsLiteratureMappingsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_Gallery | PressReleaseSearchQuery_search_ItemSearchResults_results_GalleryFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_GalleryImage | PressReleaseSearchQuery_search_ItemSearchResults_results_GalleryParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_GalleryVideo | PressReleaseSearchQuery_search_ItemSearchResults_results_GatedAccordionContainer | PressReleaseSearchQuery_search_ItemSearchResults_results_GlobalLanguageSelector | PressReleaseSearchQuery_search_ItemSearchResults_results_GlobalNavigationBar | PressReleaseSearchQuery_search_ItemSearchResults_results_GoogleAnalytics | PressReleaseSearchQuery_search_ItemSearchResults_results_GoogleTagManager | PressReleaseSearchQuery_search_ItemSearchResults_results_GoogleTagManagerFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_GridSetup | PressReleaseSearchQuery_search_ItemSearchResults_results_GridTheme | PressReleaseSearchQuery_search_ItemSearchResults_results_HTMLCode | PressReleaseSearchQuery_search_ItemSearchResults_results_HTMLCodeFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_HTMLInclude | PressReleaseSearchQuery_search_ItemSearchResults_results_HTMLIncludesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_HTMLSnippet | PressReleaseSearchQuery_search_ItemSearchResults_results_HTMLSnippetFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_HTMLTag | PressReleaseSearchQuery_search_ItemSearchResults_results_Header | PressReleaseSearchQuery_search_ItemSearchResults_results_HeaderFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_Heading | PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessSiteSetupRoot | PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessSite_00d050988bad49e5b65db1e08b03ca1b | PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1 | PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessSite_8ca001453c4b4715959d8a05292ecbc5 | PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessSite_68ffa40c5aab45548f774742b163f318 | PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessSite_89d464c8c03e4b0287e9a878d95d7149 | PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessSite_229484893ca144958b9937167dfb5064 | PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessSite_b28055626acc45a2913a9617398c9730 | PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessSite_f1cab1661abb450d84d55d938e7699cb | PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessSite_f3884baa0e1548f59a6d7154a4559604 | PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessSolutionTemplateFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessTenantSetupRoot | PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessTenant_07248c4700af499eb2a9cb7789f72372 | PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8 | PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessTenant_5d72df6049c74324969205b55767ad7b | PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3 | PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessTenant_77a403a2094e48afafa60943d349d23d | PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2 | PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessTenant_94824ac390d748499e5af0275d10811f | PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessTenant_4797571864fd40929cf2412c39757ec3 | PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107 | PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessTrustSite | PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessVariants | PressReleaseSearchQuery_search_ItemSearchResults_results_HeadlessVariantsGrouping | PressReleaseSearchQuery_search_ItemSearchResults_results_HelpArticlePage | PressReleaseSearchQuery_search_ItemSearchResults_results_HelpArticlePlatform | PressReleaseSearchQuery_search_ItemSearchResults_results_HelpArticlePlatformMap | PressReleaseSearchQuery_search_ItemSearchResults_results_HelpArticlePlatformMappings | PressReleaseSearchQuery_search_ItemSearchResults_results_HelpArticlePlatformsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_HelpArticleSearchPage | PressReleaseSearchQuery_search_ItemSearchResults_results_HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77 | PressReleaseSearchQuery_search_ItemSearchResults_results_HelpArticleTag | PressReleaseSearchQuery_search_ItemSearchResults_results_HelpArticleTagsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_HelpArticleWildcardPage | PressReleaseSearchQuery_search_ItemSearchResults_results_HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4 | PressReleaseSearchQuery_search_ItemSearchResults_results_HelpArticlesGroupFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_HelpTagMap | PressReleaseSearchQuery_search_ItemSearchResults_results_HelpTagMappings | PressReleaseSearchQuery_search_ItemSearchResults_results_HeroBanner | PressReleaseSearchQuery_search_ItemSearchResults_results_Highlight | PressReleaseSearchQuery_search_ItemSearchResults_results_HighlightBlock | PressReleaseSearchQuery_search_ItemSearchResults_results_HighlightBlockFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_HighlightBlockParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_HighlightFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_HighlightItem | PressReleaseSearchQuery_search_ItemSearchResults_results_HighlightParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_Home | PressReleaseSearchQuery_search_ItemSearchResults_results_HomePage | PressReleaseSearchQuery_search_ItemSearchResults_results_HomePage_0d3963a8171d4080b5f808618578b631 | PressReleaseSearchQuery_search_ItemSearchResults_results_HomePage_6d95c7d946c74a70be07304cc73a2010 | PressReleaseSearchQuery_search_ItemSearchResults_results_HomePage_b407f259b4e34c7db9a06e8907a56b17 | PressReleaseSearchQuery_search_ItemSearchResults_results_HomePage_cde13c51062d426b95569e8202edc963 | PressReleaseSearchQuery_search_ItemSearchResults_results_HomePage_de9353283a3e41c495ba386aed0540c6 | PressReleaseSearchQuery_search_ItemSearchResults_results_IFrame | PressReleaseSearchQuery_search_ItemSearchResults_results_IFrameFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2 | PressReleaseSearchQuery_search_ItemSearchResults_results_IFrameParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_IFrame_0da12d476de24dfeb4d0f513489bfea1 | PressReleaseSearchQuery_search_ItemSearchResults_results_IFrame_88a6f65f2b78491bb3770b06e48883e1 | PressReleaseSearchQuery_search_ItemSearchResults_results_Icon | PressReleaseSearchQuery_search_ItemSearchResults_results_IconFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_Image | PressReleaseSearchQuery_search_ItemSearchResults_results_ImageFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_ImageFolder_edc00e86cef24d0cbfa264460becc323 | PressReleaseSearchQuery_search_ItemSearchResults_results_ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993 | PressReleaseSearchQuery_search_ItemSearchResults_results_ImageParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_Image_83bc563c6320490092f8204bff81586a | PressReleaseSearchQuery_search_ItemSearchResults_results_Image_15185b0e641844499f934ff03b7ee032 | PressReleaseSearchQuery_search_ItemSearchResults_results_Image_d885df8cb2d64007b34b2bbafb527304 | PressReleaseSearchQuery_search_ItemSearchResults_results_Infographics | PressReleaseSearchQuery_search_ItemSearchResults_results_InfographicsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_InputValidationStep | PressReleaseSearchQuery_search_ItemSearchResults_results_InputValidationStep_088928cf558e40ec87f3342aa9e66757 | PressReleaseSearchQuery_search_ItemSearchResults_results_InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593 | PressReleaseSearchQuery_search_ItemSearchResults_results_InputValidationStep_d028fef2babf4ad1bbe74d62a977992f | PressReleaseSearchQuery_search_ItemSearchResults_results_IntegerFacet | PressReleaseSearchQuery_search_ItemSearchResults_results_IntroCopy | PressReleaseSearchQuery_search_ItemSearchResults_results_IntroCopyFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_InvestmentTrustAssetClass | PressReleaseSearchQuery_search_ItemSearchResults_results_InvestmentTrustAssetClassFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73 | PressReleaseSearchQuery_search_ItemSearchResults_results_InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb | PressReleaseSearchQuery_search_ItemSearchResults_results_InvestmentTrustRegion | PressReleaseSearchQuery_search_ItemSearchResults_results_InvestmentTrustRegionFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_InvestmentTrustStyle | PressReleaseSearchQuery_search_ItemSearchResults_results_InvestmentTrustStyleFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_InvestorType | PressReleaseSearchQuery_search_ItemSearchResults_results_InvestorTypesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_ItemQueriesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_ItemRights | PressReleaseSearchQuery_search_ItemSearchResults_results_JSBeaconSettings | PressReleaseSearchQuery_search_ItemSearchResults_results_JSONCheckbox | PressReleaseSearchQuery_search_ItemSearchResults_results_JSONContent | PressReleaseSearchQuery_search_ItemSearchResults_results_JSONDate | PressReleaseSearchQuery_search_ItemSearchResults_results_JSONFile | PressReleaseSearchQuery_search_ItemSearchResults_results_JSONImage | PressReleaseSearchQuery_search_ItemSearchResults_results_JSONLayout | PressReleaseSearchQuery_search_ItemSearchResults_results_JSONList | PressReleaseSearchQuery_search_ItemSearchResults_results_JSONMultilistReference | PressReleaseSearchQuery_search_ItemSearchResults_results_JSONPlaceholder | PressReleaseSearchQuery_search_ItemSearchResults_results_JSONQuery | PressReleaseSearchQuery_search_ItemSearchResults_results_JSONResults | PressReleaseSearchQuery_search_ItemSearchResults_results_JSONRichText | PressReleaseSearchQuery_search_ItemSearchResults_results_JSONScriban | PressReleaseSearchQuery_search_ItemSearchResults_results_JSONSection | PressReleaseSearchQuery_search_ItemSearchResults_results_JSONTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_JSONText | PressReleaseSearchQuery_search_ItemSearchResults_results_JSONToken | PressReleaseSearchQuery_search_ItemSearchResults_results_JSONVariantDefinition | PressReleaseSearchQuery_search_ItemSearchResults_results_JSONVariants | PressReleaseSearchQuery_search_ItemSearchResults_results_JSSLayout | PressReleaseSearchQuery_search_ItemSearchResults_results_JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0 | PressReleaseSearchQuery_search_ItemSearchResults_results_JSSSettings_6b328292f8314ab79885d89a054ca10a | PressReleaseSearchQuery_search_ItemSearchResults_results_JSSSettings_457c9d0b61b84adfaf7f82561ed275ff | PressReleaseSearchQuery_search_ItemSearchResults_results_JSSSettings_5045bf85d2ea430b9f41c2e348436e5d | PressReleaseSearchQuery_search_ItemSearchResults_results_JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5 | PressReleaseSearchQuery_search_ItemSearchResults_results_JSSSettings_b001fd725bb1476496825a8cb9e995cd | PressReleaseSearchQuery_search_ItemSearchResults_results_JSSSettings_c643bc8630d14d61a173c7870f5dbbad | PressReleaseSearchQuery_search_ItemSearchResults_results_JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2 | PressReleaseSearchQuery_search_ItemSearchResults_results_JSSSettings_ef855d0ba8b04a8e87851d1298266d90 | PressReleaseSearchQuery_search_ItemSearchResults_results_JSSSiteGrouping | PressReleaseSearchQuery_search_ItemSearchResults_results_JSSTenantFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_JavaScriptRendering | PressReleaseSearchQuery_search_ItemSearchResults_results_JsonRendering | PressReleaseSearchQuery_search_ItemSearchResults_results_JurisdictionStatus | PressReleaseSearchQuery_search_ItemSearchResults_results_JurisdictionsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_KeyHighlightItem | PressReleaseSearchQuery_search_ItemSearchResults_results_KeyHighlights | PressReleaseSearchQuery_search_ItemSearchResults_results_KeyHighlightsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_KeyHighlightsParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_Language | PressReleaseSearchQuery_search_ItemSearchResults_results_LanguageSelector | PressReleaseSearchQuery_search_ItemSearchResults_results_LanguagesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_LatestPressReleasesParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_LayoutServiceVariants | PressReleaseSearchQuery_search_ItemSearchResults_results_LimitedDisplayFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_LimitedDisplayOption | PressReleaseSearchQuery_search_ItemSearchResults_results_Link | PressReleaseSearchQuery_search_ItemSearchResults_results_LinkList | PressReleaseSearchQuery_search_ItemSearchResults_results_LinkListFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_LinkListFolder_c237d144647a4afeaa7b1570f3e3f139 | PressReleaseSearchQuery_search_ItemSearchResults_results_LinkList_33c9207e3b0446068ef54ca99a97c776 | PressReleaseSearchQuery_search_ItemSearchResults_results_LinkList_97a593ad273141dc80bfceb5ef6a33b7 | PressReleaseSearchQuery_search_ItemSearchResults_results_LinkList_f7561ffcc0d8477fb53d2703a4060be1 | PressReleaseSearchQuery_search_ItemSearchResults_results_Link_68bd1cb5a7624a969ac6cb16ab5882a3 | PressReleaseSearchQuery_search_ItemSearchResults_results_Link_930f134d56784b35bfd1b77f9d0115f1 | PressReleaseSearchQuery_search_ItemSearchResults_results_Link_e24e0789a05848bfabb6c69c0e60b6b7 | PressReleaseSearchQuery_search_ItemSearchResults_results_LinksFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_List | PressReleaseSearchQuery_search_ItemSearchResults_results_ListFacet | PressReleaseSearchQuery_search_ItemSearchResults_results_ListFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_ListItem | PressReleaseSearchQuery_search_ItemSearchResults_results_ListParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_ListStyle | PressReleaseSearchQuery_search_ItemSearchResults_results_ListStyleItem | PressReleaseSearchQuery_search_ItemSearchResults_results_ListingHeroBanner | PressReleaseSearchQuery_search_ItemSearchResults_results_ListingHeroParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_LiteratureAuthorization | PressReleaseSearchQuery_search_ItemSearchResults_results_LiteratureAuthorizationsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage | PressReleaseSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d | PressReleaseSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e | PressReleaseSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea | PressReleaseSearchQuery_search_ItemSearchResults_results_LoadMore | PressReleaseSearchQuery_search_ItemSearchResults_results_LoadMoreFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_LoadMore_7a3a53e06a0144ff8ba52be46e201fe6 | PressReleaseSearchQuery_search_ItemSearchResults_results_LocationFilter | PressReleaseSearchQuery_search_ItemSearchResults_results_LocationFilterFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_LocationFilter_aaad4aad290744dc90b69e4e83a661ec | PressReleaseSearchQuery_search_ItemSearchResults_results_Log | PressReleaseSearchQuery_search_ItemSearchResults_results_Login | PressReleaseSearchQuery_search_ItemSearchResults_results_Login_abed54dc4f7840ddac562289c9c849d8 | PressReleaseSearchQuery_search_ItemSearchResults_results_LogoTextBlockItem | PressReleaseSearchQuery_search_ItemSearchResults_results_LogoTextBlocks | PressReleaseSearchQuery_search_ItemSearchResults_results_LogoTextBlocksFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_Logout | PressReleaseSearchQuery_search_ItemSearchResults_results_Logout_c2294d8235a6452a94b15eb5e543b602 | PressReleaseSearchQuery_search_ItemSearchResults_results_ManagedRangeFilter | PressReleaseSearchQuery_search_ItemSearchResults_results_ManagedRangeFilterFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91 | PressReleaseSearchQuery_search_ItemSearchResults_results_ManagedRangeItem | PressReleaseSearchQuery_search_ItemSearchResults_results_Map | PressReleaseSearchQuery_search_ItemSearchResults_results_MapParameters | PressReleaseSearchQuery_search_ItemSearchResults_results_MapsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_MapsProvider | PressReleaseSearchQuery_search_ItemSearchResults_results_MediaBlock | PressReleaseSearchQuery_search_ItemSearchResults_results_MediaBlockFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_MediaBlockParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_MediaFolder_81150e5837f5443fa3c075e14a9321e7 | PressReleaseSearchQuery_search_ItemSearchResults_results_MediaLinkParameters | PressReleaseSearchQuery_search_ItemSearchResults_results_MediaVirtualFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_MegaNavigation | PressReleaseSearchQuery_search_ItemSearchResults_results_MegaNavigationFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_MetaBranding | PressReleaseSearchQuery_search_ItemSearchResults_results_MetaRenderingParameters | PressReleaseSearchQuery_search_ItemSearchResults_results_MetadataPartialDesign | PressReleaseSearchQuery_search_ItemSearchResults_results_Model | PressReleaseSearchQuery_search_ItemSearchResults_results_ModelIterator | PressReleaseSearchQuery_search_ItemSearchResults_results_MyLocationPOI | PressReleaseSearchQuery_search_ItemSearchResults_results_Navigation | PressReleaseSearchQuery_search_ItemSearchResults_results_NavigationCategory | PressReleaseSearchQuery_search_ItemSearchResults_results_NavigationFilter | PressReleaseSearchQuery_search_ItemSearchResults_results_NavigationFilterFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_NavigationLink | PressReleaseSearchQuery_search_ItemSearchResults_results_NavigationSubcategory | PressReleaseSearchQuery_search_ItemSearchResults_results_Navigation_9ce34bf95c934dff841d8f649c2bd6c8 | PressReleaseSearchQuery_search_ItemSearchResults_results_OneTrustSettings | PressReleaseSearchQuery_search_ItemSearchResults_results_OptimiserConfiguration | PressReleaseSearchQuery_search_ItemSearchResults_results_OptimiserConfigurationSection | PressReleaseSearchQuery_search_ItemSearchResults_results_OptimizedFile | PressReleaseSearchQuery_search_ItemSearchResults_results_OracleCDPSettings | PressReleaseSearchQuery_search_ItemSearchResults_results_OverlayContent | PressReleaseSearchQuery_search_ItemSearchResults_results_OverlayFolderTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_Ownership | PressReleaseSearchQuery_search_ItemSearchResults_results_OwnershipFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_POI | PressReleaseSearchQuery_search_ItemSearchResults_results_POIFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_POIType | PressReleaseSearchQuery_search_ItemSearchResults_results_POIs | PressReleaseSearchQuery_search_ItemSearchResults_results_PageBranchesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_PageContent | PressReleaseSearchQuery_search_ItemSearchResults_results_PageContentFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_PageContent_ef87e73bc7ff49a2ac599b0be83755c3 | PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesign | PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0 | PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesignFolder_27d4f8be63b045769a4ef3163c935b47 | PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8 | PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b | PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesignFolder_720d01f11e5046fa9c4a697f9321f662 | PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesignFolder_771a0de7e83f44338c5d78727ead93bc | PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesignFolder_14161ec204984aa7a2a46decadf669f5 | PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb | PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesignFolder_d84605f786ea482da6ff683f6572821c | PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesign_1105b8f81e00426bbf1fc840742d827b | PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesigns | PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesigns_3af52e70e982424b9c85e355542500c9 | PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesigns_9b34083e890b467d8e76b8c3dbbb712d | PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesigns_48d2d50a150c4f6283603a4fed5646e0 | PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesigns_99a71bba507746729c3fb29b04abee23 | PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesigns_a0f265b42d6241968b65d3ede7cb59c3 | PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesigns_abe5ce6a82ff4433b4973bc50f192e11 | PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesigns_b8d9b352c1694b31bd506848b47ca884 | PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesigns_d3b2e1466f744df0900bec314f699ef3 | PressReleaseSearchQuery_search_ItemSearchResults_results_PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe | PressReleaseSearchQuery_search_ItemSearchResults_results_PageLevelTabs | PressReleaseSearchQuery_search_ItemSearchResults_results_PageLevelTabsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_PageList | PressReleaseSearchQuery_search_ItemSearchResults_results_PageSelector | PressReleaseSearchQuery_search_ItemSearchResults_results_PageSelectorConfiguration | PressReleaseSearchQuery_search_ItemSearchResults_results_PageSelectorFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_PageSelector_59a7bb775f8c435ab810291abde80e63 | PressReleaseSearchQuery_search_ItemSearchResults_results_PageSize | PressReleaseSearchQuery_search_ItemSearchResults_results_PageSizeFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_PageSize_b682562e0af64b3e9e3b45273bbe152d | PressReleaseSearchQuery_search_ItemSearchResults_results_PageTheme | PressReleaseSearchQuery_search_ItemSearchResults_results_PageThemesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_Page_4f49a81db3664f198b89cab92f377d7a | PressReleaseSearchQuery_search_ItemSearchResults_results_Page_5e66d86353544fe6a27d3b894984d50f | PressReleaseSearchQuery_search_ItemSearchResults_results_Page_84f342ad2d0646b9aa9a818201145ca2 | PressReleaseSearchQuery_search_ItemSearchResults_results_Page_718df200be51463d93edf4d77ab7a49e | PressReleaseSearchQuery_search_ItemSearchResults_results_Page_b61d5babe46f4ef39f27b57c4ccefdf7 | PressReleaseSearchQuery_search_ItemSearchResults_results_Page_cfd6e04697e24f3cb9eb41b79afc35dc | PressReleaseSearchQuery_search_ItemSearchResults_results_Page_dae7821153e14dbabb0ddf0b53a90aaf | PressReleaseSearchQuery_search_ItemSearchResults_results_Page_fa608b3e6aeb426388a059d89caabada | PressReleaseSearchQuery_search_ItemSearchResults_results_Pagging | PressReleaseSearchQuery_search_ItemSearchResults_results_Pagination | PressReleaseSearchQuery_search_ItemSearchResults_results_PaginationFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_Paragraph | PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_8cf20a4412b746ee801218122c955b2d | PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b | PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8 | PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b | PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_828b5ff144cd4150bcdfe54084165112 | PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_89098e3089aa4062a77346d608caac90 | PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_1695576fb93647d7842ed17730278c32 | PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc | PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a | PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesign_fd2059fd60434dfe8c04e2437ce87634 | PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesigns | PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesigns_043d3ad0ac4445dba03afc3550d088ec | PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesigns_0310a4bf20d1441c886a0418c53e30f4 | PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesigns_36c869ded22040929ce829f6ed643c66 | PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesigns_1943dc73710a430895515a342c84b037 | PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesigns_b1e2a6790a1442d8bafa66317b8be117 | PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e | PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesigns_d52704ed3b704a53abb4292105f687ad | PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesigns_d216303f58d8425688da8cd30d00afab | PressReleaseSearchQuery_search_ItemSearchResults_results_PartialDesigns_facda26791204fa9a0363344348f2c42 | PressReleaseSearchQuery_search_ItemSearchResults_results_PerformanceChartSettings | PressReleaseSearchQuery_search_ItemSearchResults_results_PerformanceChartTimePeriod | PressReleaseSearchQuery_search_ItemSearchResults_results_PerformanceChartTimePeriodFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80 | PressReleaseSearchQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d | PressReleaseSearchQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba | PressReleaseSearchQuery_search_ItemSearchResults_results_Placeholder_1ca0304be5b64810821154426f1752c2 | PressReleaseSearchQuery_search_ItemSearchResults_results_Placeholder_d2a6884c04d54089a64ed27ca9d68d4c | PressReleaseSearchQuery_search_ItemSearchResults_results_PlainHtmlParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_Playlist | PressReleaseSearchQuery_search_ItemSearchResults_results_PlaylistFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_PlaylistParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_Podcast | PressReleaseSearchQuery_search_ItemSearchResults_results_PodcastFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_PodcastPage | PressReleaseSearchQuery_search_ItemSearchResults_results_PodcastPressReleasePage | PressReleaseSearchQuery_search_ItemSearchResults_results_PoiTypes | PressReleaseSearchQuery_search_ItemSearchResults_results_PostDeleteStep | PressReleaseSearchQuery_search_ItemSearchResults_results_PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574 | PressReleaseSearchQuery_search_ItemSearchResults_results_PostDeleteStep_78d6ec9b66e34763987003cf314ee37a | PressReleaseSearchQuery_search_ItemSearchResults_results_PostDeleteStep_b20857895385413883f096f3767cb156 | PressReleaseSearchQuery_search_ItemSearchResults_results_PostSetupStep | PressReleaseSearchQuery_search_ItemSearchResults_results_PostSetupStep_6fac654e22154a419a1d59197bebc0fe | PressReleaseSearchQuery_search_ItemSearchResults_results_PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f | PressReleaseSearchQuery_search_ItemSearchResults_results_PostSetupStep_341738aa44fe490e90ff7010a3c2463b | PressReleaseSearchQuery_search_ItemSearchResults_results_PreDeleteStep | PressReleaseSearchQuery_search_ItemSearchResults_results_PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49 | PressReleaseSearchQuery_search_ItemSearchResults_results_PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b | PressReleaseSearchQuery_search_ItemSearchResults_results_PreDeleteStep_f0daf401190f45468bda8568d08e161d | PressReleaseSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep | PressReleaseSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f | PressReleaseSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f | PressReleaseSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e | PressReleaseSearchQuery_search_ItemSearchResults_results_Presentation | PressReleaseSearchQuery_search_ItemSearchResults_results_Presentation_0a70fa7389234a6eabf34134f25f3221 | PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseContentType | PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseContentTypesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseFilter | PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleasePage | PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleasePlatform | PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleasePlatformsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage | PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f | PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72 | PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d | PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58 | PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage | PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e | PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79 | PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1 | PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258 | PressReleaseSearchQuery_search_ItemSearchResults_results_PressReleasesGroupFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_PrivacyWarning | PressReleaseSearchQuery_search_ItemSearchResults_results_ProjectFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_Promo | PressReleaseSearchQuery_search_ItemSearchResults_results_PromoFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_PromoFolder_f07cbe8973ae4de692172570260cac6e | PressReleaseSearchQuery_search_ItemSearchResults_results_Promo_7f21f14d096b4f27bbccf115c6e6f6f1 | PressReleaseSearchQuery_search_ItemSearchResults_results_Promo_881869ca7f5845ea8b34ad1bfd3551a8 | PressReleaseSearchQuery_search_ItemSearchResults_results_Promo_dfed4457d760457abec1c0dccdc44381 | PressReleaseSearchQuery_search_ItemSearchResults_results_PromotedContent | PressReleaseSearchQuery_search_ItemSearchResults_results_PromotedContentFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_PropertyListingCard | PressReleaseSearchQuery_search_ItemSearchResults_results_PropertyListingCards | PressReleaseSearchQuery_search_ItemSearchResults_results_PropertyListingCategory | PressReleaseSearchQuery_search_ItemSearchResults_results_PropertyListingFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_Query_98b413525a4b4067b92418a4b50f0a53 | PressReleaseSearchQuery_search_ItemSearchResults_results_QuickLinks | PressReleaseSearchQuery_search_ItemSearchResults_results_QuickLinksFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_QuickLinksParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_QuotationBlockItem | PressReleaseSearchQuery_search_ItemSearchResults_results_QuotationBlocks | PressReleaseSearchQuery_search_ItemSearchResults_results_QuotationBlocksFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_QuotationBlocksParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_Quote | PressReleaseSearchQuery_search_ItemSearchResults_results_QuoteFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_QuoteParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_RadiusFilter | PressReleaseSearchQuery_search_ItemSearchResults_results_RadiusFilterFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64 | PressReleaseSearchQuery_search_ItemSearchResults_results_RadiusScheme | PressReleaseSearchQuery_search_ItemSearchResults_results_RadiusSchemeValue | PressReleaseSearchQuery_search_ItemSearchResults_results_RangeSliderFilter | PressReleaseSearchQuery_search_ItemSearchResults_results_RangeSliderFilterFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_RangeSliderFilter_0a1787c296b54d40828522564a5d8e03 | PressReleaseSearchQuery_search_ItemSearchResults_results_RecentArticles | PressReleaseSearchQuery_search_ItemSearchResults_results_Redirect | PressReleaseSearchQuery_search_ItemSearchResults_results_RedirectMap | PressReleaseSearchQuery_search_ItemSearchResults_results_RedirectMaps | PressReleaseSearchQuery_search_ItemSearchResults_results_Region | PressReleaseSearchQuery_search_ItemSearchResults_results_RegionLanguages | PressReleaseSearchQuery_search_ItemSearchResults_results_RegionLanguagesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_RelatedArticles | PressReleaseSearchQuery_search_ItemSearchResults_results_RelatedArticlesParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_RenderEngineType | PressReleaseSearchQuery_search_ItemSearchResults_results_RenderingFolder_840d4a46550349ecbf9dbd090946c63d | PressReleaseSearchQuery_search_ItemSearchResults_results_RenderingHost | PressReleaseSearchQuery_search_ItemSearchResults_results_ResizableIFramePage | PressReleaseSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067 | PressReleaseSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68 | PressReleaseSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_b58eacfb27f5417bb536141f94b92521 | PressReleaseSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401 | PressReleaseSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_f460ab055585441892023750e7cef6b7 | PressReleaseSearchQuery_search_ItemSearchResults_results_ResponsiveImage | PressReleaseSearchQuery_search_ItemSearchResults_results_ResultsCount | PressReleaseSearchQuery_search_ItemSearchResults_results_ResultsCountFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186 | PressReleaseSearchQuery_search_ItemSearchResults_results_ResultsVariantSelector | PressReleaseSearchQuery_search_ItemSearchResults_results_RichText | PressReleaseSearchQuery_search_ItemSearchResults_results_RichTextFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_RichText_0f3b73366112418c8bbab0526f3887ce | PressReleaseSearchQuery_search_ItemSearchResults_results_RichText_efcfd8f6596745f48f85b5421928205d | PressReleaseSearchQuery_search_ItemSearchResults_results_RiskImageMapping | PressReleaseSearchQuery_search_ItemSearchResults_results_RiskImageMappings | PressReleaseSearchQuery_search_ItemSearchResults_results_RiskLevelOption | PressReleaseSearchQuery_search_ItemSearchResults_results_RiskLevelOptionFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_RiskWarning | PressReleaseSearchQuery_search_ItemSearchResults_results_RiskWarningFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_RiskWarningParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_RolePlaceholder | PressReleaseSearchQuery_search_ItemSearchResults_results_RowSplitter | PressReleaseSearchQuery_search_ItemSearchResults_results_RowSplitter_340c887da1d1415b9678c763af74ea97 | PressReleaseSearchQuery_search_ItemSearchResults_results_Rule | PressReleaseSearchQuery_search_ItemSearchResults_results_SDRLogoMapping | PressReleaseSearchQuery_search_ItemSearchResults_results_SDRLogoMappings | PressReleaseSearchQuery_search_ItemSearchResults_results_SDRTypeOption | PressReleaseSearchQuery_search_ItemSearchResults_results_SDRTypeOptionFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_SXAJSSLayout | PressReleaseSearchQuery_search_ItemSearchResults_results_SXARole | PressReleaseSearchQuery_search_ItemSearchResults_results_SXAStandardValuesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceAlertMessage | PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceCheckBox | PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceCheckBoxType | PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButton | PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButtons | PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceDateInput | PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceDropdown | PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceDropdownOption | PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceHiddenField | PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceInput | PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceInputType | PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceIntegratedForm | PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceIntegratedFormTypesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceRepeatableSubSection | PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceRichTextArea | PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceSection | PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceSortCodeInput | PressReleaseSearchQuery_search_ItemSearchResults_results_SalesforceSubmissionType | PressReleaseSearchQuery_search_ItemSearchResults_results_Scope | PressReleaseSearchQuery_search_ItemSearchResults_results_ScopesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_Scriban | PressReleaseSearchQuery_search_ItemSearchResults_results_Scripts | PressReleaseSearchQuery_search_ItemSearchResults_results_SearchBox | PressReleaseSearchQuery_search_ItemSearchResults_results_SearchBoxFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_SearchBox_1c04fd611d874590acfe9cc186865ab3 | PressReleaseSearchQuery_search_ItemSearchResults_results_SearchFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_SearchResults | PressReleaseSearchQuery_search_ItemSearchResults_results_SearchResultsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_SearchResults_a06f7130041d46bb8c2995a2dc00c26a | PressReleaseSearchQuery_search_ItemSearchResults_results_SecondaryHeroBannerParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_SectionHeading | PressReleaseSearchQuery_search_ItemSearchResults_results_SectionHeadingFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_SectionHeadingParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_SectionHeadingType | PressReleaseSearchQuery_search_ItemSearchResults_results_SectionHeadingTypeFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_SectionSelector | PressReleaseSearchQuery_search_ItemSearchResults_results_SectionSelectorFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_SectionSelectorTab | PressReleaseSearchQuery_search_ItemSearchResults_results_Security_33077d51ebad4d1cb4a83b79f51dba13 | PressReleaseSearchQuery_search_ItemSearchResults_results_Series | PressReleaseSearchQuery_search_ItemSearchResults_results_SeriesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_Settings | PressReleaseSearchQuery_search_ItemSearchResults_results_SettingsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_Settings_6c82caca67dc464195698faad083230e | PressReleaseSearchQuery_search_ItemSearchResults_results_SharePriceSettings | PressReleaseSearchQuery_search_ItemSearchResults_results_SharedArticlesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_SharedContentFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_SharedFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_SharedHelpArticlesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_SharedPressReleasesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_SharedSettingsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_SharedSitesSettings | PressReleaseSearchQuery_search_ItemSearchResults_results_SharedSitesSettings_c14bf746030f4e598594395f6d299e61 | PressReleaseSearchQuery_search_ItemSearchResults_results_Showcase | PressReleaseSearchQuery_search_ItemSearchResults_results_ShowcaseFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_ShowcaseItem | PressReleaseSearchQuery_search_ItemSearchResults_results_ShowcaseParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_Site | PressReleaseSearchQuery_search_ItemSearchResults_results_SiteContentFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_SiteDefinition | PressReleaseSearchQuery_search_ItemSearchResults_results_SiteEntryDisclaimer | PressReleaseSearchQuery_search_ItemSearchResults_results_SiteFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_SiteGrouping | PressReleaseSearchQuery_search_ItemSearchResults_results_SiteManagement | PressReleaseSearchQuery_search_ItemSearchResults_results_SiteSecurityItemPointer | PressReleaseSearchQuery_search_ItemSearchResults_results_SiteSelector | PressReleaseSearchQuery_search_ItemSearchResults_results_SiteSelector_a44632f56dcd4d10b4892f4e35e193c3 | PressReleaseSearchQuery_search_ItemSearchResults_results_SiteSetupRoot | PressReleaseSearchQuery_search_ItemSearchResults_results_SiteTheme | PressReleaseSearchQuery_search_ItemSearchResults_results_Site_e46f3af239fa4866a1577017c4b2a40c | PressReleaseSearchQuery_search_ItemSearchResults_results_SitecoreFormWrapperParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_SitecoreRole | PressReleaseSearchQuery_search_ItemSearchResults_results_SitemapSettings_c71d856635c849b7a84d9d176e9cbd05 | PressReleaseSearchQuery_search_ItemSearchResults_results_SkipLink | PressReleaseSearchQuery_search_ItemSearchResults_results_SkipLinkParameters | PressReleaseSearchQuery_search_ItemSearchResults_results_SkipLinksFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_Snippet | PressReleaseSearchQuery_search_ItemSearchResults_results_SnippetItem | PressReleaseSearchQuery_search_ItemSearchResults_results_SnippetsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_SocialLoginWrapper | PressReleaseSearchQuery_search_ItemSearchResults_results_SocialMediaButtons | PressReleaseSearchQuery_search_ItemSearchResults_results_SocialMediaFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_SocialMediaShare | PressReleaseSearchQuery_search_ItemSearchResults_results_SocialMediaTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_SocialNetwork | PressReleaseSearchQuery_search_ItemSearchResults_results_SocialNetworkFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_SocialNetworkLink | PressReleaseSearchQuery_search_ItemSearchResults_results_SolutionTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_SortResults | PressReleaseSearchQuery_search_ItemSearchResults_results_SortResultsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_Sorting | PressReleaseSearchQuery_search_ItemSearchResults_results_SortingGroups | PressReleaseSearchQuery_search_ItemSearchResults_results_SpotifyPodcast | PressReleaseSearchQuery_search_ItemSearchResults_results_SpotifyPodcastFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_StickyCTA | PressReleaseSearchQuery_search_ItemSearchResults_results_StickyCTAFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_StickyCTAParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_StrategiesInFocusFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_StrategyInFocus | PressReleaseSearchQuery_search_ItemSearchResults_results_Style | PressReleaseSearchQuery_search_ItemSearchResults_results_Styles | PressReleaseSearchQuery_search_ItemSearchResults_results_Styles_9c0dac2808aa4b44bc2153363206f6a5 | PressReleaseSearchQuery_search_ItemSearchResults_results_SubscriptionBannerParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_Tab | PressReleaseSearchQuery_search_ItemSearchResults_results_TabItem | PressReleaseSearchQuery_search_ItemSearchResults_results_TableOfContents | PressReleaseSearchQuery_search_ItemSearchResults_results_TableOfContentsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_TableOfContentsSection | PressReleaseSearchQuery_search_ItemSearchResults_results_TableOfContentsSubsection | PressReleaseSearchQuery_search_ItemSearchResults_results_Tabs | PressReleaseSearchQuery_search_ItemSearchResults_results_TabsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_Tabs_f26a9560ccf148c59542800e837caf7a | PressReleaseSearchQuery_search_ItemSearchResults_results_Tag | PressReleaseSearchQuery_search_ItemSearchResults_results_TagCloud | PressReleaseSearchQuery_search_ItemSearchResults_results_TagFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_TagList | PressReleaseSearchQuery_search_ItemSearchResults_results_TeamBiographySettings | PressReleaseSearchQuery_search_ItemSearchResults_results_TeamListingCards | PressReleaseSearchQuery_search_ItemSearchResults_results_TeamListingCardsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMember | PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMemberCard | PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembers | PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage | PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e | PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e | PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_47f304d629a84648a0e2b942513133ff | PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089 | PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0 | PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage | PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e | PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450 | PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a | PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29 | PressReleaseSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745 | PressReleaseSearchQuery_search_ItemSearchResults_results_TeamProfileCards | PressReleaseSearchQuery_search_ItemSearchResults_results_TeamProfileCardsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_TechzoneArticlePage | PressReleaseSearchQuery_search_ItemSearchResults_results_Tenant | PressReleaseSearchQuery_search_ItemSearchResults_results_TenantFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_TenantSecurityItemPointer | PressReleaseSearchQuery_search_ItemSearchResults_results_TenantSetupRoot | PressReleaseSearchQuery_search_ItemSearchResults_results_TertieryHeroBanner | PressReleaseSearchQuery_search_ItemSearchResults_results_TertieryHeroBannerParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_Text | PressReleaseSearchQuery_search_ItemSearchResults_results_TextBlock | PressReleaseSearchQuery_search_ItemSearchResults_results_TextBlockHeadingParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_TextBlockHeadingType | PressReleaseSearchQuery_search_ItemSearchResults_results_TextBlockHeadingTypeFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_TextBlockLinkType | PressReleaseSearchQuery_search_ItemSearchResults_results_TextBlockLinkTypeFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_TextBlocks | PressReleaseSearchQuery_search_ItemSearchResults_results_TextBlocksFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_TextBlocksParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_TextFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_TextFolder_b762d56787f5493cbb480c455d834457 | PressReleaseSearchQuery_search_ItemSearchResults_results_Text_b8f5894cb4934016bf784090b0a2fd16 | PressReleaseSearchQuery_search_ItemSearchResults_results_Theme | PressReleaseSearchQuery_search_ItemSearchResults_results_ThemeTag | PressReleaseSearchQuery_search_ItemSearchResults_results_ThemeTagsFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_ThemingMode | PressReleaseSearchQuery_search_ItemSearchResults_results_ThemingModes | PressReleaseSearchQuery_search_ItemSearchResults_results_Tile | PressReleaseSearchQuery_search_ItemSearchResults_results_TileLink | PressReleaseSearchQuery_search_ItemSearchResults_results_TileParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_TileSizeOption | PressReleaseSearchQuery_search_ItemSearchResults_results_TileSizeOptionFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_TilesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_TilesParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_Title | PressReleaseSearchQuery_search_ItemSearchResults_results_Title_a82e893105754175917de904ef7e6dbe | PressReleaseSearchQuery_search_ItemSearchResults_results_Toggle | PressReleaseSearchQuery_search_ItemSearchResults_results_ToggleFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_Toggle_8e4c968e9fa543a89ac4c0baf273ccde | PressReleaseSearchQuery_search_ItemSearchResults_results_Transformation | PressReleaseSearchQuery_search_ItemSearchResults_results_TrustArticleHeroParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_TrustFinder | PressReleaseSearchQuery_search_ItemSearchResults_results_TrustFinderFilterOption | PressReleaseSearchQuery_search_ItemSearchResults_results_TrustRegion | PressReleaseSearchQuery_search_ItemSearchResults_results_TrustType | PressReleaseSearchQuery_search_ItemSearchResults_results_TrustTypesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_Twitter | PressReleaseSearchQuery_search_ItemSearchResults_results_TwitterApp | PressReleaseSearchQuery_search_ItemSearchResults_results_TwitterApps | PressReleaseSearchQuery_search_ItemSearchResults_results_TwitterFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_TwitterParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_TwitterSettings | PressReleaseSearchQuery_search_ItemSearchResults_results_UnknownItem | PressReleaseSearchQuery_search_ItemSearchResults_results_UnminifiedFile | PressReleaseSearchQuery_search_ItemSearchResults_results_UpgradeScript | PressReleaseSearchQuery_search_ItemSearchResults_results_UpgradeScriptLibrary | PressReleaseSearchQuery_search_ItemSearchResults_results_VariantComponentField | PressReleaseSearchQuery_search_ItemSearchResults_results_VariantDateField | PressReleaseSearchQuery_search_ItemSearchResults_results_VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55 | PressReleaseSearchQuery_search_ItemSearchResults_results_VariantPlaceholder | PressReleaseSearchQuery_search_ItemSearchResults_results_VariantReference | PressReleaseSearchQuery_search_ItemSearchResults_results_VariantSection | PressReleaseSearchQuery_search_ItemSearchResults_results_VariantTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_VariantText | PressReleaseSearchQuery_search_ItemSearchResults_results_VariantToken | PressReleaseSearchQuery_search_ItemSearchResults_results_Variants | PressReleaseSearchQuery_search_ItemSearchResults_results_VectorFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_VectorTile | PressReleaseSearchQuery_search_ItemSearchResults_results_VectorTileLink | PressReleaseSearchQuery_search_ItemSearchResults_results_VectorTilesFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_VectorTilesParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_Version_95ebc23204774dc38ad3465d5fe8da2f | PressReleaseSearchQuery_search_ItemSearchResults_results_Video | PressReleaseSearchQuery_search_ItemSearchResults_results_VideoCountOption | PressReleaseSearchQuery_search_ItemSearchResults_results_VideoCountOptions | PressReleaseSearchQuery_search_ItemSearchResults_results_VideoFolder | PressReleaseSearchQuery_search_ItemSearchResults_results_VideoFolder_bba49474673e468186ba8b1a20e067a9 | PressReleaseSearchQuery_search_ItemSearchResults_results_VideoPage | PressReleaseSearchQuery_search_ItemSearchResults_results_VideoParameters | PressReleaseSearchQuery_search_ItemSearchResults_results_VideoParametersTemplate | PressReleaseSearchQuery_search_ItemSearchResults_results_VideoPressReleasePage | PressReleaseSearchQuery_search_ItemSearchResults_results_Video_4bc649610a894242be2dc5026090cf49 | PressReleaseSearchQuery_search_ItemSearchResults_results__AssetsOptimization | PressReleaseSearchQuery_search_ItemSearchResults_results__BackgroundImage | PressReleaseSearchQuery_search_ItemSearchResults_results__CompatibleThemes | PressReleaseSearchQuery_search_ItemSearchResults_results__CompositeTheme | PressReleaseSearchQuery_search_ItemSearchResults_results__CustomMetadata | PressReleaseSearchQuery_search_ItemSearchResults_results__CustomRenderingViewPath | PressReleaseSearchQuery_search_ItemSearchResults_results__DatasourceBehaviour | PressReleaseSearchQuery_search_ItemSearchResults_results__Favicon | PressReleaseSearchQuery_search_ItemSearchResults_results__FormsFolderLocation | PressReleaseSearchQuery_search_ItemSearchResults_results__FundSettings | PressReleaseSearchQuery_search_ItemSearchResults_results__HasValidUrlName | PressReleaseSearchQuery_search_ItemSearchResults_results__LocalDataLink | PressReleaseSearchQuery_search_ItemSearchResults_results__Login | PressReleaseSearchQuery_search_ItemSearchResults_results__OpenGraphMetadata | PressReleaseSearchQuery_search_ItemSearchResults_results__PageDesignTheme | PressReleaseSearchQuery_search_ItemSearchResults_results__PageSearchScope | PressReleaseSearchQuery_search_ItemSearchResults_results__SearchCriteria | PressReleaseSearchQuery_search_ItemSearchResults_results__SearchableWithoutRelatedItems | PressReleaseSearchQuery_search_ItemSearchResults_results__SeoMetadata | PressReleaseSearchQuery_search_ItemSearchResults_results__SiteTheme | PressReleaseSearchQuery_search_ItemSearchResults_results__SitemapSettings | PressReleaseSearchQuery_search_ItemSearchResults_results__StickyNote | PressReleaseSearchQuery_search_ItemSearchResults_results__Styleable | PressReleaseSearchQuery_search_ItemSearchResults_results__TwitterMetadata | PressReleaseSearchQuery_search_ItemSearchResults_results__Webinar | PressReleaseSearchQuery_search_ItemSearchResults_results__WildcardSource;

export type PressReleaseSearchQuery_search_ItemSearchResults = (
  { __typename?: 'ItemSearchResults' }
  & Pick<Types.ItemSearchResults, 'total'>
  & { pageInfo: PressReleaseSearchQuery_search_ItemSearchResults_pageInfo_PageInfo, results: Array<Types.Maybe<PressReleaseSearchQuery_search_ItemSearchResults_results>> }
);

export type PressReleaseSearchQuery_Query = (
  { __typename?: 'Query' }
  & { search: Types.Maybe<PressReleaseSearchQuery_search_ItemSearchResults> }
);


export type PressReleaseSearchQueryVariables = Types.Exact<{
  pageSize: Types.Scalars['Int']['input'];
  pageHash: Types.InputMaybe<Types.Scalars['String']['input']>;
  pressReleaseName: Types.InputMaybe<Types.Scalars['String']['input']>;
  language: Types.InputMaybe<Types.Scalars['String']['input']>;
  siteId: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type PressReleaseSearchQuery = PressReleaseSearchQuery_Query;


export const PressReleaseSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PressReleaseSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageHash"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pressReleaseName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"AND"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_path","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"StringValue","value":"4E44BA879E0B4ABF8810F3C8B70117BD","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"CONTAINS"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_templates","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"StringValue","value":"94E1D50186424DCF9CEAA0EE86451733","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"CONTAINS"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_name","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pressReleaseName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"EQ"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_language","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"shareTo","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"CONTAINS"}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageHash"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNext"}}]}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rendered"}}]}}]}}]}}]} as unknown as DocumentNode<PressReleaseSearchQuery, PressReleaseSearchQueryVariables>;